// Grouped client for Otg operations
import { ApiConfiguration } from '../ApiConfiguration';
import { Form } from '../models/Form';
import { DataFormActionRequest } from '../models/DataFormActionRequest';
import { DataFormActionResponse } from '../models/DataFormActionResponse';
import { StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest } from '../models/StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest';
import { StartObjectAppointmentSendAppointmentConfirmationEmailRequest } from '../models/StartObjectAppointmentSendAppointmentConfirmationEmailRequest';
import { StartObjectAppointmentSendOmwsmsRequest } from '../models/StartObjectAppointmentSendOmwsmsRequest';
import { StartObjectAppointmentSendUpcomingAppointmentReminderRequest } from '../models/StartObjectAppointmentSendUpcomingAppointmentReminderRequest';
import { StartObjectAppointmentInitiateOmwsmsRequest } from '../models/StartObjectAppointmentInitiateOmwsmsRequest';
import { StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest } from '../models/StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest';
import { StartObjectAppointmentCancelAppointmentRequest } from '../models/StartObjectAppointmentCancelAppointmentRequest';
import { ObjectAppointment } from '../models/ObjectAppointment';
import { UpdateObjectAppointmentRequest } from '../models/UpdateObjectAppointmentRequest';
import { CreateObjectAppointmentRequest } from '../models/CreateObjectAppointmentRequest';
import { FilterObjectAppointmentRequest } from '../models/FilterObjectAppointmentRequest';
import { DataviewObjectAppointmentResponse } from '../models/DataviewObjectAppointmentResponse';
import { CarpetCatalogItem } from '../models/CarpetCatalogItem';
import { FilterCarpetCatalogItemRequest } from '../models/FilterCarpetCatalogItemRequest';
import { DataviewCarpetCatalogItemResponse } from '../models/DataviewCarpetCatalogItemResponse';
import { OtgCarpetCatalogStyle } from '../models/OtgCarpetCatalogStyle';
import { FilterOtgCarpetCatalogStyleRequest } from '../models/FilterOtgCarpetCatalogStyleRequest';
import { DataviewOtgCarpetCatalogStyleResponse } from '../models/DataviewOtgCarpetCatalogStyleResponse';
import { CatalogItem } from '../models/CatalogItem';
import { FilterCatalogItemRequest } from '../models/FilterCatalogItemRequest';
import { DataviewCatalogItemResponse } from '../models/DataviewCatalogItemResponse';
import { OtgCatalogManufacturer } from '../models/OtgCatalogManufacturer';
import { FilterOtgCatalogManufacturerRequest } from '../models/FilterOtgCatalogManufacturerRequest';
import { DataviewOtgCatalogManufacturerResponse } from '../models/DataviewOtgCatalogManufacturerResponse';
import { OtgCatalogStyle } from '../models/OtgCatalogStyle';
import { FilterOtgCatalogStyleRequest } from '../models/FilterOtgCatalogStyleRequest';
import { DataviewOtgCatalogStyleResponse } from '../models/DataviewOtgCatalogStyleResponse';
import { CeramicTileCatalogItem } from '../models/CeramicTileCatalogItem';
import { FilterCeramicTileCatalogItemRequest } from '../models/FilterCeramicTileCatalogItemRequest';
import { DataviewCeramicTileCatalogItemResponse } from '../models/DataviewCeramicTileCatalogItemResponse';
import { StartCompanyAddNoteRequest } from '../models/StartCompanyAddNoteRequest';
import { StartCompanyAddTaskRequest } from '../models/StartCompanyAddTaskRequest';
import { StartCompanyAddAppointmentRequest } from '../models/StartCompanyAddAppointmentRequest';
import { StartCompanyAskSyntheaRequest } from '../models/StartCompanyAskSyntheaRequest';
import { Company } from '../models/Company';
import { UpdateCompanyRequest } from '../models/UpdateCompanyRequest';
import { CreateCompanyRequest } from '../models/CreateCompanyRequest';
import { FilterCompanyRequest } from '../models/FilterCompanyRequest';
import { DataviewCompanyResponse } from '../models/DataviewCompanyResponse';
import { StartContactAddNoteRequest } from '../models/StartContactAddNoteRequest';
import { StartContactAddTaskRequest } from '../models/StartContactAddTaskRequest';
import { StartContactAddAppointmentRequest } from '../models/StartContactAddAppointmentRequest';
import { StartContactAskSyntheaRequest } from '../models/StartContactAskSyntheaRequest';
import { Contact } from '../models/Contact';
import { UpdateContactRequest } from '../models/UpdateContactRequest';
import { CreateContactRequest } from '../models/CreateContactRequest';
import { FilterContactRequest } from '../models/FilterContactRequest';
import { DataviewContactResponse } from '../models/DataviewContactResponse';
import { StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest } from '../models/StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest';
import { StartContactAppointmentSendAppointmentConfirmationEmailRequest } from '../models/StartContactAppointmentSendAppointmentConfirmationEmailRequest';
import { StartContactAppointmentSendOmwsmsRequest } from '../models/StartContactAppointmentSendOmwsmsRequest';
import { StartContactAppointmentSendUpcomingAppointmentReminderRequest } from '../models/StartContactAppointmentSendUpcomingAppointmentReminderRequest';
import { StartContactAppointmentInitiateOmwsmsRequest } from '../models/StartContactAppointmentInitiateOmwsmsRequest';
import { StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest } from '../models/StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest';
import { StartContactAppointmentCancelAppointmentRequest } from '../models/StartContactAppointmentCancelAppointmentRequest';
import { ContactAppointment } from '../models/ContactAppointment';
import { UpdateContactAppointmentRequest } from '../models/UpdateContactAppointmentRequest';
import { CreateContactAppointmentRequest } from '../models/CreateContactAppointmentRequest';
import { ContactAppointmentFields } from '../models/ContactAppointmentFields';
import { FilterContactAppointmentRequest } from '../models/FilterContactAppointmentRequest';
import { DataviewContactAppointmentResponse } from '../models/DataviewContactAppointmentResponse';
import { StartContactAssignmentAskSyntheaRequest } from '../models/StartContactAssignmentAskSyntheaRequest';
import { ContactAssignment } from '../models/ContactAssignment';
import { UpdateContactAssignmentRequest } from '../models/UpdateContactAssignmentRequest';
import { ContactAssignmentFields } from '../models/ContactAssignmentFields';
import { FilterContactAssignmentRequest } from '../models/FilterContactAssignmentRequest';
import { DataviewContactAssignmentResponse } from '../models/DataviewContactAssignmentResponse';
import { ContactNote } from '../models/ContactNote';
import { UpdateContactNoteRequest } from '../models/UpdateContactNoteRequest';
import { CreateContactNoteRequest } from '../models/CreateContactNoteRequest';
import { FilterContactNoteRequest } from '../models/FilterContactNoteRequest';
import { DataviewContactNoteResponse } from '../models/DataviewContactNoteResponse';
import { ContactTask } from '../models/ContactTask';
import { UpdateContactTaskRequest } from '../models/UpdateContactTaskRequest';
import { CreateContactTaskRequest } from '../models/CreateContactTaskRequest';
import { FilterContactTaskRequest } from '../models/FilterContactTaskRequest';
import { DataviewContactTaskResponse } from '../models/DataviewContactTaskResponse';
import { StartEstimateAskSyntheaRequest } from '../models/StartEstimateAskSyntheaRequest';
import { StartEstimateAddLineItemRequest } from '../models/StartEstimateAddLineItemRequest';
import { StartEstimateSwitchItemRequest } from '../models/StartEstimateSwitchItemRequest';
import { StartEstimateRemoveItemRequest } from '../models/StartEstimateRemoveItemRequest';
import { StartEstimateEditItemRequest } from '../models/StartEstimateEditItemRequest';
import { StartEstimateAddFreightRequest } from '../models/StartEstimateAddFreightRequest';
import { StartEstimateSetDiscountRequest } from '../models/StartEstimateSetDiscountRequest';
import { StartEstimateAddSectionRequest } from '../models/StartEstimateAddSectionRequest';
import { StartEstimateRemoveSectionRequest } from '../models/StartEstimateRemoveSectionRequest';
import { StartEstimateEditSectionRequest } from '../models/StartEstimateEditSectionRequest';
import { StartEstimateSignProposalRequest } from '../models/StartEstimateSignProposalRequest';
import { StartEstimateRequestSignatureRequest } from '../models/StartEstimateRequestSignatureRequest';
import { Estimate } from '../models/Estimate';
import { UpdateEstimateRequest } from '../models/UpdateEstimateRequest';
import { CreateEstimateRequest } from '../models/CreateEstimateRequest';
import { FilterEstimateRequest } from '../models/FilterEstimateRequest';
import { DataviewEstimateResponse } from '../models/DataviewEstimateResponse';
import { StartIndividualContactAddNoteRequest } from '../models/StartIndividualContactAddNoteRequest';
import { StartIndividualContactAddTaskRequest } from '../models/StartIndividualContactAddTaskRequest';
import { StartIndividualContactAddAppointmentRequest } from '../models/StartIndividualContactAddAppointmentRequest';
import { StartIndividualContactAskSyntheaRequest } from '../models/StartIndividualContactAskSyntheaRequest';
import { IndividualContact } from '../models/IndividualContact';
import { UpdateIndividualContactRequest } from '../models/UpdateIndividualContactRequest';
import { CreateIndividualContactRequest } from '../models/CreateIndividualContactRequest';
import { FilterIndividualContactRequest } from '../models/FilterIndividualContactRequest';
import { DataviewIndividualContactResponse } from '../models/DataviewIndividualContactResponse';
import { LaminatesCatalogItem } from '../models/LaminatesCatalogItem';
import { FilterLaminatesCatalogItemRequest } from '../models/FilterLaminatesCatalogItemRequest';
import { DataviewLaminatesCatalogItemResponse } from '../models/DataviewLaminatesCatalogItemResponse';
import { OtgLaminatesCatalogStyle } from '../models/OtgLaminatesCatalogStyle';
import { FilterOtgLaminatesCatalogStyleRequest } from '../models/FilterOtgLaminatesCatalogStyleRequest';
import { DataviewOtgLaminatesCatalogStyleResponse } from '../models/DataviewOtgLaminatesCatalogStyleResponse';
import { StartLeadEditNextAppointmentRequest } from '../models/StartLeadEditNextAppointmentRequest';
import { StartLeadTakeSnapshotRequest } from '../models/StartLeadTakeSnapshotRequest';
import { StartLeadQueueEmailCampaignRequest } from '../models/StartLeadQueueEmailCampaignRequest';
import { StartLeadSendOmwsmsRequest } from '../models/StartLeadSendOmwsmsRequest';
import { StartLeadSendRememberMeSmsRequest } from '../models/StartLeadSendRememberMeSmsRequest';
import { StartLeadSendCustomEmailRequest } from '../models/StartLeadSendCustomEmailRequest';
import { StartLeadCreateTaskRequest } from '../models/StartLeadCreateTaskRequest';
import { StartLeadStartZappRequest } from '../models/StartLeadStartZappRequest';
import { StartLeadAddAppointmentRequest } from '../models/StartLeadAddAppointmentRequest';
import { Lead } from '../models/Lead';
import { UpdateLeadRequest } from '../models/UpdateLeadRequest';
import { CreateLeadRequest } from '../models/CreateLeadRequest';
import { FilterLeadRequest } from '../models/FilterLeadRequest';
import { DataviewLeadResponse } from '../models/DataviewLeadResponse';
import { StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest } from '../models/StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest';
import { StartLeadAppointmentSendAppointmentConfirmationEmailRequest } from '../models/StartLeadAppointmentSendAppointmentConfirmationEmailRequest';
import { StartLeadAppointmentSendOmwsmsRequest } from '../models/StartLeadAppointmentSendOmwsmsRequest';
import { StartLeadAppointmentSendUpcomingAppointmentReminderRequest } from '../models/StartLeadAppointmentSendUpcomingAppointmentReminderRequest';
import { StartLeadAppointmentInitiateOmwsmsRequest } from '../models/StartLeadAppointmentInitiateOmwsmsRequest';
import { StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest } from '../models/StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest';
import { StartLeadAppointmentCancelAppointmentRequest } from '../models/StartLeadAppointmentCancelAppointmentRequest';
import { LeadAppointment } from '../models/LeadAppointment';
import { FilterLeadAppointmentRequest } from '../models/FilterLeadAppointmentRequest';
import { DataviewLeadAppointmentResponse } from '../models/DataviewLeadAppointmentResponse';
import { LeadNote } from '../models/LeadNote';
import { UpdateLeadNoteRequest } from '../models/UpdateLeadNoteRequest';
import { CreateLeadNoteRequest } from '../models/CreateLeadNoteRequest';
import { FilterLeadNoteRequest } from '../models/FilterLeadNoteRequest';
import { DataviewLeadNoteResponse } from '../models/DataviewLeadNoteResponse';
import { Note } from '../models/Note';
import { UpdateNoteRequest } from '../models/UpdateNoteRequest';
import { FilterNoteRequest } from '../models/FilterNoteRequest';
import { DataviewNoteResponse } from '../models/DataviewNoteResponse';
import { StartObjectFileAskSyntheaRequest } from '../models/StartObjectFileAskSyntheaRequest';
import { ObjectFile } from '../models/ObjectFile';
import { FilterObjectFileRequest } from '../models/FilterObjectFileRequest';
import { DataviewObjectFileResponse } from '../models/DataviewObjectFileResponse';
import { StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest } from '../models/StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest';
import { StartProjectAppointmentSendAppointmentConfirmationEmailRequest } from '../models/StartProjectAppointmentSendAppointmentConfirmationEmailRequest';
import { StartProjectAppointmentSendOmwsmsRequest } from '../models/StartProjectAppointmentSendOmwsmsRequest';
import { StartProjectAppointmentSendUpcomingAppointmentReminderRequest } from '../models/StartProjectAppointmentSendUpcomingAppointmentReminderRequest';
import { StartProjectAppointmentInitiateOmwsmsRequest } from '../models/StartProjectAppointmentInitiateOmwsmsRequest';
import { StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest } from '../models/StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest';
import { StartProjectAppointmentCancelAppointmentRequest } from '../models/StartProjectAppointmentCancelAppointmentRequest';
import { ProjectAppointment } from '../models/ProjectAppointment';
import { FilterProjectAppointmentRequest } from '../models/FilterProjectAppointmentRequest';
import { DataviewProjectAppointmentResponse } from '../models/DataviewProjectAppointmentResponse';
import { ProjectNote } from '../models/ProjectNote';
import { UpdateProjectNoteRequest } from '../models/UpdateProjectNoteRequest';
import { CreateProjectNoteRequest } from '../models/CreateProjectNoteRequest';
import { FilterProjectNoteRequest } from '../models/FilterProjectNoteRequest';
import { DataviewProjectNoteResponse } from '../models/DataviewProjectNoteResponse';
import { ProjectSelection } from '../models/ProjectSelection';
import { UpdateProjectSelectionRequest } from '../models/UpdateProjectSelectionRequest';
import { CreateProjectSelectionRequest } from '../models/CreateProjectSelectionRequest';
import { ProjectSelectionFields } from '../models/ProjectSelectionFields';
import { FilterProjectSelectionRequest } from '../models/FilterProjectSelectionRequest';
import { DataviewProjectSelectionResponse } from '../models/DataviewProjectSelectionResponse';
import { ProjectTask } from '../models/ProjectTask';
import { UpdateProjectTaskRequest } from '../models/UpdateProjectTaskRequest';
import { CreateProjectTaskRequest } from '../models/CreateProjectTaskRequest';
import { FilterProjectTaskRequest } from '../models/FilterProjectTaskRequest';
import { DataviewProjectTaskResponse } from '../models/DataviewProjectTaskResponse';
import { StartRoomPhotoFileAskSyntheaRequest } from '../models/StartRoomPhotoFileAskSyntheaRequest';
import { RoomPhotoFile } from '../models/RoomPhotoFile';
import { FilterRoomPhotoFileRequest } from '../models/FilterRoomPhotoFileRequest';
import { DataviewRoomPhotoFileResponse } from '../models/DataviewRoomPhotoFileResponse';
import { StartRoomSelectionAddLineItemRequest } from '../models/StartRoomSelectionAddLineItemRequest';
import { StartRoomSelectionSwitchItemRequest } from '../models/StartRoomSelectionSwitchItemRequest';
import { StartRoomSelectionRemoveItemRequest } from '../models/StartRoomSelectionRemoveItemRequest';
import { StartRoomSelectionEditItemRequest } from '../models/StartRoomSelectionEditItemRequest';
import { StartRoomSelectionAddFreightRequest } from '../models/StartRoomSelectionAddFreightRequest';
import { RoomSelection } from '../models/RoomSelection';
import { UpdateRoomSelectionRequest } from '../models/UpdateRoomSelectionRequest';
import { CreateRoomSelectionRequest } from '../models/CreateRoomSelectionRequest';
import { FilterRoomSelectionRequest } from '../models/FilterRoomSelectionRequest';
import { DataviewRoomSelectionResponse } from '../models/DataviewRoomSelectionResponse';
import { ObjectTask } from '../models/ObjectTask';
import { UpdateObjectTaskRequest } from '../models/UpdateObjectTaskRequest';
import { CreateObjectTaskRequest } from '../models/CreateObjectTaskRequest';
import { ObjectTaskFields } from '../models/ObjectTaskFields';
import { FilterObjectTaskRequest } from '../models/FilterObjectTaskRequest';
import { DataviewObjectTaskResponse } from '../models/DataviewObjectTaskResponse';
import { StartOtgUserCreateFileRequest } from '../models/StartOtgUserCreateFileRequest';
import { OtgUser } from '../models/OtgUser';
import { FilterOtgUserRequest } from '../models/FilterOtgUserRequest';
import { DataviewOtgUserResponse } from '../models/DataviewOtgUserResponse';
import { VinylCatalogItem } from '../models/VinylCatalogItem';
import { FilterVinylCatalogItemRequest } from '../models/FilterVinylCatalogItemRequest';
import { DataviewVinylCatalogItemResponse } from '../models/DataviewVinylCatalogItemResponse';
import { OtgVinylCatalogStyle } from '../models/OtgVinylCatalogStyle';
import { FilterOtgVinylCatalogStyleRequest } from '../models/FilterOtgVinylCatalogStyleRequest';
import { DataviewOtgVinylCatalogStyleResponse } from '../models/DataviewOtgVinylCatalogStyleResponse';
import { WoodCatalogItem } from '../models/WoodCatalogItem';
import { FilterWoodCatalogItemRequest } from '../models/FilterWoodCatalogItemRequest';
import { DataviewWoodCatalogItemResponse } from '../models/DataviewWoodCatalogItemResponse';
import { OtgWoodCatalogStyle } from '../models/OtgWoodCatalogStyle';
import { FilterOtgWoodCatalogStyleRequest } from '../models/FilterOtgWoodCatalogStyleRequest';
import { DataviewOtgWoodCatalogStyleResponse } from '../models/DataviewOtgWoodCatalogStyleResponse';
import { FormSerializer } from '../serializers/FormSerializer';
import { DataFormActionRequestSerializer } from '../serializers/DataFormActionRequestSerializer';
import { DataFormActionResponseSerializer } from '../serializers/DataFormActionResponseSerializer';
import { StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer } from '../serializers/StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer';
import { StartObjectAppointmentSendAppointmentConfirmationEmailRequestSerializer } from '../serializers/StartObjectAppointmentSendAppointmentConfirmationEmailRequestSerializer';
import { StartObjectAppointmentSendOmwsmsRequestSerializer } from '../serializers/StartObjectAppointmentSendOmwsmsRequestSerializer';
import { StartObjectAppointmentSendUpcomingAppointmentReminderRequestSerializer } from '../serializers/StartObjectAppointmentSendUpcomingAppointmentReminderRequestSerializer';
import { StartObjectAppointmentInitiateOmwsmsRequestSerializer } from '../serializers/StartObjectAppointmentInitiateOmwsmsRequestSerializer';
import { StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer } from '../serializers/StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer';
import { StartObjectAppointmentCancelAppointmentRequestSerializer } from '../serializers/StartObjectAppointmentCancelAppointmentRequestSerializer';
import { ObjectAppointmentSerializer } from '../serializers/ObjectAppointmentSerializer';
import { UpdateObjectAppointmentRequestSerializer } from '../serializers/UpdateObjectAppointmentRequestSerializer';
import { CreateObjectAppointmentRequestSerializer } from '../serializers/CreateObjectAppointmentRequestSerializer';
import { FilterObjectAppointmentRequestSerializer } from '../serializers/FilterObjectAppointmentRequestSerializer';
import { DataviewObjectAppointmentResponseSerializer } from '../serializers/DataviewObjectAppointmentResponseSerializer';
import { CarpetCatalogItemSerializer } from '../serializers/CarpetCatalogItemSerializer';
import { FilterCarpetCatalogItemRequestSerializer } from '../serializers/FilterCarpetCatalogItemRequestSerializer';
import { DataviewCarpetCatalogItemResponseSerializer } from '../serializers/DataviewCarpetCatalogItemResponseSerializer';
import { OtgCarpetCatalogStyleSerializer } from '../serializers/OtgCarpetCatalogStyleSerializer';
import { FilterOtgCarpetCatalogStyleRequestSerializer } from '../serializers/FilterOtgCarpetCatalogStyleRequestSerializer';
import { DataviewOtgCarpetCatalogStyleResponseSerializer } from '../serializers/DataviewOtgCarpetCatalogStyleResponseSerializer';
import { CatalogItemSerializer } from '../serializers/CatalogItemSerializer';
import { FilterCatalogItemRequestSerializer } from '../serializers/FilterCatalogItemRequestSerializer';
import { DataviewCatalogItemResponseSerializer } from '../serializers/DataviewCatalogItemResponseSerializer';
import { OtgCatalogManufacturerSerializer } from '../serializers/OtgCatalogManufacturerSerializer';
import { FilterOtgCatalogManufacturerRequestSerializer } from '../serializers/FilterOtgCatalogManufacturerRequestSerializer';
import { DataviewOtgCatalogManufacturerResponseSerializer } from '../serializers/DataviewOtgCatalogManufacturerResponseSerializer';
import { OtgCatalogStyleSerializer } from '../serializers/OtgCatalogStyleSerializer';
import { FilterOtgCatalogStyleRequestSerializer } from '../serializers/FilterOtgCatalogStyleRequestSerializer';
import { DataviewOtgCatalogStyleResponseSerializer } from '../serializers/DataviewOtgCatalogStyleResponseSerializer';
import { CeramicTileCatalogItemSerializer } from '../serializers/CeramicTileCatalogItemSerializer';
import { FilterCeramicTileCatalogItemRequestSerializer } from '../serializers/FilterCeramicTileCatalogItemRequestSerializer';
import { DataviewCeramicTileCatalogItemResponseSerializer } from '../serializers/DataviewCeramicTileCatalogItemResponseSerializer';
import { StartCompanyAddNoteRequestSerializer } from '../serializers/StartCompanyAddNoteRequestSerializer';
import { StartCompanyAddTaskRequestSerializer } from '../serializers/StartCompanyAddTaskRequestSerializer';
import { StartCompanyAddAppointmentRequestSerializer } from '../serializers/StartCompanyAddAppointmentRequestSerializer';
import { StartCompanyAskSyntheaRequestSerializer } from '../serializers/StartCompanyAskSyntheaRequestSerializer';
import { CompanySerializer } from '../serializers/CompanySerializer';
import { UpdateCompanyRequestSerializer } from '../serializers/UpdateCompanyRequestSerializer';
import { CreateCompanyRequestSerializer } from '../serializers/CreateCompanyRequestSerializer';
import { FilterCompanyRequestSerializer } from '../serializers/FilterCompanyRequestSerializer';
import { DataviewCompanyResponseSerializer } from '../serializers/DataviewCompanyResponseSerializer';
import { StartContactAddNoteRequestSerializer } from '../serializers/StartContactAddNoteRequestSerializer';
import { StartContactAddTaskRequestSerializer } from '../serializers/StartContactAddTaskRequestSerializer';
import { StartContactAddAppointmentRequestSerializer } from '../serializers/StartContactAddAppointmentRequestSerializer';
import { StartContactAskSyntheaRequestSerializer } from '../serializers/StartContactAskSyntheaRequestSerializer';
import { ContactSerializer } from '../serializers/ContactSerializer';
import { UpdateContactRequestSerializer } from '../serializers/UpdateContactRequestSerializer';
import { CreateContactRequestSerializer } from '../serializers/CreateContactRequestSerializer';
import { FilterContactRequestSerializer } from '../serializers/FilterContactRequestSerializer';
import { DataviewContactResponseSerializer } from '../serializers/DataviewContactResponseSerializer';
import { StartContactAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer } from '../serializers/StartContactAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer';
import { StartContactAppointmentSendAppointmentConfirmationEmailRequestSerializer } from '../serializers/StartContactAppointmentSendAppointmentConfirmationEmailRequestSerializer';
import { StartContactAppointmentSendOmwsmsRequestSerializer } from '../serializers/StartContactAppointmentSendOmwsmsRequestSerializer';
import { StartContactAppointmentSendUpcomingAppointmentReminderRequestSerializer } from '../serializers/StartContactAppointmentSendUpcomingAppointmentReminderRequestSerializer';
import { StartContactAppointmentInitiateOmwsmsRequestSerializer } from '../serializers/StartContactAppointmentInitiateOmwsmsRequestSerializer';
import { StartContactAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer } from '../serializers/StartContactAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer';
import { StartContactAppointmentCancelAppointmentRequestSerializer } from '../serializers/StartContactAppointmentCancelAppointmentRequestSerializer';
import { ContactAppointmentSerializer } from '../serializers/ContactAppointmentSerializer';
import { UpdateContactAppointmentRequestSerializer } from '../serializers/UpdateContactAppointmentRequestSerializer';
import { CreateContactAppointmentRequestSerializer } from '../serializers/CreateContactAppointmentRequestSerializer';
import { FilterContactAppointmentRequestSerializer } from '../serializers/FilterContactAppointmentRequestSerializer';
import { DataviewContactAppointmentResponseSerializer } from '../serializers/DataviewContactAppointmentResponseSerializer';
import { StartContactAssignmentAskSyntheaRequestSerializer } from '../serializers/StartContactAssignmentAskSyntheaRequestSerializer';
import { ContactAssignmentSerializer } from '../serializers/ContactAssignmentSerializer';
import { UpdateContactAssignmentRequestSerializer } from '../serializers/UpdateContactAssignmentRequestSerializer';
import { FilterContactAssignmentRequestSerializer } from '../serializers/FilterContactAssignmentRequestSerializer';
import { DataviewContactAssignmentResponseSerializer } from '../serializers/DataviewContactAssignmentResponseSerializer';
import { ContactNoteSerializer } from '../serializers/ContactNoteSerializer';
import { UpdateContactNoteRequestSerializer } from '../serializers/UpdateContactNoteRequestSerializer';
import { CreateContactNoteRequestSerializer } from '../serializers/CreateContactNoteRequestSerializer';
import { FilterContactNoteRequestSerializer } from '../serializers/FilterContactNoteRequestSerializer';
import { DataviewContactNoteResponseSerializer } from '../serializers/DataviewContactNoteResponseSerializer';
import { ContactTaskSerializer } from '../serializers/ContactTaskSerializer';
import { UpdateContactTaskRequestSerializer } from '../serializers/UpdateContactTaskRequestSerializer';
import { CreateContactTaskRequestSerializer } from '../serializers/CreateContactTaskRequestSerializer';
import { FilterContactTaskRequestSerializer } from '../serializers/FilterContactTaskRequestSerializer';
import { DataviewContactTaskResponseSerializer } from '../serializers/DataviewContactTaskResponseSerializer';
import { StartEstimateAskSyntheaRequestSerializer } from '../serializers/StartEstimateAskSyntheaRequestSerializer';
import { StartEstimateAddLineItemRequestSerializer } from '../serializers/StartEstimateAddLineItemRequestSerializer';
import { StartEstimateSwitchItemRequestSerializer } from '../serializers/StartEstimateSwitchItemRequestSerializer';
import { StartEstimateRemoveItemRequestSerializer } from '../serializers/StartEstimateRemoveItemRequestSerializer';
import { StartEstimateEditItemRequestSerializer } from '../serializers/StartEstimateEditItemRequestSerializer';
import { StartEstimateAddFreightRequestSerializer } from '../serializers/StartEstimateAddFreightRequestSerializer';
import { StartEstimateSetDiscountRequestSerializer } from '../serializers/StartEstimateSetDiscountRequestSerializer';
import { StartEstimateAddSectionRequestSerializer } from '../serializers/StartEstimateAddSectionRequestSerializer';
import { StartEstimateRemoveSectionRequestSerializer } from '../serializers/StartEstimateRemoveSectionRequestSerializer';
import { StartEstimateEditSectionRequestSerializer } from '../serializers/StartEstimateEditSectionRequestSerializer';
import { StartEstimateSignProposalRequestSerializer } from '../serializers/StartEstimateSignProposalRequestSerializer';
import { StartEstimateRequestSignatureRequestSerializer } from '../serializers/StartEstimateRequestSignatureRequestSerializer';
import { EstimateSerializer } from '../serializers/EstimateSerializer';
import { UpdateEstimateRequestSerializer } from '../serializers/UpdateEstimateRequestSerializer';
import { CreateEstimateRequestSerializer } from '../serializers/CreateEstimateRequestSerializer';
import { FilterEstimateRequestSerializer } from '../serializers/FilterEstimateRequestSerializer';
import { DataviewEstimateResponseSerializer } from '../serializers/DataviewEstimateResponseSerializer';
import { StartIndividualContactAddNoteRequestSerializer } from '../serializers/StartIndividualContactAddNoteRequestSerializer';
import { StartIndividualContactAddTaskRequestSerializer } from '../serializers/StartIndividualContactAddTaskRequestSerializer';
import { StartIndividualContactAddAppointmentRequestSerializer } from '../serializers/StartIndividualContactAddAppointmentRequestSerializer';
import { StartIndividualContactAskSyntheaRequestSerializer } from '../serializers/StartIndividualContactAskSyntheaRequestSerializer';
import { IndividualContactSerializer } from '../serializers/IndividualContactSerializer';
import { UpdateIndividualContactRequestSerializer } from '../serializers/UpdateIndividualContactRequestSerializer';
import { CreateIndividualContactRequestSerializer } from '../serializers/CreateIndividualContactRequestSerializer';
import { FilterIndividualContactRequestSerializer } from '../serializers/FilterIndividualContactRequestSerializer';
import { DataviewIndividualContactResponseSerializer } from '../serializers/DataviewIndividualContactResponseSerializer';
import { LaminatesCatalogItemSerializer } from '../serializers/LaminatesCatalogItemSerializer';
import { FilterLaminatesCatalogItemRequestSerializer } from '../serializers/FilterLaminatesCatalogItemRequestSerializer';
import { DataviewLaminatesCatalogItemResponseSerializer } from '../serializers/DataviewLaminatesCatalogItemResponseSerializer';
import { OtgLaminatesCatalogStyleSerializer } from '../serializers/OtgLaminatesCatalogStyleSerializer';
import { FilterOtgLaminatesCatalogStyleRequestSerializer } from '../serializers/FilterOtgLaminatesCatalogStyleRequestSerializer';
import { DataviewOtgLaminatesCatalogStyleResponseSerializer } from '../serializers/DataviewOtgLaminatesCatalogStyleResponseSerializer';
import { StartLeadEditNextAppointmentRequestSerializer } from '../serializers/StartLeadEditNextAppointmentRequestSerializer';
import { StartLeadTakeSnapshotRequestSerializer } from '../serializers/StartLeadTakeSnapshotRequestSerializer';
import { StartLeadQueueEmailCampaignRequestSerializer } from '../serializers/StartLeadQueueEmailCampaignRequestSerializer';
import { StartLeadSendOmwsmsRequestSerializer } from '../serializers/StartLeadSendOmwsmsRequestSerializer';
import { StartLeadSendRememberMeSmsRequestSerializer } from '../serializers/StartLeadSendRememberMeSmsRequestSerializer';
import { StartLeadSendCustomEmailRequestSerializer } from '../serializers/StartLeadSendCustomEmailRequestSerializer';
import { StartLeadCreateTaskRequestSerializer } from '../serializers/StartLeadCreateTaskRequestSerializer';
import { StartLeadStartZappRequestSerializer } from '../serializers/StartLeadStartZappRequestSerializer';
import { StartLeadAddAppointmentRequestSerializer } from '../serializers/StartLeadAddAppointmentRequestSerializer';
import { LeadSerializer } from '../serializers/LeadSerializer';
import { UpdateLeadRequestSerializer } from '../serializers/UpdateLeadRequestSerializer';
import { CreateLeadRequestSerializer } from '../serializers/CreateLeadRequestSerializer';
import { FilterLeadRequestSerializer } from '../serializers/FilterLeadRequestSerializer';
import { DataviewLeadResponseSerializer } from '../serializers/DataviewLeadResponseSerializer';
import { StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer } from '../serializers/StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer';
import { StartLeadAppointmentSendAppointmentConfirmationEmailRequestSerializer } from '../serializers/StartLeadAppointmentSendAppointmentConfirmationEmailRequestSerializer';
import { StartLeadAppointmentSendOmwsmsRequestSerializer } from '../serializers/StartLeadAppointmentSendOmwsmsRequestSerializer';
import { StartLeadAppointmentSendUpcomingAppointmentReminderRequestSerializer } from '../serializers/StartLeadAppointmentSendUpcomingAppointmentReminderRequestSerializer';
import { StartLeadAppointmentInitiateOmwsmsRequestSerializer } from '../serializers/StartLeadAppointmentInitiateOmwsmsRequestSerializer';
import { StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer } from '../serializers/StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer';
import { StartLeadAppointmentCancelAppointmentRequestSerializer } from '../serializers/StartLeadAppointmentCancelAppointmentRequestSerializer';
import { LeadAppointmentSerializer } from '../serializers/LeadAppointmentSerializer';
import { FilterLeadAppointmentRequestSerializer } from '../serializers/FilterLeadAppointmentRequestSerializer';
import { DataviewLeadAppointmentResponseSerializer } from '../serializers/DataviewLeadAppointmentResponseSerializer';
import { LeadNoteSerializer } from '../serializers/LeadNoteSerializer';
import { UpdateLeadNoteRequestSerializer } from '../serializers/UpdateLeadNoteRequestSerializer';
import { CreateLeadNoteRequestSerializer } from '../serializers/CreateLeadNoteRequestSerializer';
import { FilterLeadNoteRequestSerializer } from '../serializers/FilterLeadNoteRequestSerializer';
import { DataviewLeadNoteResponseSerializer } from '../serializers/DataviewLeadNoteResponseSerializer';
import { NoteSerializer } from '../serializers/NoteSerializer';
import { UpdateNoteRequestSerializer } from '../serializers/UpdateNoteRequestSerializer';
import { FilterNoteRequestSerializer } from '../serializers/FilterNoteRequestSerializer';
import { DataviewNoteResponseSerializer } from '../serializers/DataviewNoteResponseSerializer';
import { StartObjectFileAskSyntheaRequestSerializer } from '../serializers/StartObjectFileAskSyntheaRequestSerializer';
import { ObjectFileSerializer } from '../serializers/ObjectFileSerializer';
import { FilterObjectFileRequestSerializer } from '../serializers/FilterObjectFileRequestSerializer';
import { DataviewObjectFileResponseSerializer } from '../serializers/DataviewObjectFileResponseSerializer';
import { StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer } from '../serializers/StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer';
import { StartProjectAppointmentSendAppointmentConfirmationEmailRequestSerializer } from '../serializers/StartProjectAppointmentSendAppointmentConfirmationEmailRequestSerializer';
import { StartProjectAppointmentSendOmwsmsRequestSerializer } from '../serializers/StartProjectAppointmentSendOmwsmsRequestSerializer';
import { StartProjectAppointmentSendUpcomingAppointmentReminderRequestSerializer } from '../serializers/StartProjectAppointmentSendUpcomingAppointmentReminderRequestSerializer';
import { StartProjectAppointmentInitiateOmwsmsRequestSerializer } from '../serializers/StartProjectAppointmentInitiateOmwsmsRequestSerializer';
import { StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer } from '../serializers/StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer';
import { StartProjectAppointmentCancelAppointmentRequestSerializer } from '../serializers/StartProjectAppointmentCancelAppointmentRequestSerializer';
import { ProjectAppointmentSerializer } from '../serializers/ProjectAppointmentSerializer';
import { FilterProjectAppointmentRequestSerializer } from '../serializers/FilterProjectAppointmentRequestSerializer';
import { DataviewProjectAppointmentResponseSerializer } from '../serializers/DataviewProjectAppointmentResponseSerializer';
import { ProjectNoteSerializer } from '../serializers/ProjectNoteSerializer';
import { UpdateProjectNoteRequestSerializer } from '../serializers/UpdateProjectNoteRequestSerializer';
import { CreateProjectNoteRequestSerializer } from '../serializers/CreateProjectNoteRequestSerializer';
import { FilterProjectNoteRequestSerializer } from '../serializers/FilterProjectNoteRequestSerializer';
import { DataviewProjectNoteResponseSerializer } from '../serializers/DataviewProjectNoteResponseSerializer';
import { ProjectSelectionSerializer } from '../serializers/ProjectSelectionSerializer';
import { UpdateProjectSelectionRequestSerializer } from '../serializers/UpdateProjectSelectionRequestSerializer';
import { CreateProjectSelectionRequestSerializer } from '../serializers/CreateProjectSelectionRequestSerializer';
import { FilterProjectSelectionRequestSerializer } from '../serializers/FilterProjectSelectionRequestSerializer';
import { DataviewProjectSelectionResponseSerializer } from '../serializers/DataviewProjectSelectionResponseSerializer';
import { ProjectTaskSerializer } from '../serializers/ProjectTaskSerializer';
import { UpdateProjectTaskRequestSerializer } from '../serializers/UpdateProjectTaskRequestSerializer';
import { CreateProjectTaskRequestSerializer } from '../serializers/CreateProjectTaskRequestSerializer';
import { FilterProjectTaskRequestSerializer } from '../serializers/FilterProjectTaskRequestSerializer';
import { DataviewProjectTaskResponseSerializer } from '../serializers/DataviewProjectTaskResponseSerializer';
import { StartRoomPhotoFileAskSyntheaRequestSerializer } from '../serializers/StartRoomPhotoFileAskSyntheaRequestSerializer';
import { RoomPhotoFileSerializer } from '../serializers/RoomPhotoFileSerializer';
import { FilterRoomPhotoFileRequestSerializer } from '../serializers/FilterRoomPhotoFileRequestSerializer';
import { DataviewRoomPhotoFileResponseSerializer } from '../serializers/DataviewRoomPhotoFileResponseSerializer';
import { StartRoomSelectionAddLineItemRequestSerializer } from '../serializers/StartRoomSelectionAddLineItemRequestSerializer';
import { StartRoomSelectionSwitchItemRequestSerializer } from '../serializers/StartRoomSelectionSwitchItemRequestSerializer';
import { StartRoomSelectionRemoveItemRequestSerializer } from '../serializers/StartRoomSelectionRemoveItemRequestSerializer';
import { StartRoomSelectionEditItemRequestSerializer } from '../serializers/StartRoomSelectionEditItemRequestSerializer';
import { StartRoomSelectionAddFreightRequestSerializer } from '../serializers/StartRoomSelectionAddFreightRequestSerializer';
import { RoomSelectionSerializer } from '../serializers/RoomSelectionSerializer';
import { UpdateRoomSelectionRequestSerializer } from '../serializers/UpdateRoomSelectionRequestSerializer';
import { CreateRoomSelectionRequestSerializer } from '../serializers/CreateRoomSelectionRequestSerializer';
import { FilterRoomSelectionRequestSerializer } from '../serializers/FilterRoomSelectionRequestSerializer';
import { DataviewRoomSelectionResponseSerializer } from '../serializers/DataviewRoomSelectionResponseSerializer';
import { ObjectTaskSerializer } from '../serializers/ObjectTaskSerializer';
import { UpdateObjectTaskRequestSerializer } from '../serializers/UpdateObjectTaskRequestSerializer';
import { CreateObjectTaskRequestSerializer } from '../serializers/CreateObjectTaskRequestSerializer';
import { FilterObjectTaskRequestSerializer } from '../serializers/FilterObjectTaskRequestSerializer';
import { DataviewObjectTaskResponseSerializer } from '../serializers/DataviewObjectTaskResponseSerializer';
import { StartOtgUserCreateFileRequestSerializer } from '../serializers/StartOtgUserCreateFileRequestSerializer';
import { OtgUserSerializer } from '../serializers/OtgUserSerializer';
import { FilterOtgUserRequestSerializer } from '../serializers/FilterOtgUserRequestSerializer';
import { DataviewOtgUserResponseSerializer } from '../serializers/DataviewOtgUserResponseSerializer';
import { VinylCatalogItemSerializer } from '../serializers/VinylCatalogItemSerializer';
import { FilterVinylCatalogItemRequestSerializer } from '../serializers/FilterVinylCatalogItemRequestSerializer';
import { DataviewVinylCatalogItemResponseSerializer } from '../serializers/DataviewVinylCatalogItemResponseSerializer';
import { OtgVinylCatalogStyleSerializer } from '../serializers/OtgVinylCatalogStyleSerializer';
import { FilterOtgVinylCatalogStyleRequestSerializer } from '../serializers/FilterOtgVinylCatalogStyleRequestSerializer';
import { DataviewOtgVinylCatalogStyleResponseSerializer } from '../serializers/DataviewOtgVinylCatalogStyleResponseSerializer';
import { WoodCatalogItemSerializer } from '../serializers/WoodCatalogItemSerializer';
import { FilterWoodCatalogItemRequestSerializer } from '../serializers/FilterWoodCatalogItemRequestSerializer';
import { DataviewWoodCatalogItemResponseSerializer } from '../serializers/DataviewWoodCatalogItemResponseSerializer';
import { OtgWoodCatalogStyleSerializer } from '../serializers/OtgWoodCatalogStyleSerializer';
import { FilterOtgWoodCatalogStyleRequestSerializer } from '../serializers/FilterOtgWoodCatalogStyleRequestSerializer';
import { DataviewOtgWoodCatalogStyleResponseSerializer } from '../serializers/DataviewOtgWoodCatalogStyleResponseSerializer';

/**
 * HTTP client for Otg operations
 *
 * Client for Otg operations
 */
export class OtgClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getObjectAppointmentSendCustomAppointmentConfirmationEmailForm(objectId: string, unlayerTemplateId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (unlayerTemplateId !== undefined) {
      queryParams.append('UnlayerTemplateId', String(unlayerTemplateId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runObjectAppointmentSendCustomAppointmentConfirmationEmailAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startObjectAppointmentSendCustomAppointmentConfirmationEmail(objectId: string, request?: StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getObjectAppointmentSendAppointmentConfirmationEmailForm(objectId: string, description?: string | null, unlayerTemplateId?: string | null, message?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (unlayerTemplateId !== undefined) {
      queryParams.append('UnlayerTemplateId', String(unlayerTemplateId));
    }
    if (message !== undefined) {
      queryParams.append('Message', String(message));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runObjectAppointmentSendAppointmentConfirmationEmailAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startObjectAppointmentSendAppointmentConfirmationEmail(objectId: string, request?: StartObjectAppointmentSendAppointmentConfirmationEmailRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartObjectAppointmentSendAppointmentConfirmationEmailRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getObjectAppointmentSendOmwsmsForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runObjectAppointmentSendOmwsmsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startObjectAppointmentSendOmwsms(objectId: string, request?: StartObjectAppointmentSendOmwsmsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartObjectAppointmentSendOmwsmsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getObjectAppointmentSendUpcomingAppointmentReminderForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runObjectAppointmentSendUpcomingAppointmentReminderAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startObjectAppointmentSendUpcomingAppointmentReminder(objectId: string, request?: StartObjectAppointmentSendUpcomingAppointmentReminderRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartObjectAppointmentSendUpcomingAppointmentReminderRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async runObjectAppointmentInitiateCallWithOpenPhoneAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(d53bd8ec-69fa-4983-9a79-831ebf904b5e)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startObjectAppointmentInitiateCallWithOpenPhone(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(d53bd8ec-69fa-4983-9a79-831ebf904b5e)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getObjectAppointmentInitiateOmwsmsForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runObjectAppointmentInitiateOmwsmsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startObjectAppointmentInitiateOmwsms(objectId: string, request?: StartObjectAppointmentInitiateOmwsmsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartObjectAppointmentInitiateOmwsmsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getObjectAppointmentInitiateSmsForUpcomingApppointmentForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runObjectAppointmentInitiateSmsForUpcomingApppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startObjectAppointmentInitiateSmsForUpcomingApppointment(objectId: string, request?: StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getObjectAppointmentCancelAppointmentForm(objectId: string, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runObjectAppointmentCancelAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startObjectAppointmentCancelAppointment(objectId: string, request?: StartObjectAppointmentCancelAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartObjectAppointmentCancelAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForObjectAppointment(formName: string, objectId: string, parentObjectType?: string | null, end?: string | null, isAllDay?: boolean | null, start?: string | null, timeZoneId?: string | null, organizationId?: string | null, refsO365Event?: string | null, refsSfServiceAppointment?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, parentObjectId?: string | null, appointmentTypeId?: string | null, cancelledBy?: string | null, cancelledOn?: string | null, replacedById?: string | null, tool?: string | null, addressAddress?: string | null, addressCity?: string | null, addressCountry?: string | null, addressLocation?: any | null, addressPostalCode?: string | null, addressState?: string | null, addressAddress2?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Appointment({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (end !== undefined) {
      queryParams.append('End', String(end));
    }
    if (isAllDay !== undefined) {
      queryParams.append('IsAllDay', String(isAllDay));
    }
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (organizationId !== undefined) {
      queryParams.append('OrganizationId', String(organizationId));
    }
    if (refsO365Event !== undefined) {
      queryParams.append('Refs|o365_Event', String(refsO365Event));
    }
    if (refsSfServiceAppointment !== undefined) {
      queryParams.append('Refs|sf_ServiceAppointment', String(refsSfServiceAppointment));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (appointmentTypeId !== undefined) {
      queryParams.append('AppointmentTypeId', String(appointmentTypeId));
    }
    if (cancelledBy !== undefined) {
      queryParams.append('CancelledBy', String(cancelledBy));
    }
    if (cancelledOn !== undefined) {
      queryParams.append('CancelledOn', String(cancelledOn));
    }
    if (replacedById !== undefined) {
      queryParams.append('ReplacedById', String(replacedById));
    }
    if (tool !== undefined) {
      queryParams.append('Tool', String(tool));
    }
    if (addressAddress !== undefined) {
      queryParams.append('Address|Address', String(addressAddress));
    }
    if (addressCity !== undefined) {
      queryParams.append('Address|City', String(addressCity));
    }
    if (addressCountry !== undefined) {
      queryParams.append('Address|Country', String(addressCountry));
    }
    if (addressLocation !== undefined) {
      queryParams.append('Address|Location', String(addressLocation));
    }
    if (addressPostalCode !== undefined) {
      queryParams.append('Address|PostalCode', String(addressPostalCode));
    }
    if (addressState !== undefined) {
      queryParams.append('Address|State', String(addressState));
    }
    if (addressAddress2 !== undefined) {
      queryParams.append('Address|Address2', String(addressAddress2));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeObjectAppointment(formName: string, parentObjectType?: string | null, end?: string | null, isAllDay?: boolean | null, start?: string | null, timeZoneId?: string | null, organizationId?: string | null, refsO365Event?: string | null, refsSfServiceAppointment?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, parentObjectId?: string | null, appointmentTypeId?: string | null, cancelledBy?: string | null, cancelledOn?: string | null, replacedById?: string | null, tool?: string | null, addressAddress?: string | null, addressCity?: string | null, addressCountry?: string | null, addressLocation?: any | null, addressPostalCode?: string | null, addressState?: string | null, addressAddress2?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Appointment/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (end !== undefined) {
      queryParams.append('End', String(end));
    }
    if (isAllDay !== undefined) {
      queryParams.append('IsAllDay', String(isAllDay));
    }
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (organizationId !== undefined) {
      queryParams.append('OrganizationId', String(organizationId));
    }
    if (refsO365Event !== undefined) {
      queryParams.append('Refs|o365_Event', String(refsO365Event));
    }
    if (refsSfServiceAppointment !== undefined) {
      queryParams.append('Refs|sf_ServiceAppointment', String(refsSfServiceAppointment));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (appointmentTypeId !== undefined) {
      queryParams.append('AppointmentTypeId', String(appointmentTypeId));
    }
    if (cancelledBy !== undefined) {
      queryParams.append('CancelledBy', String(cancelledBy));
    }
    if (cancelledOn !== undefined) {
      queryParams.append('CancelledOn', String(cancelledOn));
    }
    if (replacedById !== undefined) {
      queryParams.append('ReplacedById', String(replacedById));
    }
    if (tool !== undefined) {
      queryParams.append('Tool', String(tool));
    }
    if (addressAddress !== undefined) {
      queryParams.append('Address|Address', String(addressAddress));
    }
    if (addressCity !== undefined) {
      queryParams.append('Address|City', String(addressCity));
    }
    if (addressCountry !== undefined) {
      queryParams.append('Address|Country', String(addressCountry));
    }
    if (addressLocation !== undefined) {
      queryParams.append('Address|Location', String(addressLocation));
    }
    if (addressPostalCode !== undefined) {
      queryParams.append('Address|PostalCode', String(addressPostalCode));
    }
    if (addressState !== undefined) {
      queryParams.append('Address|State', String(addressState));
    }
    if (addressAddress2 !== undefined) {
      queryParams.append('Address|Address2', String(addressAddress2));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterObjectAppointment(request?: FilterObjectAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<ObjectAppointment[]> {
    const path = '/app/api/Object/otg.Appointment/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ObjectAppointmentSerializer.fromObject(item));
  }

  async createObjectAppointment(request?: CreateObjectAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.Appointment';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateObjectAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateObjectAppointment(objectId: string, request?: UpdateObjectAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Appointment({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateObjectAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentObjectAppointment(request?: FilterObjectAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<ObjectAppointment[]> {
    const path = '/app/api/Object/otg.Appointment/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ObjectAppointmentSerializer.fromObject(item));
  }

  async dataViewObjectAppointment(request?: FilterObjectAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewObjectAppointmentResponse> {
    const path = '/app/api/Object/otg.Appointment/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewObjectAppointmentResponseSerializer.fromObject(data);
  }

  async getFormForCarpetCatalogItem(formName: string, objectId: string, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesFiber?: string | null, propertiesPatternMatch?: string | null, propertiesPriceGroup?: number | null, propertiesStainResistanceRating?: number | null, propertiesWidth?: string | null, propertiesCollectionName?: string | null, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesLinks?: string | null, propertiesPlankLength?: string | null, propertiesResilientType?: string | null, propertiesStyleName?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesVendor?: string | null, propertiesWearLayer?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CarpetCatalogItem({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeCarpetCatalogItem(formName: string, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesFiber?: string | null, propertiesPatternMatch?: string | null, propertiesPriceGroup?: number | null, propertiesStainResistanceRating?: number | null, propertiesWidth?: string | null, propertiesCollectionName?: string | null, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesLinks?: string | null, propertiesPlankLength?: string | null, propertiesResilientType?: string | null, propertiesStyleName?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesVendor?: string | null, propertiesWearLayer?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CarpetCatalogItem/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterCarpetCatalogItem(request?: FilterCarpetCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<CarpetCatalogItem[]> {
    const path = '/app/api/Object/otg.CarpetCatalogItem/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCarpetCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CarpetCatalogItemSerializer.fromObject(item));
  }

  async recentCarpetCatalogItem(request?: FilterCarpetCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<CarpetCatalogItem[]> {
    const path = '/app/api/Object/otg.CarpetCatalogItem/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCarpetCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CarpetCatalogItemSerializer.fromObject(item));
  }

  async dataViewCarpetCatalogItem(request?: FilterCarpetCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewCarpetCatalogItemResponse> {
    const path = '/app/api/Object/otg.CarpetCatalogItem/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCarpetCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewCarpetCatalogItemResponseSerializer.fromObject(data);
  }

  async getFormForotgCarpetCatalogStyle(formName: string, objectId: string, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesFiber?: string | null, propertiesPatternMatch?: string | null, propertiesPriceGroup?: number | null, propertiesStainResistanceRating?: number | null, propertiesWidth?: string | null, externalId?: string | null, name?: string | null, description?: string | null, materialType?: string | null, propertiesLinks?: string | null, propertiesCollectionName?: string | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesCompetitionCrushers?: boolean | null, costRange?: string | null, tags?: string[] | null, id?: string | null, isActive?: boolean | null, catalogFeedId?: string | null, parentsManufacturer?: string | null, count?: number | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesWearLayer?: string | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CarpetCatalogStyle({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (costRange !== undefined) {
      queryParams.append('CostRange', String(costRange));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeotgCarpetCatalogStyle(formName: string, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesFiber?: string | null, propertiesPatternMatch?: string | null, propertiesPriceGroup?: number | null, propertiesStainResistanceRating?: number | null, propertiesWidth?: string | null, externalId?: string | null, name?: string | null, description?: string | null, materialType?: string | null, propertiesLinks?: string | null, propertiesCollectionName?: string | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesCompetitionCrushers?: boolean | null, costRange?: string | null, tags?: string[] | null, id?: string | null, isActive?: boolean | null, catalogFeedId?: string | null, parentsManufacturer?: string | null, count?: number | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesWearLayer?: string | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CarpetCatalogStyle/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (costRange !== undefined) {
      queryParams.append('CostRange', String(costRange));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterOtgCarpetCatalogStyle(request?: FilterOtgCarpetCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgCarpetCatalogStyle[]> {
    const path = '/app/api/Object/otg.CarpetCatalogStyle/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgCarpetCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgCarpetCatalogStyleSerializer.fromObject(item));
  }

  async recentOtgCarpetCatalogStyle(request?: FilterOtgCarpetCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgCarpetCatalogStyle[]> {
    const path = '/app/api/Object/otg.CarpetCatalogStyle/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgCarpetCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgCarpetCatalogStyleSerializer.fromObject(item));
  }

  async dataViewOtgCarpetCatalogStyle(request?: FilterOtgCarpetCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewOtgCarpetCatalogStyleResponse> {
    const path = '/app/api/Object/otg.CarpetCatalogStyle/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgCarpetCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewOtgCarpetCatalogStyleResponseSerializer.fromObject(data);
  }

  async getFormForCatalogItem(formName: string, objectId: string, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCarpetType?: string | null, propertiesCollectionName?: string | null, propertiesColorType?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesFiber?: string | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesLinks?: string | null, propertiesPatternMatch?: string | null, propertiesPlankLength?: string | null, propertiesPriceGroup?: number | null, propertiesResilientType?: string | null, propertiesStainResistanceRating?: number | null, propertiesStyleName?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesVendor?: string | null, propertiesWearLayer?: string | null, propertiesWidth?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CatalogItem({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeCatalogItem(formName: string, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCarpetType?: string | null, propertiesCollectionName?: string | null, propertiesColorType?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesFiber?: string | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesLinks?: string | null, propertiesPatternMatch?: string | null, propertiesPlankLength?: string | null, propertiesPriceGroup?: number | null, propertiesResilientType?: string | null, propertiesStainResistanceRating?: number | null, propertiesStyleName?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesVendor?: string | null, propertiesWearLayer?: string | null, propertiesWidth?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CatalogItem/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterCatalogItem(request?: FilterCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<CatalogItem[]> {
    const path = '/app/api/Object/otg.CatalogItem/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CatalogItemSerializer.fromObject(item));
  }

  async recentCatalogItem(request?: FilterCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<CatalogItem[]> {
    const path = '/app/api/Object/otg.CatalogItem/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CatalogItemSerializer.fromObject(item));
  }

  async dataViewCatalogItem(request?: FilterCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewCatalogItemResponse> {
    const path = '/app/api/Object/otg.CatalogItem/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewCatalogItemResponseSerializer.fromObject(data);
  }

  async getFormForotgCatalogManufacturer(formName: string, objectId: string, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, count?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CatalogManufacturer({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeotgCatalogManufacturer(formName: string, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, count?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CatalogManufacturer/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterOtgCatalogManufacturer(request?: FilterOtgCatalogManufacturerRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgCatalogManufacturer[]> {
    const path = '/app/api/Object/otg.CatalogManufacturer/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgCatalogManufacturerRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgCatalogManufacturerSerializer.fromObject(item));
  }

  async recentOtgCatalogManufacturer(request?: FilterOtgCatalogManufacturerRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgCatalogManufacturer[]> {
    const path = '/app/api/Object/otg.CatalogManufacturer/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgCatalogManufacturerRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgCatalogManufacturerSerializer.fromObject(item));
  }

  async dataViewOtgCatalogManufacturer(request?: FilterOtgCatalogManufacturerRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewOtgCatalogManufacturerResponse> {
    const path = '/app/api/Object/otg.CatalogManufacturer/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgCatalogManufacturerRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewOtgCatalogManufacturerResponseSerializer.fromObject(data);
  }

  async getFormForotgCatalogStyle(formName: string, objectId: string, externalId?: string | null, name?: string | null, description?: string | null, materialType?: string | null, propertiesLinks?: string | null, propertiesCollectionName?: string | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesDemo?: string | null, propertiesWidth?: string | null, propertiesPatternMatch?: string | null, propertiesFiber?: string | null, propertiesDurabilityRating?: number | null, propertiesStainResistanceRating?: number | null, propertiesPriceGroup?: number | null, propertiesCompetitionCrushers?: boolean | null, costRange?: string | null, tags?: string[] | null, id?: string | null, isActive?: boolean | null, catalogFeedId?: string | null, parentsManufacturer?: string | null, count?: number | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesWearLayer?: string | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CatalogStyle({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (costRange !== undefined) {
      queryParams.append('CostRange', String(costRange));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeotgCatalogStyle(formName: string, externalId?: string | null, name?: string | null, description?: string | null, materialType?: string | null, propertiesLinks?: string | null, propertiesCollectionName?: string | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesDemo?: string | null, propertiesWidth?: string | null, propertiesPatternMatch?: string | null, propertiesFiber?: string | null, propertiesDurabilityRating?: number | null, propertiesStainResistanceRating?: number | null, propertiesPriceGroup?: number | null, propertiesCompetitionCrushers?: boolean | null, costRange?: string | null, tags?: string[] | null, id?: string | null, isActive?: boolean | null, catalogFeedId?: string | null, parentsManufacturer?: string | null, count?: number | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesWearLayer?: string | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CatalogStyle/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (costRange !== undefined) {
      queryParams.append('CostRange', String(costRange));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterOtgCatalogStyle(request?: FilterOtgCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgCatalogStyle[]> {
    const path = '/app/api/Object/otg.CatalogStyle/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgCatalogStyleSerializer.fromObject(item));
  }

  async recentOtgCatalogStyle(request?: FilterOtgCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgCatalogStyle[]> {
    const path = '/app/api/Object/otg.CatalogStyle/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgCatalogStyleSerializer.fromObject(item));
  }

  async dataViewOtgCatalogStyle(request?: FilterOtgCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewOtgCatalogStyleResponse> {
    const path = '/app/api/Object/otg.CatalogStyle/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewOtgCatalogStyleResponseSerializer.fromObject(data);
  }

  async getFormForCeramicTileCatalogItem(formName: string, objectId: string, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCarpetType?: string | null, propertiesCollectionName?: string | null, propertiesColorType?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesFiber?: string | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesLinks?: string | null, propertiesPatternMatch?: string | null, propertiesPlankLength?: string | null, propertiesPriceGroup?: number | null, propertiesResilientType?: string | null, propertiesStainResistanceRating?: number | null, propertiesStyleName?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesVendor?: string | null, propertiesWearLayer?: string | null, propertiesWidth?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CeramicTileCatalogItem({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeCeramicTileCatalogItem(formName: string, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCarpetType?: string | null, propertiesCollectionName?: string | null, propertiesColorType?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesFiber?: string | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesLinks?: string | null, propertiesPatternMatch?: string | null, propertiesPlankLength?: string | null, propertiesPriceGroup?: number | null, propertiesResilientType?: string | null, propertiesStainResistanceRating?: number | null, propertiesStyleName?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesVendor?: string | null, propertiesWearLayer?: string | null, propertiesWidth?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CeramicTileCatalogItem/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterCeramicTileCatalogItem(request?: FilterCeramicTileCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<CeramicTileCatalogItem[]> {
    const path = '/app/api/Object/otg.CeramicTileCatalogItem/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCeramicTileCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CeramicTileCatalogItemSerializer.fromObject(item));
  }

  async recentCeramicTileCatalogItem(request?: FilterCeramicTileCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<CeramicTileCatalogItem[]> {
    const path = '/app/api/Object/otg.CeramicTileCatalogItem/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCeramicTileCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CeramicTileCatalogItemSerializer.fromObject(item));
  }

  async dataViewCeramicTileCatalogItem(request?: FilterCeramicTileCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewCeramicTileCatalogItemResponse> {
    const path = '/app/api/Object/otg.CeramicTileCatalogItem/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCeramicTileCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewCeramicTileCatalogItemResponseSerializer.fromObject(data);
  }

  async getCompanyAddNoteForm(objectId: string, content?: string | null, name?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(45b70320-0072-461b-b3da-08477e956d4b)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runCompanyAddNoteAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(45b70320-0072-461b-b3da-08477e956d4b)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startCompanyAddNote(objectId: string, request?: StartCompanyAddNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(45b70320-0072-461b-b3da-08477e956d4b)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartCompanyAddNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getCompanyAddTaskForm(objectId: string, dueDate?: string | null, priority?: string | null, name?: string | null, content?: string | null, assignedUserId?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(6020436b-12e1-4d6b-b201-6ce50f353d4a)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (priority !== undefined) {
      queryParams.append('Priority', String(priority));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (assignedUserId !== undefined) {
      queryParams.append('AssignedUserId', String(assignedUserId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runCompanyAddTaskAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(6020436b-12e1-4d6b-b201-6ce50f353d4a)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startCompanyAddTask(objectId: string, request?: StartCompanyAddTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(6020436b-12e1-4d6b-b201-6ce50f353d4a)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartCompanyAddTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getCompanyAddAppointmentForm(objectId: string, start?: string | null, userId?: string | null, name?: string | null, description?: string | null, message?: string | null, sendEmail?: boolean | null, duration?: string | null, copyAddress?: boolean | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(0ab71aea-c6e7-41ca-9dbb-e5d5f34b6192)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (userId !== undefined) {
      queryParams.append('UserId', String(userId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (message !== undefined) {
      queryParams.append('Message', String(message));
    }
    if (sendEmail !== undefined) {
      queryParams.append('SendEmail', String(sendEmail));
    }
    if (duration !== undefined) {
      queryParams.append('Duration', String(duration));
    }
    if (copyAddress !== undefined) {
      queryParams.append('CopyAddress', String(copyAddress));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runCompanyAddAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(0ab71aea-c6e7-41ca-9dbb-e5d5f34b6192)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startCompanyAddAppointment(objectId: string, request?: StartCompanyAddAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(0ab71aea-c6e7-41ca-9dbb-e5d5f34b6192)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartCompanyAddAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getCompanyAskSyntheaForm(objectId: string, assistantId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(d206aa20-25a1-4d7d-bee4-3d9b066986a3)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (assistantId !== undefined) {
      queryParams.append('AssistantId', String(assistantId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runCompanyAskSyntheaAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(d206aa20-25a1-4d7d-bee4-3d9b066986a3)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startCompanyAskSynthea(objectId: string, request?: StartCompanyAskSyntheaRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/UserAction(d206aa20-25a1-4d7d-bee4-3d9b066986a3)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartCompanyAskSyntheaRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForCompany(formName: string, objectId: string, name?: string | null, parentContactId?: string | null, role?: string | null, flowId?: string | null, objectStatusId?: string | null, tags?: string[] | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, location?: any | null, locationDistance?: any | null, creatorId?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, notes?: string | null, address2?: string | null, phoneNumbersDescription?: string | null, phoneNumbersPhoneNumber?: string | null, phoneNumbersType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (parentContactId !== undefined) {
      queryParams.append('ParentContactId', String(parentContactId));
    }
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (address !== undefined) {
      queryParams.append('Address', String(address));
    }
    if (city !== undefined) {
      queryParams.append('City', String(city));
    }
    if (state !== undefined) {
      queryParams.append('State', String(state));
    }
    if (postalCode !== undefined) {
      queryParams.append('PostalCode', String(postalCode));
    }
    if (country !== undefined) {
      queryParams.append('Country', String(country));
    }
    if (email !== undefined) {
      queryParams.append('Email', String(email));
    }
    if (location !== undefined) {
      queryParams.append('Location', String(location));
    }
    if (locationDistance !== undefined) {
      queryParams.append('LocationDistance', String(locationDistance));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (notes !== undefined) {
      queryParams.append('Notes', String(notes));
    }
    if (address2 !== undefined) {
      queryParams.append('Address2', String(address2));
    }
    if (phoneNumbersDescription !== undefined) {
      queryParams.append('PhoneNumbers|Description', String(phoneNumbersDescription));
    }
    if (phoneNumbersPhoneNumber !== undefined) {
      queryParams.append('PhoneNumbers|PhoneNumber', String(phoneNumbersPhoneNumber));
    }
    if (phoneNumbersType !== undefined) {
      queryParams.append('PhoneNumbers|Type', String(phoneNumbersType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeCompany(formName: string, name?: string | null, parentContactId?: string | null, role?: string | null, flowId?: string | null, objectStatusId?: string | null, tags?: string[] | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, location?: any | null, locationDistance?: any | null, creatorId?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, notes?: string | null, address2?: string | null, phoneNumbersDescription?: string | null, phoneNumbersPhoneNumber?: string | null, phoneNumbersType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.CompanyContact/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (parentContactId !== undefined) {
      queryParams.append('ParentContactId', String(parentContactId));
    }
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (address !== undefined) {
      queryParams.append('Address', String(address));
    }
    if (city !== undefined) {
      queryParams.append('City', String(city));
    }
    if (state !== undefined) {
      queryParams.append('State', String(state));
    }
    if (postalCode !== undefined) {
      queryParams.append('PostalCode', String(postalCode));
    }
    if (country !== undefined) {
      queryParams.append('Country', String(country));
    }
    if (email !== undefined) {
      queryParams.append('Email', String(email));
    }
    if (location !== undefined) {
      queryParams.append('Location', String(location));
    }
    if (locationDistance !== undefined) {
      queryParams.append('LocationDistance', String(locationDistance));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (notes !== undefined) {
      queryParams.append('Notes', String(notes));
    }
    if (address2 !== undefined) {
      queryParams.append('Address2', String(address2));
    }
    if (phoneNumbersDescription !== undefined) {
      queryParams.append('PhoneNumbers|Description', String(phoneNumbersDescription));
    }
    if (phoneNumbersPhoneNumber !== undefined) {
      queryParams.append('PhoneNumbers|PhoneNumber', String(phoneNumbersPhoneNumber));
    }
    if (phoneNumbersType !== undefined) {
      queryParams.append('PhoneNumbers|Type', String(phoneNumbersType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getUpsertFormForTypeCompany(entityId?: string | null, name?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    const path = '/app/api/Object/otg.CompanyContact/Upsert/DataForm';

    const queryParams = new URLSearchParams();
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterCompany(request?: FilterCompanyRequest | null, options?: { headers?: Record<string, string> }): Promise<Company[]> {
    const path = '/app/api/Object/otg.CompanyContact/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCompanyRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CompanySerializer.fromObject(item));
  }

  async createCompany(request?: CreateCompanyRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.CompanyContact';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateCompanyRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateCompany(objectId: string, request?: UpdateCompanyRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.CompanyContact({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateCompanyRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentCompany(request?: FilterCompanyRequest | null, options?: { headers?: Record<string, string> }): Promise<Company[]> {
    const path = '/app/api/Object/otg.CompanyContact/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCompanyRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CompanySerializer.fromObject(item));
  }

  async dataViewCompany(request?: FilterCompanyRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewCompanyResponse> {
    const path = '/app/api/Object/otg.CompanyContact/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCompanyRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewCompanyResponseSerializer.fromObject(data);
  }

  async getContactAddNoteForm(objectId: string, content?: string | null, name?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(45b70320-0072-461b-b3da-08477e956d4b)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAddNoteAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(45b70320-0072-461b-b3da-08477e956d4b)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAddNote(objectId: string, request?: StartContactAddNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(45b70320-0072-461b-b3da-08477e956d4b)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAddNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getContactAddTaskForm(objectId: string, dueDate?: string | null, priority?: string | null, name?: string | null, content?: string | null, assignedUserId?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(6020436b-12e1-4d6b-b201-6ce50f353d4a)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (priority !== undefined) {
      queryParams.append('Priority', String(priority));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (assignedUserId !== undefined) {
      queryParams.append('AssignedUserId', String(assignedUserId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAddTaskAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(6020436b-12e1-4d6b-b201-6ce50f353d4a)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAddTask(objectId: string, request?: StartContactAddTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(6020436b-12e1-4d6b-b201-6ce50f353d4a)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAddTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getContactAddAppointmentForm(objectId: string, start?: string | null, userId?: string | null, name?: string | null, description?: string | null, message?: string | null, sendEmail?: boolean | null, duration?: string | null, copyAddress?: boolean | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(0ab71aea-c6e7-41ca-9dbb-e5d5f34b6192)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (userId !== undefined) {
      queryParams.append('UserId', String(userId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (message !== undefined) {
      queryParams.append('Message', String(message));
    }
    if (sendEmail !== undefined) {
      queryParams.append('SendEmail', String(sendEmail));
    }
    if (duration !== undefined) {
      queryParams.append('Duration', String(duration));
    }
    if (copyAddress !== undefined) {
      queryParams.append('CopyAddress', String(copyAddress));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAddAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(0ab71aea-c6e7-41ca-9dbb-e5d5f34b6192)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAddAppointment(objectId: string, request?: StartContactAddAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(0ab71aea-c6e7-41ca-9dbb-e5d5f34b6192)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAddAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getContactAskSyntheaForm(objectId: string, assistantId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(d206aa20-25a1-4d7d-bee4-3d9b066986a3)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (assistantId !== undefined) {
      queryParams.append('AssistantId', String(assistantId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAskSyntheaAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(d206aa20-25a1-4d7d-bee4-3d9b066986a3)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAskSynthea(objectId: string, request?: StartContactAskSyntheaRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Contact({objectId})/UserAction(d206aa20-25a1-4d7d-bee4-3d9b066986a3)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAskSyntheaRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForContact(formName: string, objectId: string, role?: string | null, flowId?: string | null, objectStatusId?: string | null, tags?: string[] | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, location?: any | null, locationDistance?: any | null, creatorId?: string | null, parentContactId?: string | null, type_?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, notes?: string | null, address2?: string | null, phoneNumbersDescription?: string | null, phoneNumbersPhoneNumber?: string | null, phoneNumbersType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Contact({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (address !== undefined) {
      queryParams.append('Address', String(address));
    }
    if (city !== undefined) {
      queryParams.append('City', String(city));
    }
    if (state !== undefined) {
      queryParams.append('State', String(state));
    }
    if (postalCode !== undefined) {
      queryParams.append('PostalCode', String(postalCode));
    }
    if (country !== undefined) {
      queryParams.append('Country', String(country));
    }
    if (email !== undefined) {
      queryParams.append('Email', String(email));
    }
    if (location !== undefined) {
      queryParams.append('Location', String(location));
    }
    if (locationDistance !== undefined) {
      queryParams.append('LocationDistance', String(locationDistance));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (parentContactId !== undefined) {
      queryParams.append('ParentContactId', String(parentContactId));
    }
    if (type_ !== undefined) {
      queryParams.append('Type', String(type_));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (notes !== undefined) {
      queryParams.append('Notes', String(notes));
    }
    if (address2 !== undefined) {
      queryParams.append('Address2', String(address2));
    }
    if (phoneNumbersDescription !== undefined) {
      queryParams.append('PhoneNumbers|Description', String(phoneNumbersDescription));
    }
    if (phoneNumbersPhoneNumber !== undefined) {
      queryParams.append('PhoneNumbers|PhoneNumber', String(phoneNumbersPhoneNumber));
    }
    if (phoneNumbersType !== undefined) {
      queryParams.append('PhoneNumbers|Type', String(phoneNumbersType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeContact(formName: string, role?: string | null, flowId?: string | null, objectStatusId?: string | null, tags?: string[] | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, location?: any | null, locationDistance?: any | null, creatorId?: string | null, parentContactId?: string | null, type_?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, notes?: string | null, address2?: string | null, phoneNumbersDescription?: string | null, phoneNumbersPhoneNumber?: string | null, phoneNumbersType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Contact/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (address !== undefined) {
      queryParams.append('Address', String(address));
    }
    if (city !== undefined) {
      queryParams.append('City', String(city));
    }
    if (state !== undefined) {
      queryParams.append('State', String(state));
    }
    if (postalCode !== undefined) {
      queryParams.append('PostalCode', String(postalCode));
    }
    if (country !== undefined) {
      queryParams.append('Country', String(country));
    }
    if (email !== undefined) {
      queryParams.append('Email', String(email));
    }
    if (location !== undefined) {
      queryParams.append('Location', String(location));
    }
    if (locationDistance !== undefined) {
      queryParams.append('LocationDistance', String(locationDistance));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (parentContactId !== undefined) {
      queryParams.append('ParentContactId', String(parentContactId));
    }
    if (type_ !== undefined) {
      queryParams.append('Type', String(type_));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (notes !== undefined) {
      queryParams.append('Notes', String(notes));
    }
    if (address2 !== undefined) {
      queryParams.append('Address2', String(address2));
    }
    if (phoneNumbersDescription !== undefined) {
      queryParams.append('PhoneNumbers|Description', String(phoneNumbersDescription));
    }
    if (phoneNumbersPhoneNumber !== undefined) {
      queryParams.append('PhoneNumbers|PhoneNumber', String(phoneNumbersPhoneNumber));
    }
    if (phoneNumbersType !== undefined) {
      queryParams.append('PhoneNumbers|Type', String(phoneNumbersType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterContact(request?: FilterContactRequest | null, options?: { headers?: Record<string, string> }): Promise<Contact[]> {
    const path = '/app/api/Object/otg.Contact/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ContactSerializer.fromObject(item));
  }

  async createContact(request?: CreateContactRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.Contact';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateContact(objectId: string, request?: UpdateContactRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Contact({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentContact(request?: FilterContactRequest | null, options?: { headers?: Record<string, string> }): Promise<Contact[]> {
    const path = '/app/api/Object/otg.Contact/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ContactSerializer.fromObject(item));
  }

  async dataViewContact(request?: FilterContactRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewContactResponse> {
    const path = '/app/api/Object/otg.Contact/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewContactResponseSerializer.fromObject(data);
  }

  async getContactAppointmentSendCustomAppointmentConfirmationEmailForm(objectId: string, unlayerTemplateId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (unlayerTemplateId !== undefined) {
      queryParams.append('UnlayerTemplateId', String(unlayerTemplateId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAppointmentSendCustomAppointmentConfirmationEmailAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAppointmentSendCustomAppointmentConfirmationEmail(objectId: string, request?: StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getContactAppointmentSendAppointmentConfirmationEmailForm(objectId: string, description?: string | null, unlayerTemplateId?: string | null, message?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (unlayerTemplateId !== undefined) {
      queryParams.append('UnlayerTemplateId', String(unlayerTemplateId));
    }
    if (message !== undefined) {
      queryParams.append('Message', String(message));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAppointmentSendAppointmentConfirmationEmailAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAppointmentSendAppointmentConfirmationEmail(objectId: string, request?: StartContactAppointmentSendAppointmentConfirmationEmailRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAppointmentSendAppointmentConfirmationEmailRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getContactAppointmentSendOmwsmsForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAppointmentSendOmwsmsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAppointmentSendOmwsms(objectId: string, request?: StartContactAppointmentSendOmwsmsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAppointmentSendOmwsmsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getContactAppointmentSendUpcomingAppointmentReminderForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAppointmentSendUpcomingAppointmentReminderAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAppointmentSendUpcomingAppointmentReminder(objectId: string, request?: StartContactAppointmentSendUpcomingAppointmentReminderRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAppointmentSendUpcomingAppointmentReminderRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async runContactAppointmentInitiateCallWithOpenPhoneAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(d53bd8ec-69fa-4983-9a79-831ebf904b5e)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAppointmentInitiateCallWithOpenPhone(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(d53bd8ec-69fa-4983-9a79-831ebf904b5e)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getContactAppointmentInitiateOmwsmsForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAppointmentInitiateOmwsmsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAppointmentInitiateOmwsms(objectId: string, request?: StartContactAppointmentInitiateOmwsmsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAppointmentInitiateOmwsmsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getContactAppointmentInitiateSmsForUpcomingApppointmentForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAppointmentInitiateSmsForUpcomingApppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAppointmentInitiateSmsForUpcomingApppointment(objectId: string, request?: StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getContactAppointmentCancelAppointmentForm(objectId: string, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAppointmentCancelAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAppointmentCancelAppointment(objectId: string, request?: StartContactAppointmentCancelAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAppointmentCancelAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForContactAppointment(formName: string, objectId: string, parentObjectId?: string | null, end?: string | null, isAllDay?: boolean | null, start?: string | null, timeZoneId?: string | null, organizationId?: string | null, refsO365Event?: string | null, refsSfServiceAppointment?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, appointmentTypeId?: string | null, cancelledBy?: string | null, cancelledOn?: string | null, replacedById?: string | null, tool?: string | null, addressAddress?: string | null, addressCity?: string | null, addressCountry?: string | null, addressLocation?: any | null, addressPostalCode?: string | null, addressState?: string | null, addressAddress2?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (end !== undefined) {
      queryParams.append('End', String(end));
    }
    if (isAllDay !== undefined) {
      queryParams.append('IsAllDay', String(isAllDay));
    }
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (organizationId !== undefined) {
      queryParams.append('OrganizationId', String(organizationId));
    }
    if (refsO365Event !== undefined) {
      queryParams.append('Refs|o365_Event', String(refsO365Event));
    }
    if (refsSfServiceAppointment !== undefined) {
      queryParams.append('Refs|sf_ServiceAppointment', String(refsSfServiceAppointment));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (appointmentTypeId !== undefined) {
      queryParams.append('AppointmentTypeId', String(appointmentTypeId));
    }
    if (cancelledBy !== undefined) {
      queryParams.append('CancelledBy', String(cancelledBy));
    }
    if (cancelledOn !== undefined) {
      queryParams.append('CancelledOn', String(cancelledOn));
    }
    if (replacedById !== undefined) {
      queryParams.append('ReplacedById', String(replacedById));
    }
    if (tool !== undefined) {
      queryParams.append('Tool', String(tool));
    }
    if (addressAddress !== undefined) {
      queryParams.append('Address|Address', String(addressAddress));
    }
    if (addressCity !== undefined) {
      queryParams.append('Address|City', String(addressCity));
    }
    if (addressCountry !== undefined) {
      queryParams.append('Address|Country', String(addressCountry));
    }
    if (addressLocation !== undefined) {
      queryParams.append('Address|Location', String(addressLocation));
    }
    if (addressPostalCode !== undefined) {
      queryParams.append('Address|PostalCode', String(addressPostalCode));
    }
    if (addressState !== undefined) {
      queryParams.append('Address|State', String(addressState));
    }
    if (addressAddress2 !== undefined) {
      queryParams.append('Address|Address2', String(addressAddress2));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeContactAppointment(formName: string, parentObjectId?: string | null, end?: string | null, isAllDay?: boolean | null, start?: string | null, timeZoneId?: string | null, organizationId?: string | null, refsO365Event?: string | null, refsSfServiceAppointment?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, appointmentTypeId?: string | null, cancelledBy?: string | null, cancelledOn?: string | null, replacedById?: string | null, tool?: string | null, addressAddress?: string | null, addressCity?: string | null, addressCountry?: string | null, addressLocation?: any | null, addressPostalCode?: string | null, addressState?: string | null, addressAddress2?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAppointment/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (end !== undefined) {
      queryParams.append('End', String(end));
    }
    if (isAllDay !== undefined) {
      queryParams.append('IsAllDay', String(isAllDay));
    }
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (organizationId !== undefined) {
      queryParams.append('OrganizationId', String(organizationId));
    }
    if (refsO365Event !== undefined) {
      queryParams.append('Refs|o365_Event', String(refsO365Event));
    }
    if (refsSfServiceAppointment !== undefined) {
      queryParams.append('Refs|sf_ServiceAppointment', String(refsSfServiceAppointment));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (appointmentTypeId !== undefined) {
      queryParams.append('AppointmentTypeId', String(appointmentTypeId));
    }
    if (cancelledBy !== undefined) {
      queryParams.append('CancelledBy', String(cancelledBy));
    }
    if (cancelledOn !== undefined) {
      queryParams.append('CancelledOn', String(cancelledOn));
    }
    if (replacedById !== undefined) {
      queryParams.append('ReplacedById', String(replacedById));
    }
    if (tool !== undefined) {
      queryParams.append('Tool', String(tool));
    }
    if (addressAddress !== undefined) {
      queryParams.append('Address|Address', String(addressAddress));
    }
    if (addressCity !== undefined) {
      queryParams.append('Address|City', String(addressCity));
    }
    if (addressCountry !== undefined) {
      queryParams.append('Address|Country', String(addressCountry));
    }
    if (addressLocation !== undefined) {
      queryParams.append('Address|Location', String(addressLocation));
    }
    if (addressPostalCode !== undefined) {
      queryParams.append('Address|PostalCode', String(addressPostalCode));
    }
    if (addressState !== undefined) {
      queryParams.append('Address|State', String(addressState));
    }
    if (addressAddress2 !== undefined) {
      queryParams.append('Address|Address2', String(addressAddress2));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterContactAppointment(request?: FilterContactAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<ContactAppointment[]> {
    const path = '/app/api/Object/otg.ContactAppointment/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ContactAppointmentSerializer.fromObject(item));
  }

  async createContactAppointment(request?: CreateContactAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.ContactAppointment';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateContactAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateContactAppointment(objectId: string, request?: UpdateContactAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateContactAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deleteContactAppointment(objectId: string, fields?: ContactAppointmentFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<ContactAppointment> {
    let path = '/app/api/Object/otg.ContactAppointment({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return ContactAppointmentSerializer.fromObject(data);
  }

  async recentContactAppointment(request?: FilterContactAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<ContactAppointment[]> {
    const path = '/app/api/Object/otg.ContactAppointment/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ContactAppointmentSerializer.fromObject(item));
  }

  async dataViewContactAppointment(request?: FilterContactAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewContactAppointmentResponse> {
    const path = '/app/api/Object/otg.ContactAppointment/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewContactAppointmentResponseSerializer.fromObject(data);
  }

  async getContactAssignmentAskSyntheaForm(objectId: string, assistantId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAssignment({objectId})/UserAction(e9d9a884-e399-4cb2-8aef-68c350fe96b4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (assistantId !== undefined) {
      queryParams.append('AssistantId', String(assistantId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runContactAssignmentAskSyntheaAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAssignment({objectId})/UserAction(e9d9a884-e399-4cb2-8aef-68c350fe96b4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startContactAssignmentAskSynthea(objectId: string, request?: StartContactAssignmentAskSyntheaRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAssignment({objectId})/UserAction(e9d9a884-e399-4cb2-8aef-68c350fe96b4)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartContactAssignmentAskSyntheaRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForContactAssignment(formName: string, objectId: string, flowId?: string | null, objectStatusId?: string | null, name?: string | null, createdBy?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, parentObjectId?: string | null, parentObjectType?: string | null, contactId?: string | null, role?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAssignment({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (contactId !== undefined) {
      queryParams.append('ContactId', String(contactId));
    }
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeContactAssignment(formName: string, flowId?: string | null, objectStatusId?: string | null, name?: string | null, createdBy?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, parentObjectId?: string | null, parentObjectType?: string | null, contactId?: string | null, role?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactAssignment/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (contactId !== undefined) {
      queryParams.append('ContactId', String(contactId));
    }
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterContactAssignment(request?: FilterContactAssignmentRequest | null, options?: { headers?: Record<string, string> }): Promise<ContactAssignment[]> {
    const path = '/app/api/Object/otg.ContactAssignment/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactAssignmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ContactAssignmentSerializer.fromObject(item));
  }

  async updateContactAssignment(objectId: string, request?: UpdateContactAssignmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactAssignment({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateContactAssignmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deleteContactAssignment(objectId: string, fields?: ContactAssignmentFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<ContactAssignment> {
    let path = '/app/api/Object/otg.ContactAssignment({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return ContactAssignmentSerializer.fromObject(data);
  }

  async recentContactAssignment(request?: FilterContactAssignmentRequest | null, options?: { headers?: Record<string, string> }): Promise<ContactAssignment[]> {
    const path = '/app/api/Object/otg.ContactAssignment/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactAssignmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ContactAssignmentSerializer.fromObject(item));
  }

  async dataViewContactAssignment(request?: FilterContactAssignmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewContactAssignmentResponse> {
    const path = '/app/api/Object/otg.ContactAssignment/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactAssignmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewContactAssignmentResponseSerializer.fromObject(data);
  }

  async getFormForContactNote(formName: string, objectId: string, parentObjectType?: string | null, parentObjectId?: string | null, flowId?: string | null, objectStatusId?: string | null, content?: string | null, description?: string | null, name?: string | null, t?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactNote({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeContactNote(formName: string, parentObjectType?: string | null, parentObjectId?: string | null, flowId?: string | null, objectStatusId?: string | null, content?: string | null, description?: string | null, name?: string | null, t?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactNote/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterContactNote(request?: FilterContactNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<ContactNote[]> {
    const path = '/app/api/Object/otg.ContactNote/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ContactNoteSerializer.fromObject(item));
  }

  async createContactNote(request?: CreateContactNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.ContactNote';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateContactNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateContactNote(objectId: string, request?: UpdateContactNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactNote({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateContactNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentContactNote(request?: FilterContactNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<ContactNote[]> {
    const path = '/app/api/Object/otg.ContactNote/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ContactNoteSerializer.fromObject(item));
  }

  async dataViewContactNote(request?: FilterContactNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewContactNoteResponse> {
    const path = '/app/api/Object/otg.ContactNote/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewContactNoteResponseSerializer.fromObject(data);
  }

  async getFormForContactTask(formName: string, objectId: string, parentObjectId?: string | null, flowId?: string | null, objectStatusId?: string | null, content?: string | null, description?: string | null, name?: string | null, assignedUserId?: string | null, dueDate?: string | null, priority?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactTask({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (assignedUserId !== undefined) {
      queryParams.append('AssignedUserId', String(assignedUserId));
    }
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (priority !== undefined) {
      queryParams.append('Priority', String(priority));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeContactTask(formName: string, parentObjectId?: string | null, flowId?: string | null, objectStatusId?: string | null, content?: string | null, description?: string | null, name?: string | null, assignedUserId?: string | null, dueDate?: string | null, priority?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ContactTask/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (assignedUserId !== undefined) {
      queryParams.append('AssignedUserId', String(assignedUserId));
    }
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (priority !== undefined) {
      queryParams.append('Priority', String(priority));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterContactTask(request?: FilterContactTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<ContactTask[]> {
    const path = '/app/api/Object/otg.ContactTask/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ContactTaskSerializer.fromObject(item));
  }

  async createContactTask(request?: CreateContactTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.ContactTask';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateContactTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateContactTask(objectId: string, request?: UpdateContactTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ContactTask({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateContactTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentContactTask(request?: FilterContactTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<ContactTask[]> {
    const path = '/app/api/Object/otg.ContactTask/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ContactTaskSerializer.fromObject(item));
  }

  async dataViewContactTask(request?: FilterContactTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewContactTaskResponse> {
    const path = '/app/api/Object/otg.ContactTask/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterContactTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewContactTaskResponseSerializer.fromObject(data);
  }

  async runEstimateExportToSalesForceAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(c857a8ad-ccbe-40fd-8fa0-f012c3495eea)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateExportToSalesForce(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(c857a8ad-ccbe-40fd-8fa0-f012c3495eea)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateAskSyntheaForm(objectId: string, assistantId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(8de1c54e-4cfb-458a-b540-b1b743e9ce17)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (assistantId !== undefined) {
      queryParams.append('AssistantId', String(assistantId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateAskSyntheaAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(8de1c54e-4cfb-458a-b540-b1b743e9ce17)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateAskSynthea(objectId: string, request?: StartEstimateAskSyntheaRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(8de1c54e-4cfb-458a-b540-b1b743e9ce17)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateAskSyntheaRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateAddLineItemForm(objectId: string, itemId?: string | null, source?: string | null, quantity?: number | null, uom?: string | null, appliesTo?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(5dea52ab-280e-4703-85e5-056d035732cd)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (itemId !== undefined) {
      queryParams.append('itemId', String(itemId));
    }
    if (source !== undefined) {
      queryParams.append('source', String(source));
    }
    if (quantity !== undefined) {
      queryParams.append('quantity', String(quantity));
    }
    if (uom !== undefined) {
      queryParams.append('uom', String(uom));
    }
    if (appliesTo !== undefined) {
      queryParams.append('AppliesTo', String(appliesTo));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateAddLineItemAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(5dea52ab-280e-4703-85e5-056d035732cd)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateAddLineItem(objectId: string, request?: StartEstimateAddLineItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(5dea52ab-280e-4703-85e5-056d035732cd)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateAddLineItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateSwitchItemForm(objectId: string, currentItemId?: string | null, itemId?: string | null, source?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(67a58637-608e-47f8-b8bc-6dc5f9880d63)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (currentItemId !== undefined) {
      queryParams.append('currentItemId', String(currentItemId));
    }
    if (itemId !== undefined) {
      queryParams.append('itemId', String(itemId));
    }
    if (source !== undefined) {
      queryParams.append('source', String(source));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateSwitchItemAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(67a58637-608e-47f8-b8bc-6dc5f9880d63)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateSwitchItem(objectId: string, request?: StartEstimateSwitchItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(67a58637-608e-47f8-b8bc-6dc5f9880d63)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateSwitchItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateRemoveItemForm(objectId: string, source?: string | null, itemId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(aff55a6a-4c21-42fe-bc76-3277ab3efde4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (source !== undefined) {
      queryParams.append('source', String(source));
    }
    if (itemId !== undefined) {
      queryParams.append('itemId', String(itemId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateRemoveItemAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(aff55a6a-4c21-42fe-bc76-3277ab3efde4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateRemoveItem(objectId: string, request?: StartEstimateRemoveItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(aff55a6a-4c21-42fe-bc76-3277ab3efde4)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateRemoveItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateEditItemForm(objectId: string, source?: string | null, itemId?: string | null, margin?: number | null, wasteFactor?: number | null, quantity?: number | null, uom?: string | null, unitCost?: number | null, uomAbbreviation?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(38938af5-bc21-4443-b709-c628dc0cc930)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (source !== undefined) {
      queryParams.append('source', String(source));
    }
    if (itemId !== undefined) {
      queryParams.append('itemId', String(itemId));
    }
    if (margin !== undefined) {
      queryParams.append('margin', String(margin));
    }
    if (wasteFactor !== undefined) {
      queryParams.append('wasteFactor', String(wasteFactor));
    }
    if (quantity !== undefined) {
      queryParams.append('quantity', String(quantity));
    }
    if (uom !== undefined) {
      queryParams.append('uom', String(uom));
    }
    if (unitCost !== undefined) {
      queryParams.append('unitCost', String(unitCost));
    }
    if (uomAbbreviation !== undefined) {
      queryParams.append('uomAbbreviation', String(uomAbbreviation));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateEditItemAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(38938af5-bc21-4443-b709-c628dc0cc930)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateEditItem(objectId: string, request?: StartEstimateEditItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(38938af5-bc21-4443-b709-c628dc0cc930)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateEditItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateAddFreightForm(objectId: string, itemId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(bb685cfb-802c-4d8a-838d-c8614b5e0b9b)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (itemId !== undefined) {
      queryParams.append('itemId', String(itemId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateAddFreightAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(bb685cfb-802c-4d8a-838d-c8614b5e0b9b)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateAddFreight(objectId: string, request?: StartEstimateAddFreightRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(bb685cfb-802c-4d8a-838d-c8614b5e0b9b)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateAddFreightRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateSetDiscountForm(objectId: string, sales?: number | null, service?: number | null, salesAmount?: number | null, serviceAmount?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(e462ef0a-19e0-481a-80e3-9d0713d6eddc)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (sales !== undefined) {
      queryParams.append('sales', String(sales));
    }
    if (service !== undefined) {
      queryParams.append('service', String(service));
    }
    if (salesAmount !== undefined) {
      queryParams.append('salesAmount', String(salesAmount));
    }
    if (serviceAmount !== undefined) {
      queryParams.append('serviceAmount', String(serviceAmount));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateSetDiscountAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(e462ef0a-19e0-481a-80e3-9d0713d6eddc)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateSetDiscount(objectId: string, request?: StartEstimateSetDiscountRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(e462ef0a-19e0-481a-80e3-9d0713d6eddc)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateSetDiscountRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateAddSectionForm(objectId: string, name?: string | null, content?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(5289c13f-401e-49f0-89f4-a7d3633620f6)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('name', String(name));
    }
    if (content !== undefined) {
      queryParams.append('content', String(content));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateAddSectionAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(5289c13f-401e-49f0-89f4-a7d3633620f6)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateAddSection(objectId: string, request?: StartEstimateAddSectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(5289c13f-401e-49f0-89f4-a7d3633620f6)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateAddSectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateRemoveSectionForm(objectId: string, name?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(490292fd-c7a7-4b74-8406-62961a805030)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('name', String(name));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateRemoveSectionAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(490292fd-c7a7-4b74-8406-62961a805030)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateRemoveSection(objectId: string, request?: StartEstimateRemoveSectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(490292fd-c7a7-4b74-8406-62961a805030)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateRemoveSectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateEditSectionForm(objectId: string, name?: string | null, content?: string | null, contentType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(e92c0285-6d13-4d36-bf75-5d05f871c938)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('name', String(name));
    }
    if (content !== undefined) {
      queryParams.append('content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('contentType', String(contentType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateEditSectionAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(e92c0285-6d13-4d36-bf75-5d05f871c938)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateEditSection(objectId: string, request?: StartEstimateEditSectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(e92c0285-6d13-4d36-bf75-5d05f871c938)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateEditSectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateSignProposalForm(objectId: string, templateId?: string | null, submitterEmail?: string | null, submitterName?: string | null, name?: string | null, submitterRole?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(d1286e4c-0c74-47df-9852-be846eeac5ea)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (templateId !== undefined) {
      queryParams.append('TemplateId', String(templateId));
    }
    if (submitterEmail !== undefined) {
      queryParams.append('SubmitterEmail', String(submitterEmail));
    }
    if (submitterName !== undefined) {
      queryParams.append('SubmitterName', String(submitterName));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (submitterRole !== undefined) {
      queryParams.append('SubmitterRole', String(submitterRole));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateSignProposalAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(d1286e4c-0c74-47df-9852-be846eeac5ea)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateSignProposal(objectId: string, request?: StartEstimateSignProposalRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(d1286e4c-0c74-47df-9852-be846eeac5ea)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateSignProposalRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getEstimateRequestSignatureForm(objectId: string, templateId?: string | null, submitterEmail?: string | null, submitterName?: string | null, name?: string | null, submitterRole?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(a4b6ddde-3d6b-4cd5-8d9f-edb48bd0307a)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (templateId !== undefined) {
      queryParams.append('TemplateId', String(templateId));
    }
    if (submitterEmail !== undefined) {
      queryParams.append('SubmitterEmail', String(submitterEmail));
    }
    if (submitterName !== undefined) {
      queryParams.append('SubmitterName', String(submitterName));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (submitterRole !== undefined) {
      queryParams.append('SubmitterRole', String(submitterRole));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runEstimateRequestSignatureAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(a4b6ddde-3d6b-4cd5-8d9f-edb48bd0307a)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateRequestSignature(objectId: string, request?: StartEstimateRequestSignatureRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(a4b6ddde-3d6b-4cd5-8d9f-edb48bd0307a)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartEstimateRequestSignatureRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async runEstimateDuplicateAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(98442213-298d-4eb3-ba28-d9e60e3493a1)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateDuplicate(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(98442213-298d-4eb3-ba28-d9e60e3493a1)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async runEstimateNewVersionAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(6d17252a-3774-4f26-8bfc-bbda1cf20fa5)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startEstimateNewVersion(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})/UserAction(6d17252a-3774-4f26-8bfc-bbda1cf20fa5)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForEstimate(formName: string, objectId: string, projectExternalId?: string | null, selectionIds?: string[] | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, sessionKey?: string | null, hasWarnings?: boolean | null, totalCost?: number | null, totalPrice?: number | null, totalTax?: number | null, tags?: string[] | null, flowId?: string | null, objectStatusId?: string | null, isActive?: boolean | null, estimateNumber?: string | null, summary?: string | null, version?: number | null, blendedMargin?: number | null, discountPrice?: number | null, discountTax?: number | null, grandTotal?: number | null, grandTax?: number | null, relatedObjects?: Record<string, string> | null, relatedObjectsDocuSeal?: string | null, relatedObjectsSalesforce?: string | null, lineItemsCriteria?: string | null, lineItemsItemId?: string | null, lineItemsMargin?: number | null, lineItemsSku?: string | null, lineItemsSource?: string | null, lineItemsTotalCost?: number | null, lineItemsTotalPrice?: number | null, lineItemsUnitCost?: number | null, lineItemsUnitPrice?: number | null, lineItemsWasteFactor?: number | null, lineItemsActualWasteFactor?: number | null, lineItemsWarnings?: string[] | null, lineItemsTags?: string[] | null, lineItemsDescription?: string | null, lineItemsName?: string | null, lineItemsCostsLocationId?: string | null, lineItemsCostsMinimumQuantity?: number | null, lineItemsCostsPackageCondition?: string | null, lineItemsCostsPriceCriteria?: string | null, lineItemsCostsPromotion?: string | null, lineItemsCostsUom?: string | null, lineItemsCostsUnitCost?: number | null, lineItemsCostsDroppedDate?: string | null, lineItemsCostsEffectiveDate?: string | null, lineItemsCostsPendingDate?: string | null, lineItemsCostsPromotionalEnd?: string | null, lineItemsCostsPromotionalStart?: string | null, lineItemsAdjustedQuantityUom?: string | null, lineItemsAdjustedQuantityUnits?: number | null, lineItemsChildrenDescription?: string | null, lineItemsChildrenName?: string | null, lineItemsChildrenQuantityUom?: string | null, lineItemsChildrenQuantityUnits?: number | null, lineItemsCostLocationId?: string | null, lineItemsCostMinimumQuantity?: number | null, lineItemsCostPackageCondition?: string | null, lineItemsCostPriceCriteria?: string | null, lineItemsCostPromotion?: string | null, lineItemsCostUom?: string | null, lineItemsCostUnitCost?: number | null, lineItemsCostDroppedDate?: string | null, lineItemsCostEffectiveDate?: string | null, lineItemsCostPendingDate?: string | null, lineItemsCostPromotionalEnd?: string | null, lineItemsCostPromotionalStart?: string | null, lineItemsSellingUnitUom?: string | null, lineItemsSellingUnitUnits?: number | null, lineItemsQuantityUom?: string | null, lineItemsQuantityUnits?: number | null, taxLiabilitiesAmount?: number | null, taxLiabilitiesCategory?: string | null, taxLiabilitiesDescription?: string | null, taxLiabilitiesName?: string | null, taxRatesCity?: string | null, taxRatesCreatedOn?: string | null, taxRatesDestination?: boolean | null, taxRatesPostalCode?: string | null, taxRatesState?: string | null, taxRatesId?: string | null, taxRatesTaxLiabilitiesAmount?: number | null, taxRatesTaxLiabilitiesCategory?: string | null, taxRatesTaxLiabilitiesDescription?: string | null, taxRatesTaxLiabilitiesName?: string | null, discountsName?: string | null, discountsDescription?: string | null, discountsEntityId?: string | null, discountsId?: string | null, discountsCreatedOn?: string | null, discountsLastModifiedOn?: string | null, discountsFlowId?: string | null, discountsIsActive?: boolean | null, discountsObjectStatusId?: string | null, discountsPriceDiscount?: number | null, discountsTaxDiscount?: number | null, discountsDiscountsRatesCategory?: string | null, discountsDiscountsRatesRate?: number | null, discountsDiscountsRatesAmount?: number | null, sectionsContent?: string | null, sectionsContentType?: string | null, sectionsName?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (projectExternalId !== undefined) {
      queryParams.append('ProjectExternalId', String(projectExternalId));
    }
    if (selectionIds !== undefined) {
      queryParams.append('Selection Ids', String(selectionIds));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (sessionKey !== undefined) {
      queryParams.append('SessionKey', String(sessionKey));
    }
    if (hasWarnings !== undefined) {
      queryParams.append('HasWarnings', String(hasWarnings));
    }
    if (totalCost !== undefined) {
      queryParams.append('TotalCost', String(totalCost));
    }
    if (totalPrice !== undefined) {
      queryParams.append('TotalPrice', String(totalPrice));
    }
    if (totalTax !== undefined) {
      queryParams.append('TotalTax', String(totalTax));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (estimateNumber !== undefined) {
      queryParams.append('EstimateNumber', String(estimateNumber));
    }
    if (summary !== undefined) {
      queryParams.append('Summary', String(summary));
    }
    if (version !== undefined) {
      queryParams.append('Version', String(version));
    }
    if (blendedMargin !== undefined) {
      queryParams.append('BlendedMargin', String(blendedMargin));
    }
    if (discountPrice !== undefined) {
      queryParams.append('DiscountPrice', String(discountPrice));
    }
    if (discountTax !== undefined) {
      queryParams.append('DiscountTax', String(discountTax));
    }
    if (grandTotal !== undefined) {
      queryParams.append('GrandTotal', String(grandTotal));
    }
    if (grandTax !== undefined) {
      queryParams.append('GrandTax', String(grandTax));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (relatedObjectsDocuSeal !== undefined) {
      queryParams.append('RelatedObjects|DocuSeal', String(relatedObjectsDocuSeal));
    }
    if (relatedObjectsSalesforce !== undefined) {
      queryParams.append('RelatedObjects|Salesforce', String(relatedObjectsSalesforce));
    }
    if (lineItemsCriteria !== undefined) {
      queryParams.append('LineItems|Criteria', String(lineItemsCriteria));
    }
    if (lineItemsItemId !== undefined) {
      queryParams.append('LineItems|ItemId', String(lineItemsItemId));
    }
    if (lineItemsMargin !== undefined) {
      queryParams.append('LineItems|Margin', String(lineItemsMargin));
    }
    if (lineItemsSku !== undefined) {
      queryParams.append('LineItems|SKU', String(lineItemsSku));
    }
    if (lineItemsSource !== undefined) {
      queryParams.append('LineItems|Source', String(lineItemsSource));
    }
    if (lineItemsTotalCost !== undefined) {
      queryParams.append('LineItems|TotalCost', String(lineItemsTotalCost));
    }
    if (lineItemsTotalPrice !== undefined) {
      queryParams.append('LineItems|TotalPrice', String(lineItemsTotalPrice));
    }
    if (lineItemsUnitCost !== undefined) {
      queryParams.append('LineItems|UnitCost', String(lineItemsUnitCost));
    }
    if (lineItemsUnitPrice !== undefined) {
      queryParams.append('LineItems|UnitPrice', String(lineItemsUnitPrice));
    }
    if (lineItemsWasteFactor !== undefined) {
      queryParams.append('LineItems|WasteFactor', String(lineItemsWasteFactor));
    }
    if (lineItemsActualWasteFactor !== undefined) {
      queryParams.append('LineItems|ActualWasteFactor', String(lineItemsActualWasteFactor));
    }
    if (lineItemsWarnings !== undefined) {
      queryParams.append('LineItems|Warnings', String(lineItemsWarnings));
    }
    if (lineItemsTags !== undefined) {
      queryParams.append('LineItems|Tags', String(lineItemsTags));
    }
    if (lineItemsDescription !== undefined) {
      queryParams.append('LineItems|Description', String(lineItemsDescription));
    }
    if (lineItemsName !== undefined) {
      queryParams.append('LineItems|Name', String(lineItemsName));
    }
    if (lineItemsCostsLocationId !== undefined) {
      queryParams.append('LineItems|Costs|LocationId', String(lineItemsCostsLocationId));
    }
    if (lineItemsCostsMinimumQuantity !== undefined) {
      queryParams.append('LineItems|Costs|MinimumQuantity', String(lineItemsCostsMinimumQuantity));
    }
    if (lineItemsCostsPackageCondition !== undefined) {
      queryParams.append('LineItems|Costs|PackageCondition', String(lineItemsCostsPackageCondition));
    }
    if (lineItemsCostsPriceCriteria !== undefined) {
      queryParams.append('LineItems|Costs|PriceCriteria', String(lineItemsCostsPriceCriteria));
    }
    if (lineItemsCostsPromotion !== undefined) {
      queryParams.append('LineItems|Costs|Promotion', String(lineItemsCostsPromotion));
    }
    if (lineItemsCostsUom !== undefined) {
      queryParams.append('LineItems|Costs|UOM', String(lineItemsCostsUom));
    }
    if (lineItemsCostsUnitCost !== undefined) {
      queryParams.append('LineItems|Costs|UnitCost', String(lineItemsCostsUnitCost));
    }
    if (lineItemsCostsDroppedDate !== undefined) {
      queryParams.append('LineItems|Costs|DroppedDate', String(lineItemsCostsDroppedDate));
    }
    if (lineItemsCostsEffectiveDate !== undefined) {
      queryParams.append('LineItems|Costs|EffectiveDate', String(lineItemsCostsEffectiveDate));
    }
    if (lineItemsCostsPendingDate !== undefined) {
      queryParams.append('LineItems|Costs|PendingDate', String(lineItemsCostsPendingDate));
    }
    if (lineItemsCostsPromotionalEnd !== undefined) {
      queryParams.append('LineItems|Costs|PromotionalEnd', String(lineItemsCostsPromotionalEnd));
    }
    if (lineItemsCostsPromotionalStart !== undefined) {
      queryParams.append('LineItems|Costs|PromotionalStart', String(lineItemsCostsPromotionalStart));
    }
    if (lineItemsAdjustedQuantityUom !== undefined) {
      queryParams.append('LineItems|AdjustedQuantity|UOM', String(lineItemsAdjustedQuantityUom));
    }
    if (lineItemsAdjustedQuantityUnits !== undefined) {
      queryParams.append('LineItems|AdjustedQuantity|Units', String(lineItemsAdjustedQuantityUnits));
    }
    if (lineItemsChildrenDescription !== undefined) {
      queryParams.append('LineItems|Children|Description', String(lineItemsChildrenDescription));
    }
    if (lineItemsChildrenName !== undefined) {
      queryParams.append('LineItems|Children|Name', String(lineItemsChildrenName));
    }
    if (lineItemsChildrenQuantityUom !== undefined) {
      queryParams.append('LineItems|Children|Quantity|UOM', String(lineItemsChildrenQuantityUom));
    }
    if (lineItemsChildrenQuantityUnits !== undefined) {
      queryParams.append('LineItems|Children|Quantity|Units', String(lineItemsChildrenQuantityUnits));
    }
    if (lineItemsCostLocationId !== undefined) {
      queryParams.append('LineItems|Cost|LocationId', String(lineItemsCostLocationId));
    }
    if (lineItemsCostMinimumQuantity !== undefined) {
      queryParams.append('LineItems|Cost|MinimumQuantity', String(lineItemsCostMinimumQuantity));
    }
    if (lineItemsCostPackageCondition !== undefined) {
      queryParams.append('LineItems|Cost|PackageCondition', String(lineItemsCostPackageCondition));
    }
    if (lineItemsCostPriceCriteria !== undefined) {
      queryParams.append('LineItems|Cost|PriceCriteria', String(lineItemsCostPriceCriteria));
    }
    if (lineItemsCostPromotion !== undefined) {
      queryParams.append('LineItems|Cost|Promotion', String(lineItemsCostPromotion));
    }
    if (lineItemsCostUom !== undefined) {
      queryParams.append('LineItems|Cost|UOM', String(lineItemsCostUom));
    }
    if (lineItemsCostUnitCost !== undefined) {
      queryParams.append('LineItems|Cost|UnitCost', String(lineItemsCostUnitCost));
    }
    if (lineItemsCostDroppedDate !== undefined) {
      queryParams.append('LineItems|Cost|DroppedDate', String(lineItemsCostDroppedDate));
    }
    if (lineItemsCostEffectiveDate !== undefined) {
      queryParams.append('LineItems|Cost|EffectiveDate', String(lineItemsCostEffectiveDate));
    }
    if (lineItemsCostPendingDate !== undefined) {
      queryParams.append('LineItems|Cost|PendingDate', String(lineItemsCostPendingDate));
    }
    if (lineItemsCostPromotionalEnd !== undefined) {
      queryParams.append('LineItems|Cost|PromotionalEnd', String(lineItemsCostPromotionalEnd));
    }
    if (lineItemsCostPromotionalStart !== undefined) {
      queryParams.append('LineItems|Cost|PromotionalStart', String(lineItemsCostPromotionalStart));
    }
    if (lineItemsSellingUnitUom !== undefined) {
      queryParams.append('LineItems|SellingUnit|UOM', String(lineItemsSellingUnitUom));
    }
    if (lineItemsSellingUnitUnits !== undefined) {
      queryParams.append('LineItems|SellingUnit|Units', String(lineItemsSellingUnitUnits));
    }
    if (lineItemsQuantityUom !== undefined) {
      queryParams.append('LineItems|Quantity|UOM', String(lineItemsQuantityUom));
    }
    if (lineItemsQuantityUnits !== undefined) {
      queryParams.append('LineItems|Quantity|Units', String(lineItemsQuantityUnits));
    }
    if (taxLiabilitiesAmount !== undefined) {
      queryParams.append('TaxLiabilities|Amount', String(taxLiabilitiesAmount));
    }
    if (taxLiabilitiesCategory !== undefined) {
      queryParams.append('TaxLiabilities|Category', String(taxLiabilitiesCategory));
    }
    if (taxLiabilitiesDescription !== undefined) {
      queryParams.append('TaxLiabilities|Description', String(taxLiabilitiesDescription));
    }
    if (taxLiabilitiesName !== undefined) {
      queryParams.append('TaxLiabilities|Name', String(taxLiabilitiesName));
    }
    if (taxRatesCity !== undefined) {
      queryParams.append('TaxRates|City', String(taxRatesCity));
    }
    if (taxRatesCreatedOn !== undefined) {
      queryParams.append('TaxRates|CreatedOn', String(taxRatesCreatedOn));
    }
    if (taxRatesDestination !== undefined) {
      queryParams.append('TaxRates|Destination', String(taxRatesDestination));
    }
    if (taxRatesPostalCode !== undefined) {
      queryParams.append('TaxRates|PostalCode', String(taxRatesPostalCode));
    }
    if (taxRatesState !== undefined) {
      queryParams.append('TaxRates|State', String(taxRatesState));
    }
    if (taxRatesId !== undefined) {
      queryParams.append('TaxRates|_id', String(taxRatesId));
    }
    if (taxRatesTaxLiabilitiesAmount !== undefined) {
      queryParams.append('TaxRates|TaxLiabilities|Amount', String(taxRatesTaxLiabilitiesAmount));
    }
    if (taxRatesTaxLiabilitiesCategory !== undefined) {
      queryParams.append('TaxRates|TaxLiabilities|Category', String(taxRatesTaxLiabilitiesCategory));
    }
    if (taxRatesTaxLiabilitiesDescription !== undefined) {
      queryParams.append('TaxRates|TaxLiabilities|Description', String(taxRatesTaxLiabilitiesDescription));
    }
    if (taxRatesTaxLiabilitiesName !== undefined) {
      queryParams.append('TaxRates|TaxLiabilities|Name', String(taxRatesTaxLiabilitiesName));
    }
    if (discountsName !== undefined) {
      queryParams.append('Discounts|Name', String(discountsName));
    }
    if (discountsDescription !== undefined) {
      queryParams.append('Discounts|Description', String(discountsDescription));
    }
    if (discountsEntityId !== undefined) {
      queryParams.append('Discounts|EntityId', String(discountsEntityId));
    }
    if (discountsId !== undefined) {
      queryParams.append('Discounts|_id', String(discountsId));
    }
    if (discountsCreatedOn !== undefined) {
      queryParams.append('Discounts|CreatedOn', String(discountsCreatedOn));
    }
    if (discountsLastModifiedOn !== undefined) {
      queryParams.append('Discounts|LastModifiedOn', String(discountsLastModifiedOn));
    }
    if (discountsFlowId !== undefined) {
      queryParams.append('Discounts|FlowId', String(discountsFlowId));
    }
    if (discountsIsActive !== undefined) {
      queryParams.append('Discounts|IsActive', String(discountsIsActive));
    }
    if (discountsObjectStatusId !== undefined) {
      queryParams.append('Discounts|ObjectStatusId', String(discountsObjectStatusId));
    }
    if (discountsPriceDiscount !== undefined) {
      queryParams.append('Discounts|PriceDiscount', String(discountsPriceDiscount));
    }
    if (discountsTaxDiscount !== undefined) {
      queryParams.append('Discounts|TaxDiscount', String(discountsTaxDiscount));
    }
    if (discountsDiscountsRatesCategory !== undefined) {
      queryParams.append('Discounts|DiscountsRates|Category', String(discountsDiscountsRatesCategory));
    }
    if (discountsDiscountsRatesRate !== undefined) {
      queryParams.append('Discounts|DiscountsRates|Rate', String(discountsDiscountsRatesRate));
    }
    if (discountsDiscountsRatesAmount !== undefined) {
      queryParams.append('Discounts|DiscountsRates|Amount', String(discountsDiscountsRatesAmount));
    }
    if (sectionsContent !== undefined) {
      queryParams.append('Sections|Content', String(sectionsContent));
    }
    if (sectionsContentType !== undefined) {
      queryParams.append('Sections|ContentType', String(sectionsContentType));
    }
    if (sectionsName !== undefined) {
      queryParams.append('Sections|Name', String(sectionsName));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeEstimate(formName: string, projectExternalId?: string | null, selectionIds?: string[] | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, sessionKey?: string | null, hasWarnings?: boolean | null, totalCost?: number | null, totalPrice?: number | null, totalTax?: number | null, tags?: string[] | null, flowId?: string | null, objectStatusId?: string | null, isActive?: boolean | null, estimateNumber?: string | null, summary?: string | null, version?: number | null, blendedMargin?: number | null, discountPrice?: number | null, discountTax?: number | null, grandTotal?: number | null, grandTax?: number | null, relatedObjects?: Record<string, string> | null, relatedObjectsDocuSeal?: string | null, relatedObjectsSalesforce?: string | null, lineItemsCriteria?: string | null, lineItemsItemId?: string | null, lineItemsMargin?: number | null, lineItemsSku?: string | null, lineItemsSource?: string | null, lineItemsTotalCost?: number | null, lineItemsTotalPrice?: number | null, lineItemsUnitCost?: number | null, lineItemsUnitPrice?: number | null, lineItemsWasteFactor?: number | null, lineItemsActualWasteFactor?: number | null, lineItemsWarnings?: string[] | null, lineItemsTags?: string[] | null, lineItemsDescription?: string | null, lineItemsName?: string | null, lineItemsCostsLocationId?: string | null, lineItemsCostsMinimumQuantity?: number | null, lineItemsCostsPackageCondition?: string | null, lineItemsCostsPriceCriteria?: string | null, lineItemsCostsPromotion?: string | null, lineItemsCostsUom?: string | null, lineItemsCostsUnitCost?: number | null, lineItemsCostsDroppedDate?: string | null, lineItemsCostsEffectiveDate?: string | null, lineItemsCostsPendingDate?: string | null, lineItemsCostsPromotionalEnd?: string | null, lineItemsCostsPromotionalStart?: string | null, lineItemsAdjustedQuantityUom?: string | null, lineItemsAdjustedQuantityUnits?: number | null, lineItemsChildrenDescription?: string | null, lineItemsChildrenName?: string | null, lineItemsChildrenQuantityUom?: string | null, lineItemsChildrenQuantityUnits?: number | null, lineItemsCostLocationId?: string | null, lineItemsCostMinimumQuantity?: number | null, lineItemsCostPackageCondition?: string | null, lineItemsCostPriceCriteria?: string | null, lineItemsCostPromotion?: string | null, lineItemsCostUom?: string | null, lineItemsCostUnitCost?: number | null, lineItemsCostDroppedDate?: string | null, lineItemsCostEffectiveDate?: string | null, lineItemsCostPendingDate?: string | null, lineItemsCostPromotionalEnd?: string | null, lineItemsCostPromotionalStart?: string | null, lineItemsSellingUnitUom?: string | null, lineItemsSellingUnitUnits?: number | null, lineItemsQuantityUom?: string | null, lineItemsQuantityUnits?: number | null, taxLiabilitiesAmount?: number | null, taxLiabilitiesCategory?: string | null, taxLiabilitiesDescription?: string | null, taxLiabilitiesName?: string | null, taxRatesCity?: string | null, taxRatesCreatedOn?: string | null, taxRatesDestination?: boolean | null, taxRatesPostalCode?: string | null, taxRatesState?: string | null, taxRatesId?: string | null, taxRatesTaxLiabilitiesAmount?: number | null, taxRatesTaxLiabilitiesCategory?: string | null, taxRatesTaxLiabilitiesDescription?: string | null, taxRatesTaxLiabilitiesName?: string | null, discountsName?: string | null, discountsDescription?: string | null, discountsEntityId?: string | null, discountsId?: string | null, discountsCreatedOn?: string | null, discountsLastModifiedOn?: string | null, discountsFlowId?: string | null, discountsIsActive?: boolean | null, discountsObjectStatusId?: string | null, discountsPriceDiscount?: number | null, discountsTaxDiscount?: number | null, discountsDiscountsRatesCategory?: string | null, discountsDiscountsRatesRate?: number | null, discountsDiscountsRatesAmount?: number | null, sectionsContent?: string | null, sectionsContentType?: string | null, sectionsName?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Estimate/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (projectExternalId !== undefined) {
      queryParams.append('ProjectExternalId', String(projectExternalId));
    }
    if (selectionIds !== undefined) {
      queryParams.append('Selection Ids', String(selectionIds));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (sessionKey !== undefined) {
      queryParams.append('SessionKey', String(sessionKey));
    }
    if (hasWarnings !== undefined) {
      queryParams.append('HasWarnings', String(hasWarnings));
    }
    if (totalCost !== undefined) {
      queryParams.append('TotalCost', String(totalCost));
    }
    if (totalPrice !== undefined) {
      queryParams.append('TotalPrice', String(totalPrice));
    }
    if (totalTax !== undefined) {
      queryParams.append('TotalTax', String(totalTax));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (estimateNumber !== undefined) {
      queryParams.append('EstimateNumber', String(estimateNumber));
    }
    if (summary !== undefined) {
      queryParams.append('Summary', String(summary));
    }
    if (version !== undefined) {
      queryParams.append('Version', String(version));
    }
    if (blendedMargin !== undefined) {
      queryParams.append('BlendedMargin', String(blendedMargin));
    }
    if (discountPrice !== undefined) {
      queryParams.append('DiscountPrice', String(discountPrice));
    }
    if (discountTax !== undefined) {
      queryParams.append('DiscountTax', String(discountTax));
    }
    if (grandTotal !== undefined) {
      queryParams.append('GrandTotal', String(grandTotal));
    }
    if (grandTax !== undefined) {
      queryParams.append('GrandTax', String(grandTax));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (relatedObjectsDocuSeal !== undefined) {
      queryParams.append('RelatedObjects|DocuSeal', String(relatedObjectsDocuSeal));
    }
    if (relatedObjectsSalesforce !== undefined) {
      queryParams.append('RelatedObjects|Salesforce', String(relatedObjectsSalesforce));
    }
    if (lineItemsCriteria !== undefined) {
      queryParams.append('LineItems|Criteria', String(lineItemsCriteria));
    }
    if (lineItemsItemId !== undefined) {
      queryParams.append('LineItems|ItemId', String(lineItemsItemId));
    }
    if (lineItemsMargin !== undefined) {
      queryParams.append('LineItems|Margin', String(lineItemsMargin));
    }
    if (lineItemsSku !== undefined) {
      queryParams.append('LineItems|SKU', String(lineItemsSku));
    }
    if (lineItemsSource !== undefined) {
      queryParams.append('LineItems|Source', String(lineItemsSource));
    }
    if (lineItemsTotalCost !== undefined) {
      queryParams.append('LineItems|TotalCost', String(lineItemsTotalCost));
    }
    if (lineItemsTotalPrice !== undefined) {
      queryParams.append('LineItems|TotalPrice', String(lineItemsTotalPrice));
    }
    if (lineItemsUnitCost !== undefined) {
      queryParams.append('LineItems|UnitCost', String(lineItemsUnitCost));
    }
    if (lineItemsUnitPrice !== undefined) {
      queryParams.append('LineItems|UnitPrice', String(lineItemsUnitPrice));
    }
    if (lineItemsWasteFactor !== undefined) {
      queryParams.append('LineItems|WasteFactor', String(lineItemsWasteFactor));
    }
    if (lineItemsActualWasteFactor !== undefined) {
      queryParams.append('LineItems|ActualWasteFactor', String(lineItemsActualWasteFactor));
    }
    if (lineItemsWarnings !== undefined) {
      queryParams.append('LineItems|Warnings', String(lineItemsWarnings));
    }
    if (lineItemsTags !== undefined) {
      queryParams.append('LineItems|Tags', String(lineItemsTags));
    }
    if (lineItemsDescription !== undefined) {
      queryParams.append('LineItems|Description', String(lineItemsDescription));
    }
    if (lineItemsName !== undefined) {
      queryParams.append('LineItems|Name', String(lineItemsName));
    }
    if (lineItemsCostsLocationId !== undefined) {
      queryParams.append('LineItems|Costs|LocationId', String(lineItemsCostsLocationId));
    }
    if (lineItemsCostsMinimumQuantity !== undefined) {
      queryParams.append('LineItems|Costs|MinimumQuantity', String(lineItemsCostsMinimumQuantity));
    }
    if (lineItemsCostsPackageCondition !== undefined) {
      queryParams.append('LineItems|Costs|PackageCondition', String(lineItemsCostsPackageCondition));
    }
    if (lineItemsCostsPriceCriteria !== undefined) {
      queryParams.append('LineItems|Costs|PriceCriteria', String(lineItemsCostsPriceCriteria));
    }
    if (lineItemsCostsPromotion !== undefined) {
      queryParams.append('LineItems|Costs|Promotion', String(lineItemsCostsPromotion));
    }
    if (lineItemsCostsUom !== undefined) {
      queryParams.append('LineItems|Costs|UOM', String(lineItemsCostsUom));
    }
    if (lineItemsCostsUnitCost !== undefined) {
      queryParams.append('LineItems|Costs|UnitCost', String(lineItemsCostsUnitCost));
    }
    if (lineItemsCostsDroppedDate !== undefined) {
      queryParams.append('LineItems|Costs|DroppedDate', String(lineItemsCostsDroppedDate));
    }
    if (lineItemsCostsEffectiveDate !== undefined) {
      queryParams.append('LineItems|Costs|EffectiveDate', String(lineItemsCostsEffectiveDate));
    }
    if (lineItemsCostsPendingDate !== undefined) {
      queryParams.append('LineItems|Costs|PendingDate', String(lineItemsCostsPendingDate));
    }
    if (lineItemsCostsPromotionalEnd !== undefined) {
      queryParams.append('LineItems|Costs|PromotionalEnd', String(lineItemsCostsPromotionalEnd));
    }
    if (lineItemsCostsPromotionalStart !== undefined) {
      queryParams.append('LineItems|Costs|PromotionalStart', String(lineItemsCostsPromotionalStart));
    }
    if (lineItemsAdjustedQuantityUom !== undefined) {
      queryParams.append('LineItems|AdjustedQuantity|UOM', String(lineItemsAdjustedQuantityUom));
    }
    if (lineItemsAdjustedQuantityUnits !== undefined) {
      queryParams.append('LineItems|AdjustedQuantity|Units', String(lineItemsAdjustedQuantityUnits));
    }
    if (lineItemsChildrenDescription !== undefined) {
      queryParams.append('LineItems|Children|Description', String(lineItemsChildrenDescription));
    }
    if (lineItemsChildrenName !== undefined) {
      queryParams.append('LineItems|Children|Name', String(lineItemsChildrenName));
    }
    if (lineItemsChildrenQuantityUom !== undefined) {
      queryParams.append('LineItems|Children|Quantity|UOM', String(lineItemsChildrenQuantityUom));
    }
    if (lineItemsChildrenQuantityUnits !== undefined) {
      queryParams.append('LineItems|Children|Quantity|Units', String(lineItemsChildrenQuantityUnits));
    }
    if (lineItemsCostLocationId !== undefined) {
      queryParams.append('LineItems|Cost|LocationId', String(lineItemsCostLocationId));
    }
    if (lineItemsCostMinimumQuantity !== undefined) {
      queryParams.append('LineItems|Cost|MinimumQuantity', String(lineItemsCostMinimumQuantity));
    }
    if (lineItemsCostPackageCondition !== undefined) {
      queryParams.append('LineItems|Cost|PackageCondition', String(lineItemsCostPackageCondition));
    }
    if (lineItemsCostPriceCriteria !== undefined) {
      queryParams.append('LineItems|Cost|PriceCriteria', String(lineItemsCostPriceCriteria));
    }
    if (lineItemsCostPromotion !== undefined) {
      queryParams.append('LineItems|Cost|Promotion', String(lineItemsCostPromotion));
    }
    if (lineItemsCostUom !== undefined) {
      queryParams.append('LineItems|Cost|UOM', String(lineItemsCostUom));
    }
    if (lineItemsCostUnitCost !== undefined) {
      queryParams.append('LineItems|Cost|UnitCost', String(lineItemsCostUnitCost));
    }
    if (lineItemsCostDroppedDate !== undefined) {
      queryParams.append('LineItems|Cost|DroppedDate', String(lineItemsCostDroppedDate));
    }
    if (lineItemsCostEffectiveDate !== undefined) {
      queryParams.append('LineItems|Cost|EffectiveDate', String(lineItemsCostEffectiveDate));
    }
    if (lineItemsCostPendingDate !== undefined) {
      queryParams.append('LineItems|Cost|PendingDate', String(lineItemsCostPendingDate));
    }
    if (lineItemsCostPromotionalEnd !== undefined) {
      queryParams.append('LineItems|Cost|PromotionalEnd', String(lineItemsCostPromotionalEnd));
    }
    if (lineItemsCostPromotionalStart !== undefined) {
      queryParams.append('LineItems|Cost|PromotionalStart', String(lineItemsCostPromotionalStart));
    }
    if (lineItemsSellingUnitUom !== undefined) {
      queryParams.append('LineItems|SellingUnit|UOM', String(lineItemsSellingUnitUom));
    }
    if (lineItemsSellingUnitUnits !== undefined) {
      queryParams.append('LineItems|SellingUnit|Units', String(lineItemsSellingUnitUnits));
    }
    if (lineItemsQuantityUom !== undefined) {
      queryParams.append('LineItems|Quantity|UOM', String(lineItemsQuantityUom));
    }
    if (lineItemsQuantityUnits !== undefined) {
      queryParams.append('LineItems|Quantity|Units', String(lineItemsQuantityUnits));
    }
    if (taxLiabilitiesAmount !== undefined) {
      queryParams.append('TaxLiabilities|Amount', String(taxLiabilitiesAmount));
    }
    if (taxLiabilitiesCategory !== undefined) {
      queryParams.append('TaxLiabilities|Category', String(taxLiabilitiesCategory));
    }
    if (taxLiabilitiesDescription !== undefined) {
      queryParams.append('TaxLiabilities|Description', String(taxLiabilitiesDescription));
    }
    if (taxLiabilitiesName !== undefined) {
      queryParams.append('TaxLiabilities|Name', String(taxLiabilitiesName));
    }
    if (taxRatesCity !== undefined) {
      queryParams.append('TaxRates|City', String(taxRatesCity));
    }
    if (taxRatesCreatedOn !== undefined) {
      queryParams.append('TaxRates|CreatedOn', String(taxRatesCreatedOn));
    }
    if (taxRatesDestination !== undefined) {
      queryParams.append('TaxRates|Destination', String(taxRatesDestination));
    }
    if (taxRatesPostalCode !== undefined) {
      queryParams.append('TaxRates|PostalCode', String(taxRatesPostalCode));
    }
    if (taxRatesState !== undefined) {
      queryParams.append('TaxRates|State', String(taxRatesState));
    }
    if (taxRatesId !== undefined) {
      queryParams.append('TaxRates|_id', String(taxRatesId));
    }
    if (taxRatesTaxLiabilitiesAmount !== undefined) {
      queryParams.append('TaxRates|TaxLiabilities|Amount', String(taxRatesTaxLiabilitiesAmount));
    }
    if (taxRatesTaxLiabilitiesCategory !== undefined) {
      queryParams.append('TaxRates|TaxLiabilities|Category', String(taxRatesTaxLiabilitiesCategory));
    }
    if (taxRatesTaxLiabilitiesDescription !== undefined) {
      queryParams.append('TaxRates|TaxLiabilities|Description', String(taxRatesTaxLiabilitiesDescription));
    }
    if (taxRatesTaxLiabilitiesName !== undefined) {
      queryParams.append('TaxRates|TaxLiabilities|Name', String(taxRatesTaxLiabilitiesName));
    }
    if (discountsName !== undefined) {
      queryParams.append('Discounts|Name', String(discountsName));
    }
    if (discountsDescription !== undefined) {
      queryParams.append('Discounts|Description', String(discountsDescription));
    }
    if (discountsEntityId !== undefined) {
      queryParams.append('Discounts|EntityId', String(discountsEntityId));
    }
    if (discountsId !== undefined) {
      queryParams.append('Discounts|_id', String(discountsId));
    }
    if (discountsCreatedOn !== undefined) {
      queryParams.append('Discounts|CreatedOn', String(discountsCreatedOn));
    }
    if (discountsLastModifiedOn !== undefined) {
      queryParams.append('Discounts|LastModifiedOn', String(discountsLastModifiedOn));
    }
    if (discountsFlowId !== undefined) {
      queryParams.append('Discounts|FlowId', String(discountsFlowId));
    }
    if (discountsIsActive !== undefined) {
      queryParams.append('Discounts|IsActive', String(discountsIsActive));
    }
    if (discountsObjectStatusId !== undefined) {
      queryParams.append('Discounts|ObjectStatusId', String(discountsObjectStatusId));
    }
    if (discountsPriceDiscount !== undefined) {
      queryParams.append('Discounts|PriceDiscount', String(discountsPriceDiscount));
    }
    if (discountsTaxDiscount !== undefined) {
      queryParams.append('Discounts|TaxDiscount', String(discountsTaxDiscount));
    }
    if (discountsDiscountsRatesCategory !== undefined) {
      queryParams.append('Discounts|DiscountsRates|Category', String(discountsDiscountsRatesCategory));
    }
    if (discountsDiscountsRatesRate !== undefined) {
      queryParams.append('Discounts|DiscountsRates|Rate', String(discountsDiscountsRatesRate));
    }
    if (discountsDiscountsRatesAmount !== undefined) {
      queryParams.append('Discounts|DiscountsRates|Amount', String(discountsDiscountsRatesAmount));
    }
    if (sectionsContent !== undefined) {
      queryParams.append('Sections|Content', String(sectionsContent));
    }
    if (sectionsContentType !== undefined) {
      queryParams.append('Sections|ContentType', String(sectionsContentType));
    }
    if (sectionsName !== undefined) {
      queryParams.append('Sections|Name', String(sectionsName));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterEstimate(request?: FilterEstimateRequest | null, options?: { headers?: Record<string, string> }): Promise<Estimate[]> {
    const path = '/app/api/Object/otg.Estimate/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterEstimateRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => EstimateSerializer.fromObject(item));
  }

  async createEstimate(request?: CreateEstimateRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.Estimate';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateEstimateRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateEstimate(objectId: string, request?: UpdateEstimateRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Estimate({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateEstimateRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentEstimate(request?: FilterEstimateRequest | null, options?: { headers?: Record<string, string> }): Promise<Estimate[]> {
    const path = '/app/api/Object/otg.Estimate/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterEstimateRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => EstimateSerializer.fromObject(item));
  }

  async dataViewEstimate(request?: FilterEstimateRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewEstimateResponse> {
    const path = '/app/api/Object/otg.Estimate/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterEstimateRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewEstimateResponseSerializer.fromObject(data);
  }

  async getIndividualContactAddNoteForm(objectId: string, content?: string | null, name?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(45b70320-0072-461b-b3da-08477e956d4b)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runIndividualContactAddNoteAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(45b70320-0072-461b-b3da-08477e956d4b)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startIndividualContactAddNote(objectId: string, request?: StartIndividualContactAddNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(45b70320-0072-461b-b3da-08477e956d4b)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartIndividualContactAddNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getIndividualContactAddTaskForm(objectId: string, dueDate?: string | null, priority?: string | null, name?: string | null, content?: string | null, assignedUserId?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(6020436b-12e1-4d6b-b201-6ce50f353d4a)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (priority !== undefined) {
      queryParams.append('Priority', String(priority));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (assignedUserId !== undefined) {
      queryParams.append('AssignedUserId', String(assignedUserId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runIndividualContactAddTaskAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(6020436b-12e1-4d6b-b201-6ce50f353d4a)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startIndividualContactAddTask(objectId: string, request?: StartIndividualContactAddTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(6020436b-12e1-4d6b-b201-6ce50f353d4a)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartIndividualContactAddTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getIndividualContactAddAppointmentForm(objectId: string, start?: string | null, userId?: string | null, name?: string | null, description?: string | null, message?: string | null, sendEmail?: boolean | null, duration?: string | null, copyAddress?: boolean | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(0ab71aea-c6e7-41ca-9dbb-e5d5f34b6192)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (userId !== undefined) {
      queryParams.append('UserId', String(userId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (message !== undefined) {
      queryParams.append('Message', String(message));
    }
    if (sendEmail !== undefined) {
      queryParams.append('SendEmail', String(sendEmail));
    }
    if (duration !== undefined) {
      queryParams.append('Duration', String(duration));
    }
    if (copyAddress !== undefined) {
      queryParams.append('CopyAddress', String(copyAddress));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runIndividualContactAddAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(0ab71aea-c6e7-41ca-9dbb-e5d5f34b6192)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startIndividualContactAddAppointment(objectId: string, request?: StartIndividualContactAddAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(0ab71aea-c6e7-41ca-9dbb-e5d5f34b6192)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartIndividualContactAddAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getIndividualContactAskSyntheaForm(objectId: string, assistantId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(d206aa20-25a1-4d7d-bee4-3d9b066986a3)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (assistantId !== undefined) {
      queryParams.append('AssistantId', String(assistantId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runIndividualContactAskSyntheaAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(d206aa20-25a1-4d7d-bee4-3d9b066986a3)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startIndividualContactAskSynthea(objectId: string, request?: StartIndividualContactAskSyntheaRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/UserAction(d206aa20-25a1-4d7d-bee4-3d9b066986a3)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartIndividualContactAskSyntheaRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForIndividualContact(formName: string, objectId: string, name?: string | null, parentContactId?: string | null, role?: string | null, flowId?: string | null, objectStatusId?: string | null, tags?: string[] | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, location?: any | null, locationDistance?: any | null, creatorId?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, notes?: string | null, address2?: string | null, phoneNumbersDescription?: string | null, phoneNumbersPhoneNumber?: string | null, phoneNumbersType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (parentContactId !== undefined) {
      queryParams.append('ParentContactId', String(parentContactId));
    }
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (address !== undefined) {
      queryParams.append('Address', String(address));
    }
    if (city !== undefined) {
      queryParams.append('City', String(city));
    }
    if (state !== undefined) {
      queryParams.append('State', String(state));
    }
    if (postalCode !== undefined) {
      queryParams.append('PostalCode', String(postalCode));
    }
    if (country !== undefined) {
      queryParams.append('Country', String(country));
    }
    if (email !== undefined) {
      queryParams.append('Email', String(email));
    }
    if (location !== undefined) {
      queryParams.append('Location', String(location));
    }
    if (locationDistance !== undefined) {
      queryParams.append('LocationDistance', String(locationDistance));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (notes !== undefined) {
      queryParams.append('Notes', String(notes));
    }
    if (address2 !== undefined) {
      queryParams.append('Address2', String(address2));
    }
    if (phoneNumbersDescription !== undefined) {
      queryParams.append('PhoneNumbers|Description', String(phoneNumbersDescription));
    }
    if (phoneNumbersPhoneNumber !== undefined) {
      queryParams.append('PhoneNumbers|PhoneNumber', String(phoneNumbersPhoneNumber));
    }
    if (phoneNumbersType !== undefined) {
      queryParams.append('PhoneNumbers|Type', String(phoneNumbersType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeIndividualContact(formName: string, name?: string | null, parentContactId?: string | null, role?: string | null, flowId?: string | null, objectStatusId?: string | null, tags?: string[] | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, location?: any | null, locationDistance?: any | null, creatorId?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, notes?: string | null, address2?: string | null, phoneNumbersDescription?: string | null, phoneNumbersPhoneNumber?: string | null, phoneNumbersType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.IndividualContact/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (parentContactId !== undefined) {
      queryParams.append('ParentContactId', String(parentContactId));
    }
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (address !== undefined) {
      queryParams.append('Address', String(address));
    }
    if (city !== undefined) {
      queryParams.append('City', String(city));
    }
    if (state !== undefined) {
      queryParams.append('State', String(state));
    }
    if (postalCode !== undefined) {
      queryParams.append('PostalCode', String(postalCode));
    }
    if (country !== undefined) {
      queryParams.append('Country', String(country));
    }
    if (email !== undefined) {
      queryParams.append('Email', String(email));
    }
    if (location !== undefined) {
      queryParams.append('Location', String(location));
    }
    if (locationDistance !== undefined) {
      queryParams.append('LocationDistance', String(locationDistance));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (notes !== undefined) {
      queryParams.append('Notes', String(notes));
    }
    if (address2 !== undefined) {
      queryParams.append('Address2', String(address2));
    }
    if (phoneNumbersDescription !== undefined) {
      queryParams.append('PhoneNumbers|Description', String(phoneNumbersDescription));
    }
    if (phoneNumbersPhoneNumber !== undefined) {
      queryParams.append('PhoneNumbers|PhoneNumber', String(phoneNumbersPhoneNumber));
    }
    if (phoneNumbersType !== undefined) {
      queryParams.append('PhoneNumbers|Type', String(phoneNumbersType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getUpsertFormForTypeIndividualContact(entityId?: string | null, name?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    const path = '/app/api/Object/otg.IndividualContact/Upsert/DataForm';

    const queryParams = new URLSearchParams();
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterIndividualContact(request?: FilterIndividualContactRequest | null, options?: { headers?: Record<string, string> }): Promise<IndividualContact[]> {
    const path = '/app/api/Object/otg.IndividualContact/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterIndividualContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => IndividualContactSerializer.fromObject(item));
  }

  async createIndividualContact(request?: CreateIndividualContactRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.IndividualContact';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateIndividualContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateIndividualContact(objectId: string, request?: UpdateIndividualContactRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.IndividualContact({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateIndividualContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentIndividualContact(request?: FilterIndividualContactRequest | null, options?: { headers?: Record<string, string> }): Promise<IndividualContact[]> {
    const path = '/app/api/Object/otg.IndividualContact/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterIndividualContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => IndividualContactSerializer.fromObject(item));
  }

  async dataViewIndividualContact(request?: FilterIndividualContactRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewIndividualContactResponse> {
    const path = '/app/api/Object/otg.IndividualContact/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterIndividualContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewIndividualContactResponseSerializer.fromObject(data);
  }

  async getFormForLaminatesCatalogItem(formName: string, objectId: string, propertiesLaminatesType?: string | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCarpetType?: string | null, propertiesCollectionName?: string | null, propertiesColorType?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesFiber?: string | null, propertiesInstallationMethod?: string | null, propertiesLength?: string | null, propertiesLinks?: string | null, propertiesPatternMatch?: string | null, propertiesPriceGroup?: number | null, propertiesResilientType?: string | null, propertiesStainResistanceRating?: number | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesWearLayer?: string | null, propertiesWidth?: string | null, propertiesWoodType?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LaminatesCatalogItem({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeLaminatesCatalogItem(formName: string, propertiesLaminatesType?: string | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCarpetType?: string | null, propertiesCollectionName?: string | null, propertiesColorType?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesFiber?: string | null, propertiesInstallationMethod?: string | null, propertiesLength?: string | null, propertiesLinks?: string | null, propertiesPatternMatch?: string | null, propertiesPriceGroup?: number | null, propertiesResilientType?: string | null, propertiesStainResistanceRating?: number | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesWearLayer?: string | null, propertiesWidth?: string | null, propertiesWoodType?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LaminatesCatalogItem/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterLaminatesCatalogItem(request?: FilterLaminatesCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<LaminatesCatalogItem[]> {
    const path = '/app/api/Object/otg.LaminatesCatalogItem/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLaminatesCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => LaminatesCatalogItemSerializer.fromObject(item));
  }

  async recentLaminatesCatalogItem(request?: FilterLaminatesCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<LaminatesCatalogItem[]> {
    const path = '/app/api/Object/otg.LaminatesCatalogItem/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLaminatesCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => LaminatesCatalogItemSerializer.fromObject(item));
  }

  async dataViewLaminatesCatalogItem(request?: FilterLaminatesCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewLaminatesCatalogItemResponse> {
    const path = '/app/api/Object/otg.LaminatesCatalogItem/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLaminatesCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewLaminatesCatalogItemResponseSerializer.fromObject(data);
  }

  async getFormForotgLaminatesCatalogStyle(formName: string, objectId: string, propertiesLaminatesType?: string | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, externalId?: string | null, name?: string | null, description?: string | null, materialType?: string | null, propertiesLinks?: string | null, propertiesCollectionName?: string | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesDemo?: string | null, propertiesWidth?: string | null, propertiesPatternMatch?: string | null, propertiesFiber?: string | null, propertiesDurabilityRating?: number | null, propertiesStainResistanceRating?: number | null, propertiesPriceGroup?: number | null, propertiesCompetitionCrushers?: boolean | null, costRange?: string | null, tags?: string[] | null, id?: string | null, isActive?: boolean | null, catalogFeedId?: string | null, parentsManufacturer?: string | null, count?: number | null, propertiesWoodType?: string | null, propertiesInstallationMethod?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesWearLayer?: string | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LaminatesCatalogStyle({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (costRange !== undefined) {
      queryParams.append('CostRange', String(costRange));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeotgLaminatesCatalogStyle(formName: string, propertiesLaminatesType?: string | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, externalId?: string | null, name?: string | null, description?: string | null, materialType?: string | null, propertiesLinks?: string | null, propertiesCollectionName?: string | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesDemo?: string | null, propertiesWidth?: string | null, propertiesPatternMatch?: string | null, propertiesFiber?: string | null, propertiesDurabilityRating?: number | null, propertiesStainResistanceRating?: number | null, propertiesPriceGroup?: number | null, propertiesCompetitionCrushers?: boolean | null, costRange?: string | null, tags?: string[] | null, id?: string | null, isActive?: boolean | null, catalogFeedId?: string | null, parentsManufacturer?: string | null, count?: number | null, propertiesWoodType?: string | null, propertiesInstallationMethod?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesWearLayer?: string | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LaminatesCatalogStyle/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (costRange !== undefined) {
      queryParams.append('CostRange', String(costRange));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterOtgLaminatesCatalogStyle(request?: FilterOtgLaminatesCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgLaminatesCatalogStyle[]> {
    const path = '/app/api/Object/otg.LaminatesCatalogStyle/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgLaminatesCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgLaminatesCatalogStyleSerializer.fromObject(item));
  }

  async recentOtgLaminatesCatalogStyle(request?: FilterOtgLaminatesCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgLaminatesCatalogStyle[]> {
    const path = '/app/api/Object/otg.LaminatesCatalogStyle/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgLaminatesCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgLaminatesCatalogStyleSerializer.fromObject(item));
  }

  async dataViewOtgLaminatesCatalogStyle(request?: FilterOtgLaminatesCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewOtgLaminatesCatalogStyleResponse> {
    const path = '/app/api/Object/otg.LaminatesCatalogStyle/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgLaminatesCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewOtgLaminatesCatalogStyleResponseSerializer.fromObject(data);
  }

  async getLeadEditNextAppointmentForm(objectId: string, id?: string | null, nextAppoitmentId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(0522eac0-e45a-4b23-9143-431691e4d559)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (nextAppoitmentId !== undefined) {
      queryParams.append('NextAppoitmentId', String(nextAppoitmentId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadEditNextAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(0522eac0-e45a-4b23-9143-431691e4d559)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadEditNextAppointment(objectId: string, request?: StartLeadEditNextAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(0522eac0-e45a-4b23-9143-431691e4d559)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadEditNextAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadTakeSnapshotForm(objectId: string, name?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(f69e0c92-ef52-43d5-bef5-67c4da6466cc)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadTakeSnapshotAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(f69e0c92-ef52-43d5-bef5-67c4da6466cc)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadTakeSnapshot(objectId: string, request?: StartLeadTakeSnapshotRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(f69e0c92-ef52-43d5-bef5-67c4da6466cc)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadTakeSnapshotRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadQueueEmailCampaignForm(objectId: string, name?: string | null, description?: string | null, fromName?: string | null, fromEmail?: string | null, subject?: string | null, toNameField?: string | null, toEmailField?: string | null, unlayerTemplateId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(1267ab56-a588-442b-aaf6-8fb03f2be0d1)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (fromName !== undefined) {
      queryParams.append('FromName', String(fromName));
    }
    if (fromEmail !== undefined) {
      queryParams.append('FromEmail', String(fromEmail));
    }
    if (subject !== undefined) {
      queryParams.append('Subject', String(subject));
    }
    if (toNameField !== undefined) {
      queryParams.append('ToNameField', String(toNameField));
    }
    if (toEmailField !== undefined) {
      queryParams.append('ToEmailField', String(toEmailField));
    }
    if (unlayerTemplateId !== undefined) {
      queryParams.append('UnlayerTemplateId', String(unlayerTemplateId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadQueueEmailCampaignAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(1267ab56-a588-442b-aaf6-8fb03f2be0d1)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadQueueEmailCampaign(objectId: string, request?: StartLeadQueueEmailCampaignRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(1267ab56-a588-442b-aaf6-8fb03f2be0d1)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadQueueEmailCampaignRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadSendOmwsmsForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(cb3039a6-11a3-486a-8322-643c99da6ef7)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadSendOmwsmsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(cb3039a6-11a3-486a-8322-643c99da6ef7)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadSendOmwsms(objectId: string, request?: StartLeadSendOmwsmsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(cb3039a6-11a3-486a-8322-643c99da6ef7)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadSendOmwsmsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadSendRememberMeSmsForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(2828eb9a-53b7-431e-b1c6-3b2fa1e13f18)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadSendRememberMeSmsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(2828eb9a-53b7-431e-b1c6-3b2fa1e13f18)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadSendRememberMeSms(objectId: string, request?: StartLeadSendRememberMeSmsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(2828eb9a-53b7-431e-b1c6-3b2fa1e13f18)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadSendRememberMeSmsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async runLeadScheduleAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(8677f665-a2f2-4b4a-a1f4-3d912edc3a37)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadScheduleAppointment(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(8677f665-a2f2-4b4a-a1f4-3d912edc3a37)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async runLeadGetDirectionsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(a0cf90d0-0915-4112-81e5-a9e9cf32e679)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadGetDirections(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(a0cf90d0-0915-4112-81e5-a9e9cf32e679)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadSendCustomEmailForm(objectId: string, description?: string | null, unlayerTemplateId?: string | null, message?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(b0e4c38c-1ee4-44ab-b857-435af07066a4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (unlayerTemplateId !== undefined) {
      queryParams.append('UnlayerTemplateId', String(unlayerTemplateId));
    }
    if (message !== undefined) {
      queryParams.append('Message', String(message));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadSendCustomEmailAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(b0e4c38c-1ee4-44ab-b857-435af07066a4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadSendCustomEmail(objectId: string, request?: StartLeadSendCustomEmailRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(b0e4c38c-1ee4-44ab-b857-435af07066a4)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadSendCustomEmailRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadCreateTaskForm(objectId: string, description?: string | null, dueDate?: string | null, entityId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(526aa877-501a-4289-b6a2-665fa3ce647e)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadCreateTaskAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(526aa877-501a-4289-b6a2-665fa3ce647e)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadCreateTask(objectId: string, request?: StartLeadCreateTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(526aa877-501a-4289-b6a2-665fa3ce647e)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadCreateTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadStartZappForm(objectId: string, description?: string | null, campaign?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(fd782493-092e-4f8a-b757-aad1b0a2db3d)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (campaign !== undefined) {
      queryParams.append('Campaign', String(campaign));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadStartZappAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(fd782493-092e-4f8a-b757-aad1b0a2db3d)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadStartZapp(objectId: string, request?: StartLeadStartZappRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(fd782493-092e-4f8a-b757-aad1b0a2db3d)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadStartZappRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadAddAppointmentForm(objectId: string, start?: string | null, duration?: string | null, name?: string | null, description?: string | null, content?: string | null, userId?: string | null, projectId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(8597bec6-1408-45d0-bd79-88d0a4c63b13)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (duration !== undefined) {
      queryParams.append('Duration', String(duration));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (userId !== undefined) {
      queryParams.append('UserId', String(userId));
    }
    if (projectId !== undefined) {
      queryParams.append('ProjectId', String(projectId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadAddAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(8597bec6-1408-45d0-bd79-88d0a4c63b13)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadAddAppointment(objectId: string, request?: StartLeadAddAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})/UserAction(8597bec6-1408-45d0-bd79-88d0a4c63b13)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadAddAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForLead(formName: string, objectId: string, id?: string | null, name?: string | null, normalizedPhoneNumber?: string | null, normalizedEmail?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, assignedEntityId?: string | null, nextAppointmentId?: string | null, objectStatusId?: string | null, entityId?: string | null, propertiesHdyhau?: string | null, leadTypeId?: string | null, communicationPreferencesPhone?: string | null, communicationPreferencesSms?: string | null, communicationPreferencesEmail?: string | null, convertedOn?: string | null, isActive?: boolean | null, flowId?: string | null, notes?: string | null, tags?: string[] | null, createdOn?: string | null, lastModifiedOn?: string | null, timeZoneId?: string | null, salesforceLeadId?: any | null, salesforceAccountId?: any | null, location?: any | null, locationDistance?: any | null, service?: string | null, integrationsTag?: string | null, integrationsExternalId?: string | null, integrationsStatus?: string | null, integrationsUrl?: string | null, integrationsIntegrationId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (normalizedPhoneNumber !== undefined) {
      queryParams.append('NormalizedPhoneNumber', String(normalizedPhoneNumber));
    }
    if (normalizedEmail !== undefined) {
      queryParams.append('NormalizedEmail', String(normalizedEmail));
    }
    if (address !== undefined) {
      queryParams.append('Address', String(address));
    }
    if (city !== undefined) {
      queryParams.append('City', String(city));
    }
    if (state !== undefined) {
      queryParams.append('State', String(state));
    }
    if (postalCode !== undefined) {
      queryParams.append('PostalCode', String(postalCode));
    }
    if (country !== undefined) {
      queryParams.append('Country', String(country));
    }
    if (assignedEntityId !== undefined) {
      queryParams.append('AssignedEntityId', String(assignedEntityId));
    }
    if (nextAppointmentId !== undefined) {
      queryParams.append('NextAppointmentId', String(nextAppointmentId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (propertiesHdyhau !== undefined) {
      queryParams.append('Properties|hdyhau', String(propertiesHdyhau));
    }
    if (leadTypeId !== undefined) {
      queryParams.append('LeadTypeId', String(leadTypeId));
    }
    if (communicationPreferencesPhone !== undefined) {
      queryParams.append('CommunicationPreferences|Phone', String(communicationPreferencesPhone));
    }
    if (communicationPreferencesSms !== undefined) {
      queryParams.append('CommunicationPreferences|SMS', String(communicationPreferencesSms));
    }
    if (communicationPreferencesEmail !== undefined) {
      queryParams.append('CommunicationPreferences|Email', String(communicationPreferencesEmail));
    }
    if (convertedOn !== undefined) {
      queryParams.append('ConvertedOn', String(convertedOn));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (notes !== undefined) {
      queryParams.append('Notes', String(notes));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (salesforceLeadId !== undefined) {
      queryParams.append('SalesforceLeadId', String(salesforceLeadId));
    }
    if (salesforceAccountId !== undefined) {
      queryParams.append('SalesforceAccountId', String(salesforceAccountId));
    }
    if (location !== undefined) {
      queryParams.append('Location', String(location));
    }
    if (locationDistance !== undefined) {
      queryParams.append('LocationDistance', String(locationDistance));
    }
    if (service !== undefined) {
      queryParams.append('Service', String(service));
    }
    if (integrationsTag !== undefined) {
      queryParams.append('Integrations|Tag', String(integrationsTag));
    }
    if (integrationsExternalId !== undefined) {
      queryParams.append('Integrations|ExternalId', String(integrationsExternalId));
    }
    if (integrationsStatus !== undefined) {
      queryParams.append('Integrations|Status', String(integrationsStatus));
    }
    if (integrationsUrl !== undefined) {
      queryParams.append('Integrations|Url', String(integrationsUrl));
    }
    if (integrationsIntegrationId !== undefined) {
      queryParams.append('Integrations|IntegrationId', String(integrationsIntegrationId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeLead(formName: string, id?: string | null, name?: string | null, normalizedPhoneNumber?: string | null, normalizedEmail?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, assignedEntityId?: string | null, nextAppointmentId?: string | null, objectStatusId?: string | null, entityId?: string | null, propertiesHdyhau?: string | null, leadTypeId?: string | null, communicationPreferencesPhone?: string | null, communicationPreferencesSms?: string | null, communicationPreferencesEmail?: string | null, convertedOn?: string | null, isActive?: boolean | null, flowId?: string | null, notes?: string | null, tags?: string[] | null, createdOn?: string | null, lastModifiedOn?: string | null, timeZoneId?: string | null, salesforceLeadId?: any | null, salesforceAccountId?: any | null, location?: any | null, locationDistance?: any | null, service?: string | null, integrationsTag?: string | null, integrationsExternalId?: string | null, integrationsStatus?: string | null, integrationsUrl?: string | null, integrationsIntegrationId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Lead/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (normalizedPhoneNumber !== undefined) {
      queryParams.append('NormalizedPhoneNumber', String(normalizedPhoneNumber));
    }
    if (normalizedEmail !== undefined) {
      queryParams.append('NormalizedEmail', String(normalizedEmail));
    }
    if (address !== undefined) {
      queryParams.append('Address', String(address));
    }
    if (city !== undefined) {
      queryParams.append('City', String(city));
    }
    if (state !== undefined) {
      queryParams.append('State', String(state));
    }
    if (postalCode !== undefined) {
      queryParams.append('PostalCode', String(postalCode));
    }
    if (country !== undefined) {
      queryParams.append('Country', String(country));
    }
    if (assignedEntityId !== undefined) {
      queryParams.append('AssignedEntityId', String(assignedEntityId));
    }
    if (nextAppointmentId !== undefined) {
      queryParams.append('NextAppointmentId', String(nextAppointmentId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (propertiesHdyhau !== undefined) {
      queryParams.append('Properties|hdyhau', String(propertiesHdyhau));
    }
    if (leadTypeId !== undefined) {
      queryParams.append('LeadTypeId', String(leadTypeId));
    }
    if (communicationPreferencesPhone !== undefined) {
      queryParams.append('CommunicationPreferences|Phone', String(communicationPreferencesPhone));
    }
    if (communicationPreferencesSms !== undefined) {
      queryParams.append('CommunicationPreferences|SMS', String(communicationPreferencesSms));
    }
    if (communicationPreferencesEmail !== undefined) {
      queryParams.append('CommunicationPreferences|Email', String(communicationPreferencesEmail));
    }
    if (convertedOn !== undefined) {
      queryParams.append('ConvertedOn', String(convertedOn));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (notes !== undefined) {
      queryParams.append('Notes', String(notes));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (salesforceLeadId !== undefined) {
      queryParams.append('SalesforceLeadId', String(salesforceLeadId));
    }
    if (salesforceAccountId !== undefined) {
      queryParams.append('SalesforceAccountId', String(salesforceAccountId));
    }
    if (location !== undefined) {
      queryParams.append('Location', String(location));
    }
    if (locationDistance !== undefined) {
      queryParams.append('LocationDistance', String(locationDistance));
    }
    if (service !== undefined) {
      queryParams.append('Service', String(service));
    }
    if (integrationsTag !== undefined) {
      queryParams.append('Integrations|Tag', String(integrationsTag));
    }
    if (integrationsExternalId !== undefined) {
      queryParams.append('Integrations|ExternalId', String(integrationsExternalId));
    }
    if (integrationsStatus !== undefined) {
      queryParams.append('Integrations|Status', String(integrationsStatus));
    }
    if (integrationsUrl !== undefined) {
      queryParams.append('Integrations|Url', String(integrationsUrl));
    }
    if (integrationsIntegrationId !== undefined) {
      queryParams.append('Integrations|IntegrationId', String(integrationsIntegrationId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterLead(request?: FilterLeadRequest | null, options?: { headers?: Record<string, string> }): Promise<Lead[]> {
    const path = '/app/api/Object/otg.Lead/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => LeadSerializer.fromObject(item));
  }

  async createLead(request?: CreateLeadRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.Lead';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateLeadRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateLead(objectId: string, request?: UpdateLeadRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Lead({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateLeadRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentLead(request?: FilterLeadRequest | null, options?: { headers?: Record<string, string> }): Promise<Lead[]> {
    const path = '/app/api/Object/otg.Lead/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => LeadSerializer.fromObject(item));
  }

  async dataViewLead(request?: FilterLeadRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewLeadResponse> {
    const path = '/app/api/Object/otg.Lead/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewLeadResponseSerializer.fromObject(data);
  }

  async getLeadAppointmentSendCustomAppointmentConfirmationEmailForm(objectId: string, unlayerTemplateId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (unlayerTemplateId !== undefined) {
      queryParams.append('UnlayerTemplateId', String(unlayerTemplateId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadAppointmentSendCustomAppointmentConfirmationEmailAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadAppointmentSendCustomAppointmentConfirmationEmail(objectId: string, request?: StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadAppointmentSendAppointmentConfirmationEmailForm(objectId: string, description?: string | null, unlayerTemplateId?: string | null, message?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (unlayerTemplateId !== undefined) {
      queryParams.append('UnlayerTemplateId', String(unlayerTemplateId));
    }
    if (message !== undefined) {
      queryParams.append('Message', String(message));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadAppointmentSendAppointmentConfirmationEmailAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadAppointmentSendAppointmentConfirmationEmail(objectId: string, request?: StartLeadAppointmentSendAppointmentConfirmationEmailRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadAppointmentSendAppointmentConfirmationEmailRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadAppointmentSendOmwsmsForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadAppointmentSendOmwsmsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadAppointmentSendOmwsms(objectId: string, request?: StartLeadAppointmentSendOmwsmsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadAppointmentSendOmwsmsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadAppointmentSendUpcomingAppointmentReminderForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadAppointmentSendUpcomingAppointmentReminderAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadAppointmentSendUpcomingAppointmentReminder(objectId: string, request?: StartLeadAppointmentSendUpcomingAppointmentReminderRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadAppointmentSendUpcomingAppointmentReminderRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async runLeadAppointmentInitiateCallWithOpenPhoneAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(d53bd8ec-69fa-4983-9a79-831ebf904b5e)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadAppointmentInitiateCallWithOpenPhone(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(d53bd8ec-69fa-4983-9a79-831ebf904b5e)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadAppointmentInitiateOmwsmsForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadAppointmentInitiateOmwsmsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadAppointmentInitiateOmwsms(objectId: string, request?: StartLeadAppointmentInitiateOmwsmsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadAppointmentInitiateOmwsmsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadAppointmentInitiateSmsForUpcomingApppointmentForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadAppointmentInitiateSmsForUpcomingApppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadAppointmentInitiateSmsForUpcomingApppointment(objectId: string, request?: StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getLeadAppointmentCancelAppointmentForm(objectId: string, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runLeadAppointmentCancelAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startLeadAppointmentCancelAppointment(objectId: string, request?: StartLeadAppointmentCancelAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartLeadAppointmentCancelAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForLeadAppointment(formName: string, objectId: string, parentObjectId?: string | null, leadId?: string | null, end?: string | null, isAllDay?: boolean | null, start?: string | null, timeZoneId?: string | null, organizationId?: string | null, refsO365Event?: string | null, refsSfServiceAppointment?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, appointmentTypeId?: string | null, cancelledBy?: string | null, cancelledOn?: string | null, replacedById?: string | null, tool?: string | null, addressAddress?: string | null, addressCity?: string | null, addressCountry?: string | null, addressLocation?: any | null, addressPostalCode?: string | null, addressState?: string | null, addressAddress2?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadAppointment({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (leadId !== undefined) {
      queryParams.append('LeadId', String(leadId));
    }
    if (end !== undefined) {
      queryParams.append('End', String(end));
    }
    if (isAllDay !== undefined) {
      queryParams.append('IsAllDay', String(isAllDay));
    }
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (organizationId !== undefined) {
      queryParams.append('OrganizationId', String(organizationId));
    }
    if (refsO365Event !== undefined) {
      queryParams.append('Refs|o365_Event', String(refsO365Event));
    }
    if (refsSfServiceAppointment !== undefined) {
      queryParams.append('Refs|sf_ServiceAppointment', String(refsSfServiceAppointment));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (appointmentTypeId !== undefined) {
      queryParams.append('AppointmentTypeId', String(appointmentTypeId));
    }
    if (cancelledBy !== undefined) {
      queryParams.append('CancelledBy', String(cancelledBy));
    }
    if (cancelledOn !== undefined) {
      queryParams.append('CancelledOn', String(cancelledOn));
    }
    if (replacedById !== undefined) {
      queryParams.append('ReplacedById', String(replacedById));
    }
    if (tool !== undefined) {
      queryParams.append('Tool', String(tool));
    }
    if (addressAddress !== undefined) {
      queryParams.append('Address|Address', String(addressAddress));
    }
    if (addressCity !== undefined) {
      queryParams.append('Address|City', String(addressCity));
    }
    if (addressCountry !== undefined) {
      queryParams.append('Address|Country', String(addressCountry));
    }
    if (addressLocation !== undefined) {
      queryParams.append('Address|Location', String(addressLocation));
    }
    if (addressPostalCode !== undefined) {
      queryParams.append('Address|PostalCode', String(addressPostalCode));
    }
    if (addressState !== undefined) {
      queryParams.append('Address|State', String(addressState));
    }
    if (addressAddress2 !== undefined) {
      queryParams.append('Address|Address2', String(addressAddress2));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeLeadAppointment(formName: string, parentObjectId?: string | null, leadId?: string | null, end?: string | null, isAllDay?: boolean | null, start?: string | null, timeZoneId?: string | null, organizationId?: string | null, refsO365Event?: string | null, refsSfServiceAppointment?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, appointmentTypeId?: string | null, cancelledBy?: string | null, cancelledOn?: string | null, replacedById?: string | null, tool?: string | null, addressAddress?: string | null, addressCity?: string | null, addressCountry?: string | null, addressLocation?: any | null, addressPostalCode?: string | null, addressState?: string | null, addressAddress2?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadAppointment/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (leadId !== undefined) {
      queryParams.append('LeadId', String(leadId));
    }
    if (end !== undefined) {
      queryParams.append('End', String(end));
    }
    if (isAllDay !== undefined) {
      queryParams.append('IsAllDay', String(isAllDay));
    }
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (organizationId !== undefined) {
      queryParams.append('OrganizationId', String(organizationId));
    }
    if (refsO365Event !== undefined) {
      queryParams.append('Refs|o365_Event', String(refsO365Event));
    }
    if (refsSfServiceAppointment !== undefined) {
      queryParams.append('Refs|sf_ServiceAppointment', String(refsSfServiceAppointment));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (appointmentTypeId !== undefined) {
      queryParams.append('AppointmentTypeId', String(appointmentTypeId));
    }
    if (cancelledBy !== undefined) {
      queryParams.append('CancelledBy', String(cancelledBy));
    }
    if (cancelledOn !== undefined) {
      queryParams.append('CancelledOn', String(cancelledOn));
    }
    if (replacedById !== undefined) {
      queryParams.append('ReplacedById', String(replacedById));
    }
    if (tool !== undefined) {
      queryParams.append('Tool', String(tool));
    }
    if (addressAddress !== undefined) {
      queryParams.append('Address|Address', String(addressAddress));
    }
    if (addressCity !== undefined) {
      queryParams.append('Address|City', String(addressCity));
    }
    if (addressCountry !== undefined) {
      queryParams.append('Address|Country', String(addressCountry));
    }
    if (addressLocation !== undefined) {
      queryParams.append('Address|Location', String(addressLocation));
    }
    if (addressPostalCode !== undefined) {
      queryParams.append('Address|PostalCode', String(addressPostalCode));
    }
    if (addressState !== undefined) {
      queryParams.append('Address|State', String(addressState));
    }
    if (addressAddress2 !== undefined) {
      queryParams.append('Address|Address2', String(addressAddress2));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterLeadAppointment(request?: FilterLeadAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<LeadAppointment[]> {
    const path = '/app/api/Object/otg.LeadAppointment/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => LeadAppointmentSerializer.fromObject(item));
  }

  async recentLeadAppointment(request?: FilterLeadAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<LeadAppointment[]> {
    const path = '/app/api/Object/otg.LeadAppointment/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => LeadAppointmentSerializer.fromObject(item));
  }

  async dataViewLeadAppointment(request?: FilterLeadAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewLeadAppointmentResponse> {
    const path = '/app/api/Object/otg.LeadAppointment/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewLeadAppointmentResponseSerializer.fromObject(data);
  }

  async getFormForLeadNote(formName: string, objectId: string, parentObjectId?: string | null, flowId?: string | null, objectStatusId?: string | null, content?: string | null, description?: string | null, name?: string | null, t?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadNote({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeLeadNote(formName: string, parentObjectId?: string | null, flowId?: string | null, objectStatusId?: string | null, content?: string | null, description?: string | null, name?: string | null, t?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.LeadNote/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterLeadNote(request?: FilterLeadNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<LeadNote[]> {
    const path = '/app/api/Object/otg.LeadNote/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => LeadNoteSerializer.fromObject(item));
  }

  async createLeadNote(request?: CreateLeadNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.LeadNote';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateLeadNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateLeadNote(objectId: string, request?: UpdateLeadNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.LeadNote({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateLeadNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentLeadNote(request?: FilterLeadNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<LeadNote[]> {
    const path = '/app/api/Object/otg.LeadNote/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => LeadNoteSerializer.fromObject(item));
  }

  async dataViewLeadNote(request?: FilterLeadNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewLeadNoteResponse> {
    const path = '/app/api/Object/otg.LeadNote/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewLeadNoteResponseSerializer.fromObject(data);
  }

  async getFormForNote(formName: string, objectId: string, parentObjectType?: string | null, t?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Note({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeNote(formName: string, parentObjectType?: string | null, t?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Note/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterNote(request?: FilterNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<Note[]> {
    const path = '/app/api/Object/otg.Note/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => NoteSerializer.fromObject(item));
  }

  async updateNote(objectId: string, request?: UpdateNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Note({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentNote(request?: FilterNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<Note[]> {
    const path = '/app/api/Object/otg.Note/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => NoteSerializer.fromObject(item));
  }

  async dataViewNote(request?: FilterNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewNoteResponse> {
    const path = '/app/api/Object/otg.Note/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewNoteResponseSerializer.fromObject(data);
  }

  async getObjectFileAskSyntheaForm(objectId: string, assistantId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ObjectFile({objectId})/UserAction(e9d9a884-e399-4cb2-8aef-68c350fe96b4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (assistantId !== undefined) {
      queryParams.append('AssistantId', String(assistantId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runObjectFileAskSyntheaAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ObjectFile({objectId})/UserAction(e9d9a884-e399-4cb2-8aef-68c350fe96b4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startObjectFileAskSynthea(objectId: string, request?: StartObjectFileAskSyntheaRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ObjectFile({objectId})/UserAction(e9d9a884-e399-4cb2-8aef-68c350fe96b4)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartObjectFileAskSyntheaRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForObjectFile(formName: string, objectId: string, contentType?: string | null, size?: number | null, publicUrl?: string | null, allowAnonymousDownload?: boolean | null, flowId?: string | null, objectStatusId?: string | null, t?: string | null, name?: string | null, absoluteUri?: string | null, parentId?: string | null, createdBy?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, parentObjectId?: string | null, parentObjectType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ObjectFile({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (size !== undefined) {
      queryParams.append('Size', String(size));
    }
    if (publicUrl !== undefined) {
      queryParams.append('PublicUrl', String(publicUrl));
    }
    if (allowAnonymousDownload !== undefined) {
      queryParams.append('AllowAnonymousDownload', String(allowAnonymousDownload));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (absoluteUri !== undefined) {
      queryParams.append('AbsoluteUri', String(absoluteUri));
    }
    if (parentId !== undefined) {
      queryParams.append('ParentId', String(parentId));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeObjectFile(formName: string, contentType?: string | null, size?: number | null, publicUrl?: string | null, allowAnonymousDownload?: boolean | null, flowId?: string | null, objectStatusId?: string | null, t?: string | null, name?: string | null, absoluteUri?: string | null, parentId?: string | null, createdBy?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, parentObjectId?: string | null, parentObjectType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ObjectFile/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (size !== undefined) {
      queryParams.append('Size', String(size));
    }
    if (publicUrl !== undefined) {
      queryParams.append('PublicUrl', String(publicUrl));
    }
    if (allowAnonymousDownload !== undefined) {
      queryParams.append('AllowAnonymousDownload', String(allowAnonymousDownload));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (absoluteUri !== undefined) {
      queryParams.append('AbsoluteUri', String(absoluteUri));
    }
    if (parentId !== undefined) {
      queryParams.append('ParentId', String(parentId));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterObjectFile(request?: FilterObjectFileRequest | null, options?: { headers?: Record<string, string> }): Promise<ObjectFile[]> {
    const path = '/app/api/Object/otg.ObjectFile/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectFileRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ObjectFileSerializer.fromObject(item));
  }

  async recentObjectFile(request?: FilterObjectFileRequest | null, options?: { headers?: Record<string, string> }): Promise<ObjectFile[]> {
    const path = '/app/api/Object/otg.ObjectFile/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectFileRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ObjectFileSerializer.fromObject(item));
  }

  async dataViewObjectFile(request?: FilterObjectFileRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewObjectFileResponse> {
    const path = '/app/api/Object/otg.ObjectFile/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectFileRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewObjectFileResponseSerializer.fromObject(data);
  }

  async getProjectAppointmentSendCustomAppointmentConfirmationEmailForm(objectId: string, unlayerTemplateId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (unlayerTemplateId !== undefined) {
      queryParams.append('UnlayerTemplateId', String(unlayerTemplateId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAppointmentSendCustomAppointmentConfirmationEmailAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAppointmentSendCustomAppointmentConfirmationEmail(objectId: string, request?: StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(b1a3f1ab-0666-49a5-a3a6-ee419fc888fe)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectAppointmentSendAppointmentConfirmationEmailForm(objectId: string, description?: string | null, unlayerTemplateId?: string | null, message?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (unlayerTemplateId !== undefined) {
      queryParams.append('UnlayerTemplateId', String(unlayerTemplateId));
    }
    if (message !== undefined) {
      queryParams.append('Message', String(message));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAppointmentSendAppointmentConfirmationEmailAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAppointmentSendAppointmentConfirmationEmail(objectId: string, request?: StartProjectAppointmentSendAppointmentConfirmationEmailRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(f1de146a-64a6-4895-84ac-1362613ba34c)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAppointmentSendAppointmentConfirmationEmailRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectAppointmentSendOmwsmsForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAppointmentSendOmwsmsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAppointmentSendOmwsms(objectId: string, request?: StartProjectAppointmentSendOmwsmsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(2e8f1aa3-6d5f-449f-8036-141782333508)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAppointmentSendOmwsmsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectAppointmentSendUpcomingAppointmentReminderForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAppointmentSendUpcomingAppointmentReminderAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAppointmentSendUpcomingAppointmentReminder(objectId: string, request?: StartProjectAppointmentSendUpcomingAppointmentReminderRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(bf2ea2a0-f5b1-4781-ac85-11a001dfabfe)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAppointmentSendUpcomingAppointmentReminderRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async runProjectAppointmentInitiateCallWithOpenPhoneAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(d53bd8ec-69fa-4983-9a79-831ebf904b5e)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAppointmentInitiateCallWithOpenPhone(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(d53bd8ec-69fa-4983-9a79-831ebf904b5e)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectAppointmentInitiateOmwsmsForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAppointmentInitiateOmwsmsAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAppointmentInitiateOmwsms(objectId: string, request?: StartProjectAppointmentInitiateOmwsmsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(f277675f-15a9-45c5-a226-b5f5ea382252)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAppointmentInitiateOmwsmsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectAppointmentInitiateSmsForUpcomingApppointmentForm(objectId: string, phoneNumber?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (phoneNumber !== undefined) {
      queryParams.append('PhoneNumber', String(phoneNumber));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAppointmentInitiateSmsForUpcomingApppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAppointmentInitiateSmsForUpcomingApppointment(objectId: string, request?: StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(853b8829-05d3-4404-ab5a-ec6db57e5f57)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectAppointmentCancelAppointmentForm(objectId: string, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAppointmentCancelAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAppointmentCancelAppointment(objectId: string, request?: StartProjectAppointmentCancelAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/UserAction(b040f39b-555a-4ca4-9f15-16859e3629c0)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAppointmentCancelAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForProjectAppointment(formName: string, objectId: string, parentObjectId?: string | null, leadId?: string | null, end?: string | null, isAllDay?: boolean | null, start?: string | null, timeZoneId?: string | null, organizationId?: string | null, refsO365Event?: string | null, refsSfServiceAppointment?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, appointmentTypeId?: string | null, cancelledBy?: string | null, cancelledOn?: string | null, replacedById?: string | null, tool?: string | null, addressAddress?: string | null, addressCity?: string | null, addressCountry?: string | null, addressLocation?: any | null, addressPostalCode?: string | null, addressState?: string | null, addressAddress2?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectAppointment({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (leadId !== undefined) {
      queryParams.append('LeadId', String(leadId));
    }
    if (end !== undefined) {
      queryParams.append('End', String(end));
    }
    if (isAllDay !== undefined) {
      queryParams.append('IsAllDay', String(isAllDay));
    }
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (organizationId !== undefined) {
      queryParams.append('OrganizationId', String(organizationId));
    }
    if (refsO365Event !== undefined) {
      queryParams.append('Refs|o365_Event', String(refsO365Event));
    }
    if (refsSfServiceAppointment !== undefined) {
      queryParams.append('Refs|sf_ServiceAppointment', String(refsSfServiceAppointment));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (appointmentTypeId !== undefined) {
      queryParams.append('AppointmentTypeId', String(appointmentTypeId));
    }
    if (cancelledBy !== undefined) {
      queryParams.append('CancelledBy', String(cancelledBy));
    }
    if (cancelledOn !== undefined) {
      queryParams.append('CancelledOn', String(cancelledOn));
    }
    if (replacedById !== undefined) {
      queryParams.append('ReplacedById', String(replacedById));
    }
    if (tool !== undefined) {
      queryParams.append('Tool', String(tool));
    }
    if (addressAddress !== undefined) {
      queryParams.append('Address|Address', String(addressAddress));
    }
    if (addressCity !== undefined) {
      queryParams.append('Address|City', String(addressCity));
    }
    if (addressCountry !== undefined) {
      queryParams.append('Address|Country', String(addressCountry));
    }
    if (addressLocation !== undefined) {
      queryParams.append('Address|Location', String(addressLocation));
    }
    if (addressPostalCode !== undefined) {
      queryParams.append('Address|PostalCode', String(addressPostalCode));
    }
    if (addressState !== undefined) {
      queryParams.append('Address|State', String(addressState));
    }
    if (addressAddress2 !== undefined) {
      queryParams.append('Address|Address2', String(addressAddress2));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeProjectAppointment(formName: string, parentObjectId?: string | null, leadId?: string | null, end?: string | null, isAllDay?: boolean | null, start?: string | null, timeZoneId?: string | null, organizationId?: string | null, refsO365Event?: string | null, refsSfServiceAppointment?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, appointmentTypeId?: string | null, cancelledBy?: string | null, cancelledOn?: string | null, replacedById?: string | null, tool?: string | null, addressAddress?: string | null, addressCity?: string | null, addressCountry?: string | null, addressLocation?: any | null, addressPostalCode?: string | null, addressState?: string | null, addressAddress2?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectAppointment/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (leadId !== undefined) {
      queryParams.append('LeadId', String(leadId));
    }
    if (end !== undefined) {
      queryParams.append('End', String(end));
    }
    if (isAllDay !== undefined) {
      queryParams.append('IsAllDay', String(isAllDay));
    }
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (organizationId !== undefined) {
      queryParams.append('OrganizationId', String(organizationId));
    }
    if (refsO365Event !== undefined) {
      queryParams.append('Refs|o365_Event', String(refsO365Event));
    }
    if (refsSfServiceAppointment !== undefined) {
      queryParams.append('Refs|sf_ServiceAppointment', String(refsSfServiceAppointment));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (appointmentTypeId !== undefined) {
      queryParams.append('AppointmentTypeId', String(appointmentTypeId));
    }
    if (cancelledBy !== undefined) {
      queryParams.append('CancelledBy', String(cancelledBy));
    }
    if (cancelledOn !== undefined) {
      queryParams.append('CancelledOn', String(cancelledOn));
    }
    if (replacedById !== undefined) {
      queryParams.append('ReplacedById', String(replacedById));
    }
    if (tool !== undefined) {
      queryParams.append('Tool', String(tool));
    }
    if (addressAddress !== undefined) {
      queryParams.append('Address|Address', String(addressAddress));
    }
    if (addressCity !== undefined) {
      queryParams.append('Address|City', String(addressCity));
    }
    if (addressCountry !== undefined) {
      queryParams.append('Address|Country', String(addressCountry));
    }
    if (addressLocation !== undefined) {
      queryParams.append('Address|Location', String(addressLocation));
    }
    if (addressPostalCode !== undefined) {
      queryParams.append('Address|PostalCode', String(addressPostalCode));
    }
    if (addressState !== undefined) {
      queryParams.append('Address|State', String(addressState));
    }
    if (addressAddress2 !== undefined) {
      queryParams.append('Address|Address2', String(addressAddress2));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterProjectAppointment(request?: FilterProjectAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<ProjectAppointment[]> {
    const path = '/app/api/Object/otg.ProjectAppointment/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProjectAppointmentSerializer.fromObject(item));
  }

  async recentProjectAppointment(request?: FilterProjectAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<ProjectAppointment[]> {
    const path = '/app/api/Object/otg.ProjectAppointment/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProjectAppointmentSerializer.fromObject(item));
  }

  async dataViewProjectAppointment(request?: FilterProjectAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewProjectAppointmentResponse> {
    const path = '/app/api/Object/otg.ProjectAppointment/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewProjectAppointmentResponseSerializer.fromObject(data);
  }

  async getFormForProjectNote(formName: string, objectId: string, parentObjectId?: string | null, flowId?: string | null, objectStatusId?: string | null, content?: string | null, description?: string | null, name?: string | null, t?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectNote({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeProjectNote(formName: string, parentObjectId?: string | null, flowId?: string | null, objectStatusId?: string | null, content?: string | null, description?: string | null, name?: string | null, t?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectNote/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterProjectNote(request?: FilterProjectNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<ProjectNote[]> {
    const path = '/app/api/Object/otg.ProjectNote/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProjectNoteSerializer.fromObject(item));
  }

  async createProjectNote(request?: CreateProjectNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.ProjectNote';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateProjectNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateProjectNote(objectId: string, request?: UpdateProjectNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectNote({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateProjectNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentProjectNote(request?: FilterProjectNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<ProjectNote[]> {
    const path = '/app/api/Object/otg.ProjectNote/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProjectNoteSerializer.fromObject(item));
  }

  async dataViewProjectNote(request?: FilterProjectNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewProjectNoteResponse> {
    const path = '/app/api/Object/otg.ProjectNote/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewProjectNoteResponseSerializer.fromObject(data);
  }

  async getFormForProjectSelection(formName: string, objectId: string, itemIds?: string[] | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, parentObjectId?: string | null, parentObjectType?: string | null, selectionBinsDescription?: string | null, selectionBinsItemIds?: string[] | null, selectionBinsName?: string | null, selectionBinsRooms?: string[] | null, selectionBinsRoomSelectionInstallationTypeId?: string | null, selectionBinsRoomSelectionProductType?: string | null, selectionBinsRoomSelectionPatternTypeId?: string | null, selectionBinsRoomSelectionTrimWorkId?: string | null, selectionBinsRoomSelectionUnderlaymentId?: string | null, selectionBinsRoomSelectionCatalogFeedId?: string | null, selectionBinsRoomSelectionItemId?: string | null, selectionBinsRoomSelectionStyleNumber?: string | null, selectionBinsRoomSelectionBin?: string | null, selectionBinsRoomSelectionProjectExternalId?: string | null, selectionBinsRoomSelectionRoomIds?: string[] | null, selectionBinsRoomSelectionName?: string | null, selectionBinsRoomSelectionDescription?: string | null, selectionBinsRoomSelectionEntityId?: string | null, selectionBinsRoomSelectionId?: string | null, selectionBinsRoomSelectionCreatedOn?: string | null, selectionBinsRoomSelectionCreatedBy?: string | null, selectionBinsRoomSelectionWasteFactor?: number | null, selectionBinsRoomSelectionBinId?: string | null, selectionBinsRoomSelectionSessionKey?: string | null, selectionBinsRoomSelectionHash?: string | null, selectionBinsRoomSelectionHasWarnings?: boolean | null, selectionBinsRoomSelectionTotalCost?: number | null, selectionBinsRoomSelectionTotalPrice?: number | null, selectionBinsRoomSelectionTotalTax?: number | null, selectionBinsRoomSelectionFlowId?: string | null, selectionBinsRoomSelectionIsActive?: boolean | null, selectionBinsRoomSelectionObjectStatusId?: string | null, selectionBinsRoomSelectionAreaUom?: string | null, selectionBinsRoomSelectionAreaUnits?: number | null, selectionBinsRoomSelectionMainProductQuantityUom?: string | null, selectionBinsRoomSelectionMainProductQuantityUnits?: number | null, selectionBinsRoomSelectionPerimeterUom?: string | null, selectionBinsRoomSelectionPerimeterUnits?: number | null, selectionBinsRoomSelectionLineItemsCriteria?: string | null, selectionBinsRoomSelectionLineItemsItemId?: string | null, selectionBinsRoomSelectionLineItemsMargin?: number | null, selectionBinsRoomSelectionLineItemsSku?: string | null, selectionBinsRoomSelectionLineItemsSource?: string | null, selectionBinsRoomSelectionLineItemsTotalCost?: number | null, selectionBinsRoomSelectionLineItemsTotalPrice?: number | null, selectionBinsRoomSelectionLineItemsUnitCost?: number | null, selectionBinsRoomSelectionLineItemsUnitPrice?: number | null, selectionBinsRoomSelectionLineItemsWasteFactor?: number | null, selectionBinsRoomSelectionLineItemsActualWasteFactor?: number | null, selectionBinsRoomSelectionLineItemsWarnings?: string[] | null, selectionBinsRoomSelectionLineItemsTags?: string[] | null, selectionBinsRoomSelectionLineItemsDescription?: string | null, selectionBinsRoomSelectionLineItemsName?: string | null, selectionBinsRoomSelectionLineItemsCostsLocationId?: string | null, selectionBinsRoomSelectionLineItemsCostsMinimumQuantity?: number | null, selectionBinsRoomSelectionLineItemsCostsPackageCondition?: string | null, selectionBinsRoomSelectionLineItemsCostsPriceCriteria?: string | null, selectionBinsRoomSelectionLineItemsCostsPromotion?: string | null, selectionBinsRoomSelectionLineItemsCostsUom?: string | null, selectionBinsRoomSelectionLineItemsCostsUnitCost?: number | null, selectionBinsRoomSelectionLineItemsCostsDroppedDate?: string | null, selectionBinsRoomSelectionLineItemsCostsEffectiveDate?: string | null, selectionBinsRoomSelectionLineItemsCostsPendingDate?: string | null, selectionBinsRoomSelectionLineItemsCostsPromotionalEnd?: string | null, selectionBinsRoomSelectionLineItemsCostsPromotionalStart?: string | null, selectionBinsRoomSelectionLineItemsAdjustedQuantityUom?: string | null, selectionBinsRoomSelectionLineItemsAdjustedQuantityUnits?: number | null, selectionBinsRoomSelectionLineItemsChildrenDescription?: string | null, selectionBinsRoomSelectionLineItemsChildrenName?: string | null, selectionBinsRoomSelectionLineItemsChildrenQuantityUom?: string | null, selectionBinsRoomSelectionLineItemsChildrenQuantityUnits?: number | null, selectionBinsRoomSelectionLineItemsCostLocationId?: string | null, selectionBinsRoomSelectionLineItemsCostMinimumQuantity?: number | null, selectionBinsRoomSelectionLineItemsCostPackageCondition?: string | null, selectionBinsRoomSelectionLineItemsCostPriceCriteria?: string | null, selectionBinsRoomSelectionLineItemsCostPromotion?: string | null, selectionBinsRoomSelectionLineItemsCostUom?: string | null, selectionBinsRoomSelectionLineItemsCostUnitCost?: number | null, selectionBinsRoomSelectionLineItemsCostDroppedDate?: string | null, selectionBinsRoomSelectionLineItemsCostEffectiveDate?: string | null, selectionBinsRoomSelectionLineItemsCostPendingDate?: string | null, selectionBinsRoomSelectionLineItemsCostPromotionalEnd?: string | null, selectionBinsRoomSelectionLineItemsCostPromotionalStart?: string | null, selectionBinsRoomSelectionLineItemsSellingUnitUom?: string | null, selectionBinsRoomSelectionLineItemsSellingUnitUnits?: number | null, selectionBinsRoomSelectionLineItemsQuantityUom?: string | null, selectionBinsRoomSelectionLineItemsQuantityUnits?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectSelection({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (itemIds !== undefined) {
      queryParams.append('ItemIds', String(itemIds));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (selectionBinsDescription !== undefined) {
      queryParams.append('SelectionBins|Description', String(selectionBinsDescription));
    }
    if (selectionBinsItemIds !== undefined) {
      queryParams.append('SelectionBins|ItemIds', String(selectionBinsItemIds));
    }
    if (selectionBinsName !== undefined) {
      queryParams.append('SelectionBins|Name', String(selectionBinsName));
    }
    if (selectionBinsRooms !== undefined) {
      queryParams.append('SelectionBins|Rooms', String(selectionBinsRooms));
    }
    if (selectionBinsRoomSelectionInstallationTypeId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|InstallationTypeId', String(selectionBinsRoomSelectionInstallationTypeId));
    }
    if (selectionBinsRoomSelectionProductType !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|ProductType', String(selectionBinsRoomSelectionProductType));
    }
    if (selectionBinsRoomSelectionPatternTypeId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|PatternTypeId', String(selectionBinsRoomSelectionPatternTypeId));
    }
    if (selectionBinsRoomSelectionTrimWorkId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|TrimWorkId', String(selectionBinsRoomSelectionTrimWorkId));
    }
    if (selectionBinsRoomSelectionUnderlaymentId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|UnderlaymentId', String(selectionBinsRoomSelectionUnderlaymentId));
    }
    if (selectionBinsRoomSelectionCatalogFeedId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|CatalogFeedId', String(selectionBinsRoomSelectionCatalogFeedId));
    }
    if (selectionBinsRoomSelectionItemId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|ItemId', String(selectionBinsRoomSelectionItemId));
    }
    if (selectionBinsRoomSelectionStyleNumber !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|StyleNumber', String(selectionBinsRoomSelectionStyleNumber));
    }
    if (selectionBinsRoomSelectionBin !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Bin', String(selectionBinsRoomSelectionBin));
    }
    if (selectionBinsRoomSelectionProjectExternalId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|ProjectExternalId', String(selectionBinsRoomSelectionProjectExternalId));
    }
    if (selectionBinsRoomSelectionRoomIds !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|RoomIds', String(selectionBinsRoomSelectionRoomIds));
    }
    if (selectionBinsRoomSelectionName !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Name', String(selectionBinsRoomSelectionName));
    }
    if (selectionBinsRoomSelectionDescription !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Description', String(selectionBinsRoomSelectionDescription));
    }
    if (selectionBinsRoomSelectionEntityId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|EntityId', String(selectionBinsRoomSelectionEntityId));
    }
    if (selectionBinsRoomSelectionId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|_id', String(selectionBinsRoomSelectionId));
    }
    if (selectionBinsRoomSelectionCreatedOn !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|CreatedOn', String(selectionBinsRoomSelectionCreatedOn));
    }
    if (selectionBinsRoomSelectionCreatedBy !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|CreatedBy', String(selectionBinsRoomSelectionCreatedBy));
    }
    if (selectionBinsRoomSelectionWasteFactor !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|WasteFactor', String(selectionBinsRoomSelectionWasteFactor));
    }
    if (selectionBinsRoomSelectionBinId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|BinId', String(selectionBinsRoomSelectionBinId));
    }
    if (selectionBinsRoomSelectionSessionKey !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|SessionKey', String(selectionBinsRoomSelectionSessionKey));
    }
    if (selectionBinsRoomSelectionHash !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Hash', String(selectionBinsRoomSelectionHash));
    }
    if (selectionBinsRoomSelectionHasWarnings !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|HasWarnings', String(selectionBinsRoomSelectionHasWarnings));
    }
    if (selectionBinsRoomSelectionTotalCost !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|TotalCost', String(selectionBinsRoomSelectionTotalCost));
    }
    if (selectionBinsRoomSelectionTotalPrice !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|TotalPrice', String(selectionBinsRoomSelectionTotalPrice));
    }
    if (selectionBinsRoomSelectionTotalTax !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|TotalTax', String(selectionBinsRoomSelectionTotalTax));
    }
    if (selectionBinsRoomSelectionFlowId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|FlowId', String(selectionBinsRoomSelectionFlowId));
    }
    if (selectionBinsRoomSelectionIsActive !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|IsActive', String(selectionBinsRoomSelectionIsActive));
    }
    if (selectionBinsRoomSelectionObjectStatusId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|ObjectStatusId', String(selectionBinsRoomSelectionObjectStatusId));
    }
    if (selectionBinsRoomSelectionAreaUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Area|UOM', String(selectionBinsRoomSelectionAreaUom));
    }
    if (selectionBinsRoomSelectionAreaUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Area|Units', String(selectionBinsRoomSelectionAreaUnits));
    }
    if (selectionBinsRoomSelectionMainProductQuantityUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|MainProductQuantity|UOM', String(selectionBinsRoomSelectionMainProductQuantityUom));
    }
    if (selectionBinsRoomSelectionMainProductQuantityUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|MainProductQuantity|Units', String(selectionBinsRoomSelectionMainProductQuantityUnits));
    }
    if (selectionBinsRoomSelectionPerimeterUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Perimeter|UOM', String(selectionBinsRoomSelectionPerimeterUom));
    }
    if (selectionBinsRoomSelectionPerimeterUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Perimeter|Units', String(selectionBinsRoomSelectionPerimeterUnits));
    }
    if (selectionBinsRoomSelectionLineItemsCriteria !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Criteria', String(selectionBinsRoomSelectionLineItemsCriteria));
    }
    if (selectionBinsRoomSelectionLineItemsItemId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|ItemId', String(selectionBinsRoomSelectionLineItemsItemId));
    }
    if (selectionBinsRoomSelectionLineItemsMargin !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Margin', String(selectionBinsRoomSelectionLineItemsMargin));
    }
    if (selectionBinsRoomSelectionLineItemsSku !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|SKU', String(selectionBinsRoomSelectionLineItemsSku));
    }
    if (selectionBinsRoomSelectionLineItemsSource !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Source', String(selectionBinsRoomSelectionLineItemsSource));
    }
    if (selectionBinsRoomSelectionLineItemsTotalCost !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|TotalCost', String(selectionBinsRoomSelectionLineItemsTotalCost));
    }
    if (selectionBinsRoomSelectionLineItemsTotalPrice !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|TotalPrice', String(selectionBinsRoomSelectionLineItemsTotalPrice));
    }
    if (selectionBinsRoomSelectionLineItemsUnitCost !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|UnitCost', String(selectionBinsRoomSelectionLineItemsUnitCost));
    }
    if (selectionBinsRoomSelectionLineItemsUnitPrice !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|UnitPrice', String(selectionBinsRoomSelectionLineItemsUnitPrice));
    }
    if (selectionBinsRoomSelectionLineItemsWasteFactor !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|WasteFactor', String(selectionBinsRoomSelectionLineItemsWasteFactor));
    }
    if (selectionBinsRoomSelectionLineItemsActualWasteFactor !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|ActualWasteFactor', String(selectionBinsRoomSelectionLineItemsActualWasteFactor));
    }
    if (selectionBinsRoomSelectionLineItemsWarnings !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Warnings', String(selectionBinsRoomSelectionLineItemsWarnings));
    }
    if (selectionBinsRoomSelectionLineItemsTags !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Tags', String(selectionBinsRoomSelectionLineItemsTags));
    }
    if (selectionBinsRoomSelectionLineItemsDescription !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Description', String(selectionBinsRoomSelectionLineItemsDescription));
    }
    if (selectionBinsRoomSelectionLineItemsName !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Name', String(selectionBinsRoomSelectionLineItemsName));
    }
    if (selectionBinsRoomSelectionLineItemsCostsLocationId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|LocationId', String(selectionBinsRoomSelectionLineItemsCostsLocationId));
    }
    if (selectionBinsRoomSelectionLineItemsCostsMinimumQuantity !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|MinimumQuantity', String(selectionBinsRoomSelectionLineItemsCostsMinimumQuantity));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPackageCondition !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|PackageCondition', String(selectionBinsRoomSelectionLineItemsCostsPackageCondition));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPriceCriteria !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|PriceCriteria', String(selectionBinsRoomSelectionLineItemsCostsPriceCriteria));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPromotion !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|Promotion', String(selectionBinsRoomSelectionLineItemsCostsPromotion));
    }
    if (selectionBinsRoomSelectionLineItemsCostsUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|UOM', String(selectionBinsRoomSelectionLineItemsCostsUom));
    }
    if (selectionBinsRoomSelectionLineItemsCostsUnitCost !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|UnitCost', String(selectionBinsRoomSelectionLineItemsCostsUnitCost));
    }
    if (selectionBinsRoomSelectionLineItemsCostsDroppedDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|DroppedDate', String(selectionBinsRoomSelectionLineItemsCostsDroppedDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostsEffectiveDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|EffectiveDate', String(selectionBinsRoomSelectionLineItemsCostsEffectiveDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPendingDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|PendingDate', String(selectionBinsRoomSelectionLineItemsCostsPendingDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPromotionalEnd !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|PromotionalEnd', String(selectionBinsRoomSelectionLineItemsCostsPromotionalEnd));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPromotionalStart !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|PromotionalStart', String(selectionBinsRoomSelectionLineItemsCostsPromotionalStart));
    }
    if (selectionBinsRoomSelectionLineItemsAdjustedQuantityUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|AdjustedQuantity|UOM', String(selectionBinsRoomSelectionLineItemsAdjustedQuantityUom));
    }
    if (selectionBinsRoomSelectionLineItemsAdjustedQuantityUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|AdjustedQuantity|Units', String(selectionBinsRoomSelectionLineItemsAdjustedQuantityUnits));
    }
    if (selectionBinsRoomSelectionLineItemsChildrenDescription !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Children|Description', String(selectionBinsRoomSelectionLineItemsChildrenDescription));
    }
    if (selectionBinsRoomSelectionLineItemsChildrenName !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Children|Name', String(selectionBinsRoomSelectionLineItemsChildrenName));
    }
    if (selectionBinsRoomSelectionLineItemsChildrenQuantityUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Children|Quantity|UOM', String(selectionBinsRoomSelectionLineItemsChildrenQuantityUom));
    }
    if (selectionBinsRoomSelectionLineItemsChildrenQuantityUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Children|Quantity|Units', String(selectionBinsRoomSelectionLineItemsChildrenQuantityUnits));
    }
    if (selectionBinsRoomSelectionLineItemsCostLocationId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|LocationId', String(selectionBinsRoomSelectionLineItemsCostLocationId));
    }
    if (selectionBinsRoomSelectionLineItemsCostMinimumQuantity !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|MinimumQuantity', String(selectionBinsRoomSelectionLineItemsCostMinimumQuantity));
    }
    if (selectionBinsRoomSelectionLineItemsCostPackageCondition !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|PackageCondition', String(selectionBinsRoomSelectionLineItemsCostPackageCondition));
    }
    if (selectionBinsRoomSelectionLineItemsCostPriceCriteria !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|PriceCriteria', String(selectionBinsRoomSelectionLineItemsCostPriceCriteria));
    }
    if (selectionBinsRoomSelectionLineItemsCostPromotion !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|Promotion', String(selectionBinsRoomSelectionLineItemsCostPromotion));
    }
    if (selectionBinsRoomSelectionLineItemsCostUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|UOM', String(selectionBinsRoomSelectionLineItemsCostUom));
    }
    if (selectionBinsRoomSelectionLineItemsCostUnitCost !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|UnitCost', String(selectionBinsRoomSelectionLineItemsCostUnitCost));
    }
    if (selectionBinsRoomSelectionLineItemsCostDroppedDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|DroppedDate', String(selectionBinsRoomSelectionLineItemsCostDroppedDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostEffectiveDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|EffectiveDate', String(selectionBinsRoomSelectionLineItemsCostEffectiveDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostPendingDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|PendingDate', String(selectionBinsRoomSelectionLineItemsCostPendingDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostPromotionalEnd !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|PromotionalEnd', String(selectionBinsRoomSelectionLineItemsCostPromotionalEnd));
    }
    if (selectionBinsRoomSelectionLineItemsCostPromotionalStart !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|PromotionalStart', String(selectionBinsRoomSelectionLineItemsCostPromotionalStart));
    }
    if (selectionBinsRoomSelectionLineItemsSellingUnitUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|SellingUnit|UOM', String(selectionBinsRoomSelectionLineItemsSellingUnitUom));
    }
    if (selectionBinsRoomSelectionLineItemsSellingUnitUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|SellingUnit|Units', String(selectionBinsRoomSelectionLineItemsSellingUnitUnits));
    }
    if (selectionBinsRoomSelectionLineItemsQuantityUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Quantity|UOM', String(selectionBinsRoomSelectionLineItemsQuantityUom));
    }
    if (selectionBinsRoomSelectionLineItemsQuantityUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Quantity|Units', String(selectionBinsRoomSelectionLineItemsQuantityUnits));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeProjectSelection(formName: string, itemIds?: string[] | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, parentObjectId?: string | null, parentObjectType?: string | null, selectionBinsDescription?: string | null, selectionBinsItemIds?: string[] | null, selectionBinsName?: string | null, selectionBinsRooms?: string[] | null, selectionBinsRoomSelectionInstallationTypeId?: string | null, selectionBinsRoomSelectionProductType?: string | null, selectionBinsRoomSelectionPatternTypeId?: string | null, selectionBinsRoomSelectionTrimWorkId?: string | null, selectionBinsRoomSelectionUnderlaymentId?: string | null, selectionBinsRoomSelectionCatalogFeedId?: string | null, selectionBinsRoomSelectionItemId?: string | null, selectionBinsRoomSelectionStyleNumber?: string | null, selectionBinsRoomSelectionBin?: string | null, selectionBinsRoomSelectionProjectExternalId?: string | null, selectionBinsRoomSelectionRoomIds?: string[] | null, selectionBinsRoomSelectionName?: string | null, selectionBinsRoomSelectionDescription?: string | null, selectionBinsRoomSelectionEntityId?: string | null, selectionBinsRoomSelectionId?: string | null, selectionBinsRoomSelectionCreatedOn?: string | null, selectionBinsRoomSelectionCreatedBy?: string | null, selectionBinsRoomSelectionWasteFactor?: number | null, selectionBinsRoomSelectionBinId?: string | null, selectionBinsRoomSelectionSessionKey?: string | null, selectionBinsRoomSelectionHash?: string | null, selectionBinsRoomSelectionHasWarnings?: boolean | null, selectionBinsRoomSelectionTotalCost?: number | null, selectionBinsRoomSelectionTotalPrice?: number | null, selectionBinsRoomSelectionTotalTax?: number | null, selectionBinsRoomSelectionFlowId?: string | null, selectionBinsRoomSelectionIsActive?: boolean | null, selectionBinsRoomSelectionObjectStatusId?: string | null, selectionBinsRoomSelectionAreaUom?: string | null, selectionBinsRoomSelectionAreaUnits?: number | null, selectionBinsRoomSelectionMainProductQuantityUom?: string | null, selectionBinsRoomSelectionMainProductQuantityUnits?: number | null, selectionBinsRoomSelectionPerimeterUom?: string | null, selectionBinsRoomSelectionPerimeterUnits?: number | null, selectionBinsRoomSelectionLineItemsCriteria?: string | null, selectionBinsRoomSelectionLineItemsItemId?: string | null, selectionBinsRoomSelectionLineItemsMargin?: number | null, selectionBinsRoomSelectionLineItemsSku?: string | null, selectionBinsRoomSelectionLineItemsSource?: string | null, selectionBinsRoomSelectionLineItemsTotalCost?: number | null, selectionBinsRoomSelectionLineItemsTotalPrice?: number | null, selectionBinsRoomSelectionLineItemsUnitCost?: number | null, selectionBinsRoomSelectionLineItemsUnitPrice?: number | null, selectionBinsRoomSelectionLineItemsWasteFactor?: number | null, selectionBinsRoomSelectionLineItemsActualWasteFactor?: number | null, selectionBinsRoomSelectionLineItemsWarnings?: string[] | null, selectionBinsRoomSelectionLineItemsTags?: string[] | null, selectionBinsRoomSelectionLineItemsDescription?: string | null, selectionBinsRoomSelectionLineItemsName?: string | null, selectionBinsRoomSelectionLineItemsCostsLocationId?: string | null, selectionBinsRoomSelectionLineItemsCostsMinimumQuantity?: number | null, selectionBinsRoomSelectionLineItemsCostsPackageCondition?: string | null, selectionBinsRoomSelectionLineItemsCostsPriceCriteria?: string | null, selectionBinsRoomSelectionLineItemsCostsPromotion?: string | null, selectionBinsRoomSelectionLineItemsCostsUom?: string | null, selectionBinsRoomSelectionLineItemsCostsUnitCost?: number | null, selectionBinsRoomSelectionLineItemsCostsDroppedDate?: string | null, selectionBinsRoomSelectionLineItemsCostsEffectiveDate?: string | null, selectionBinsRoomSelectionLineItemsCostsPendingDate?: string | null, selectionBinsRoomSelectionLineItemsCostsPromotionalEnd?: string | null, selectionBinsRoomSelectionLineItemsCostsPromotionalStart?: string | null, selectionBinsRoomSelectionLineItemsAdjustedQuantityUom?: string | null, selectionBinsRoomSelectionLineItemsAdjustedQuantityUnits?: number | null, selectionBinsRoomSelectionLineItemsChildrenDescription?: string | null, selectionBinsRoomSelectionLineItemsChildrenName?: string | null, selectionBinsRoomSelectionLineItemsChildrenQuantityUom?: string | null, selectionBinsRoomSelectionLineItemsChildrenQuantityUnits?: number | null, selectionBinsRoomSelectionLineItemsCostLocationId?: string | null, selectionBinsRoomSelectionLineItemsCostMinimumQuantity?: number | null, selectionBinsRoomSelectionLineItemsCostPackageCondition?: string | null, selectionBinsRoomSelectionLineItemsCostPriceCriteria?: string | null, selectionBinsRoomSelectionLineItemsCostPromotion?: string | null, selectionBinsRoomSelectionLineItemsCostUom?: string | null, selectionBinsRoomSelectionLineItemsCostUnitCost?: number | null, selectionBinsRoomSelectionLineItemsCostDroppedDate?: string | null, selectionBinsRoomSelectionLineItemsCostEffectiveDate?: string | null, selectionBinsRoomSelectionLineItemsCostPendingDate?: string | null, selectionBinsRoomSelectionLineItemsCostPromotionalEnd?: string | null, selectionBinsRoomSelectionLineItemsCostPromotionalStart?: string | null, selectionBinsRoomSelectionLineItemsSellingUnitUom?: string | null, selectionBinsRoomSelectionLineItemsSellingUnitUnits?: number | null, selectionBinsRoomSelectionLineItemsQuantityUom?: string | null, selectionBinsRoomSelectionLineItemsQuantityUnits?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectSelection/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (itemIds !== undefined) {
      queryParams.append('ItemIds', String(itemIds));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (selectionBinsDescription !== undefined) {
      queryParams.append('SelectionBins|Description', String(selectionBinsDescription));
    }
    if (selectionBinsItemIds !== undefined) {
      queryParams.append('SelectionBins|ItemIds', String(selectionBinsItemIds));
    }
    if (selectionBinsName !== undefined) {
      queryParams.append('SelectionBins|Name', String(selectionBinsName));
    }
    if (selectionBinsRooms !== undefined) {
      queryParams.append('SelectionBins|Rooms', String(selectionBinsRooms));
    }
    if (selectionBinsRoomSelectionInstallationTypeId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|InstallationTypeId', String(selectionBinsRoomSelectionInstallationTypeId));
    }
    if (selectionBinsRoomSelectionProductType !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|ProductType', String(selectionBinsRoomSelectionProductType));
    }
    if (selectionBinsRoomSelectionPatternTypeId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|PatternTypeId', String(selectionBinsRoomSelectionPatternTypeId));
    }
    if (selectionBinsRoomSelectionTrimWorkId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|TrimWorkId', String(selectionBinsRoomSelectionTrimWorkId));
    }
    if (selectionBinsRoomSelectionUnderlaymentId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|UnderlaymentId', String(selectionBinsRoomSelectionUnderlaymentId));
    }
    if (selectionBinsRoomSelectionCatalogFeedId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|CatalogFeedId', String(selectionBinsRoomSelectionCatalogFeedId));
    }
    if (selectionBinsRoomSelectionItemId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|ItemId', String(selectionBinsRoomSelectionItemId));
    }
    if (selectionBinsRoomSelectionStyleNumber !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|StyleNumber', String(selectionBinsRoomSelectionStyleNumber));
    }
    if (selectionBinsRoomSelectionBin !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Bin', String(selectionBinsRoomSelectionBin));
    }
    if (selectionBinsRoomSelectionProjectExternalId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|ProjectExternalId', String(selectionBinsRoomSelectionProjectExternalId));
    }
    if (selectionBinsRoomSelectionRoomIds !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|RoomIds', String(selectionBinsRoomSelectionRoomIds));
    }
    if (selectionBinsRoomSelectionName !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Name', String(selectionBinsRoomSelectionName));
    }
    if (selectionBinsRoomSelectionDescription !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Description', String(selectionBinsRoomSelectionDescription));
    }
    if (selectionBinsRoomSelectionEntityId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|EntityId', String(selectionBinsRoomSelectionEntityId));
    }
    if (selectionBinsRoomSelectionId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|_id', String(selectionBinsRoomSelectionId));
    }
    if (selectionBinsRoomSelectionCreatedOn !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|CreatedOn', String(selectionBinsRoomSelectionCreatedOn));
    }
    if (selectionBinsRoomSelectionCreatedBy !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|CreatedBy', String(selectionBinsRoomSelectionCreatedBy));
    }
    if (selectionBinsRoomSelectionWasteFactor !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|WasteFactor', String(selectionBinsRoomSelectionWasteFactor));
    }
    if (selectionBinsRoomSelectionBinId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|BinId', String(selectionBinsRoomSelectionBinId));
    }
    if (selectionBinsRoomSelectionSessionKey !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|SessionKey', String(selectionBinsRoomSelectionSessionKey));
    }
    if (selectionBinsRoomSelectionHash !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Hash', String(selectionBinsRoomSelectionHash));
    }
    if (selectionBinsRoomSelectionHasWarnings !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|HasWarnings', String(selectionBinsRoomSelectionHasWarnings));
    }
    if (selectionBinsRoomSelectionTotalCost !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|TotalCost', String(selectionBinsRoomSelectionTotalCost));
    }
    if (selectionBinsRoomSelectionTotalPrice !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|TotalPrice', String(selectionBinsRoomSelectionTotalPrice));
    }
    if (selectionBinsRoomSelectionTotalTax !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|TotalTax', String(selectionBinsRoomSelectionTotalTax));
    }
    if (selectionBinsRoomSelectionFlowId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|FlowId', String(selectionBinsRoomSelectionFlowId));
    }
    if (selectionBinsRoomSelectionIsActive !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|IsActive', String(selectionBinsRoomSelectionIsActive));
    }
    if (selectionBinsRoomSelectionObjectStatusId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|ObjectStatusId', String(selectionBinsRoomSelectionObjectStatusId));
    }
    if (selectionBinsRoomSelectionAreaUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Area|UOM', String(selectionBinsRoomSelectionAreaUom));
    }
    if (selectionBinsRoomSelectionAreaUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Area|Units', String(selectionBinsRoomSelectionAreaUnits));
    }
    if (selectionBinsRoomSelectionMainProductQuantityUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|MainProductQuantity|UOM', String(selectionBinsRoomSelectionMainProductQuantityUom));
    }
    if (selectionBinsRoomSelectionMainProductQuantityUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|MainProductQuantity|Units', String(selectionBinsRoomSelectionMainProductQuantityUnits));
    }
    if (selectionBinsRoomSelectionPerimeterUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Perimeter|UOM', String(selectionBinsRoomSelectionPerimeterUom));
    }
    if (selectionBinsRoomSelectionPerimeterUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|Perimeter|Units', String(selectionBinsRoomSelectionPerimeterUnits));
    }
    if (selectionBinsRoomSelectionLineItemsCriteria !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Criteria', String(selectionBinsRoomSelectionLineItemsCriteria));
    }
    if (selectionBinsRoomSelectionLineItemsItemId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|ItemId', String(selectionBinsRoomSelectionLineItemsItemId));
    }
    if (selectionBinsRoomSelectionLineItemsMargin !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Margin', String(selectionBinsRoomSelectionLineItemsMargin));
    }
    if (selectionBinsRoomSelectionLineItemsSku !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|SKU', String(selectionBinsRoomSelectionLineItemsSku));
    }
    if (selectionBinsRoomSelectionLineItemsSource !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Source', String(selectionBinsRoomSelectionLineItemsSource));
    }
    if (selectionBinsRoomSelectionLineItemsTotalCost !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|TotalCost', String(selectionBinsRoomSelectionLineItemsTotalCost));
    }
    if (selectionBinsRoomSelectionLineItemsTotalPrice !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|TotalPrice', String(selectionBinsRoomSelectionLineItemsTotalPrice));
    }
    if (selectionBinsRoomSelectionLineItemsUnitCost !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|UnitCost', String(selectionBinsRoomSelectionLineItemsUnitCost));
    }
    if (selectionBinsRoomSelectionLineItemsUnitPrice !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|UnitPrice', String(selectionBinsRoomSelectionLineItemsUnitPrice));
    }
    if (selectionBinsRoomSelectionLineItemsWasteFactor !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|WasteFactor', String(selectionBinsRoomSelectionLineItemsWasteFactor));
    }
    if (selectionBinsRoomSelectionLineItemsActualWasteFactor !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|ActualWasteFactor', String(selectionBinsRoomSelectionLineItemsActualWasteFactor));
    }
    if (selectionBinsRoomSelectionLineItemsWarnings !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Warnings', String(selectionBinsRoomSelectionLineItemsWarnings));
    }
    if (selectionBinsRoomSelectionLineItemsTags !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Tags', String(selectionBinsRoomSelectionLineItemsTags));
    }
    if (selectionBinsRoomSelectionLineItemsDescription !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Description', String(selectionBinsRoomSelectionLineItemsDescription));
    }
    if (selectionBinsRoomSelectionLineItemsName !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Name', String(selectionBinsRoomSelectionLineItemsName));
    }
    if (selectionBinsRoomSelectionLineItemsCostsLocationId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|LocationId', String(selectionBinsRoomSelectionLineItemsCostsLocationId));
    }
    if (selectionBinsRoomSelectionLineItemsCostsMinimumQuantity !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|MinimumQuantity', String(selectionBinsRoomSelectionLineItemsCostsMinimumQuantity));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPackageCondition !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|PackageCondition', String(selectionBinsRoomSelectionLineItemsCostsPackageCondition));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPriceCriteria !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|PriceCriteria', String(selectionBinsRoomSelectionLineItemsCostsPriceCriteria));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPromotion !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|Promotion', String(selectionBinsRoomSelectionLineItemsCostsPromotion));
    }
    if (selectionBinsRoomSelectionLineItemsCostsUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|UOM', String(selectionBinsRoomSelectionLineItemsCostsUom));
    }
    if (selectionBinsRoomSelectionLineItemsCostsUnitCost !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|UnitCost', String(selectionBinsRoomSelectionLineItemsCostsUnitCost));
    }
    if (selectionBinsRoomSelectionLineItemsCostsDroppedDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|DroppedDate', String(selectionBinsRoomSelectionLineItemsCostsDroppedDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostsEffectiveDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|EffectiveDate', String(selectionBinsRoomSelectionLineItemsCostsEffectiveDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPendingDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|PendingDate', String(selectionBinsRoomSelectionLineItemsCostsPendingDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPromotionalEnd !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|PromotionalEnd', String(selectionBinsRoomSelectionLineItemsCostsPromotionalEnd));
    }
    if (selectionBinsRoomSelectionLineItemsCostsPromotionalStart !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Costs|PromotionalStart', String(selectionBinsRoomSelectionLineItemsCostsPromotionalStart));
    }
    if (selectionBinsRoomSelectionLineItemsAdjustedQuantityUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|AdjustedQuantity|UOM', String(selectionBinsRoomSelectionLineItemsAdjustedQuantityUom));
    }
    if (selectionBinsRoomSelectionLineItemsAdjustedQuantityUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|AdjustedQuantity|Units', String(selectionBinsRoomSelectionLineItemsAdjustedQuantityUnits));
    }
    if (selectionBinsRoomSelectionLineItemsChildrenDescription !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Children|Description', String(selectionBinsRoomSelectionLineItemsChildrenDescription));
    }
    if (selectionBinsRoomSelectionLineItemsChildrenName !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Children|Name', String(selectionBinsRoomSelectionLineItemsChildrenName));
    }
    if (selectionBinsRoomSelectionLineItemsChildrenQuantityUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Children|Quantity|UOM', String(selectionBinsRoomSelectionLineItemsChildrenQuantityUom));
    }
    if (selectionBinsRoomSelectionLineItemsChildrenQuantityUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Children|Quantity|Units', String(selectionBinsRoomSelectionLineItemsChildrenQuantityUnits));
    }
    if (selectionBinsRoomSelectionLineItemsCostLocationId !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|LocationId', String(selectionBinsRoomSelectionLineItemsCostLocationId));
    }
    if (selectionBinsRoomSelectionLineItemsCostMinimumQuantity !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|MinimumQuantity', String(selectionBinsRoomSelectionLineItemsCostMinimumQuantity));
    }
    if (selectionBinsRoomSelectionLineItemsCostPackageCondition !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|PackageCondition', String(selectionBinsRoomSelectionLineItemsCostPackageCondition));
    }
    if (selectionBinsRoomSelectionLineItemsCostPriceCriteria !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|PriceCriteria', String(selectionBinsRoomSelectionLineItemsCostPriceCriteria));
    }
    if (selectionBinsRoomSelectionLineItemsCostPromotion !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|Promotion', String(selectionBinsRoomSelectionLineItemsCostPromotion));
    }
    if (selectionBinsRoomSelectionLineItemsCostUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|UOM', String(selectionBinsRoomSelectionLineItemsCostUom));
    }
    if (selectionBinsRoomSelectionLineItemsCostUnitCost !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|UnitCost', String(selectionBinsRoomSelectionLineItemsCostUnitCost));
    }
    if (selectionBinsRoomSelectionLineItemsCostDroppedDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|DroppedDate', String(selectionBinsRoomSelectionLineItemsCostDroppedDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostEffectiveDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|EffectiveDate', String(selectionBinsRoomSelectionLineItemsCostEffectiveDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostPendingDate !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|PendingDate', String(selectionBinsRoomSelectionLineItemsCostPendingDate));
    }
    if (selectionBinsRoomSelectionLineItemsCostPromotionalEnd !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|PromotionalEnd', String(selectionBinsRoomSelectionLineItemsCostPromotionalEnd));
    }
    if (selectionBinsRoomSelectionLineItemsCostPromotionalStart !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Cost|PromotionalStart', String(selectionBinsRoomSelectionLineItemsCostPromotionalStart));
    }
    if (selectionBinsRoomSelectionLineItemsSellingUnitUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|SellingUnit|UOM', String(selectionBinsRoomSelectionLineItemsSellingUnitUom));
    }
    if (selectionBinsRoomSelectionLineItemsSellingUnitUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|SellingUnit|Units', String(selectionBinsRoomSelectionLineItemsSellingUnitUnits));
    }
    if (selectionBinsRoomSelectionLineItemsQuantityUom !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Quantity|UOM', String(selectionBinsRoomSelectionLineItemsQuantityUom));
    }
    if (selectionBinsRoomSelectionLineItemsQuantityUnits !== undefined) {
      queryParams.append('SelectionBins|RoomSelection|LineItems|Quantity|Units', String(selectionBinsRoomSelectionLineItemsQuantityUnits));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterProjectSelection(request?: FilterProjectSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<ProjectSelection[]> {
    const path = '/app/api/Object/otg.ProjectSelection/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProjectSelectionSerializer.fromObject(item));
  }

  async createProjectSelection(request?: CreateProjectSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.ProjectSelection';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateProjectSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateProjectSelection(objectId: string, request?: UpdateProjectSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectSelection({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateProjectSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deleteProjectSelection(objectId: string, fields?: ProjectSelectionFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<ProjectSelection> {
    let path = '/app/api/Object/otg.ProjectSelection({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return ProjectSelectionSerializer.fromObject(data);
  }

  async recentProjectSelection(request?: FilterProjectSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<ProjectSelection[]> {
    const path = '/app/api/Object/otg.ProjectSelection/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProjectSelectionSerializer.fromObject(item));
  }

  async dataViewProjectSelection(request?: FilterProjectSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewProjectSelectionResponse> {
    const path = '/app/api/Object/otg.ProjectSelection/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewProjectSelectionResponseSerializer.fromObject(data);
  }

  async getFormForProjectTask(formName: string, objectId: string, parentObjectId?: string | null, flowId?: string | null, objectStatusId?: string | null, content?: string | null, description?: string | null, name?: string | null, assignedUserId?: string | null, dueDate?: string | null, priority?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectTask({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (assignedUserId !== undefined) {
      queryParams.append('AssignedUserId', String(assignedUserId));
    }
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (priority !== undefined) {
      queryParams.append('Priority', String(priority));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeProjectTask(formName: string, parentObjectId?: string | null, flowId?: string | null, objectStatusId?: string | null, content?: string | null, description?: string | null, name?: string | null, assignedUserId?: string | null, dueDate?: string | null, priority?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.ProjectTask/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (assignedUserId !== undefined) {
      queryParams.append('AssignedUserId', String(assignedUserId));
    }
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (priority !== undefined) {
      queryParams.append('Priority', String(priority));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterProjectTask(request?: FilterProjectTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<ProjectTask[]> {
    const path = '/app/api/Object/otg.ProjectTask/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProjectTaskSerializer.fromObject(item));
  }

  async createProjectTask(request?: CreateProjectTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.ProjectTask';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateProjectTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateProjectTask(objectId: string, request?: UpdateProjectTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.ProjectTask({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateProjectTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentProjectTask(request?: FilterProjectTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<ProjectTask[]> {
    const path = '/app/api/Object/otg.ProjectTask/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProjectTaskSerializer.fromObject(item));
  }

  async dataViewProjectTask(request?: FilterProjectTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewProjectTaskResponse> {
    const path = '/app/api/Object/otg.ProjectTask/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewProjectTaskResponseSerializer.fromObject(data);
  }

  async getRoomPhotoFileAskSyntheaForm(objectId: string, assistantId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.RoomPhotoFile({objectId})/UserAction(e9d9a884-e399-4cb2-8aef-68c350fe96b4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (assistantId !== undefined) {
      queryParams.append('AssistantId', String(assistantId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runRoomPhotoFileAskSyntheaAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomPhotoFile({objectId})/UserAction(e9d9a884-e399-4cb2-8aef-68c350fe96b4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startRoomPhotoFileAskSynthea(objectId: string, request?: StartRoomPhotoFileAskSyntheaRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomPhotoFile({objectId})/UserAction(e9d9a884-e399-4cb2-8aef-68c350fe96b4)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartRoomPhotoFileAskSyntheaRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForRoomPhotoFile(formName: string, objectId: string, contentType?: string | null, size?: number | null, publicUrl?: string | null, allowAnonymousDownload?: boolean | null, flowId?: string | null, objectStatusId?: string | null, t?: string | null, name?: string | null, absoluteUri?: string | null, parentId?: string | null, createdBy?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, parentObjectId?: string | null, parentObjectType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.RoomPhotoFile({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (size !== undefined) {
      queryParams.append('Size', String(size));
    }
    if (publicUrl !== undefined) {
      queryParams.append('PublicUrl', String(publicUrl));
    }
    if (allowAnonymousDownload !== undefined) {
      queryParams.append('AllowAnonymousDownload', String(allowAnonymousDownload));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (absoluteUri !== undefined) {
      queryParams.append('AbsoluteUri', String(absoluteUri));
    }
    if (parentId !== undefined) {
      queryParams.append('ParentId', String(parentId));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeRoomPhotoFile(formName: string, contentType?: string | null, size?: number | null, publicUrl?: string | null, allowAnonymousDownload?: boolean | null, flowId?: string | null, objectStatusId?: string | null, t?: string | null, name?: string | null, absoluteUri?: string | null, parentId?: string | null, createdBy?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, parentObjectId?: string | null, parentObjectType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.RoomPhotoFile/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (size !== undefined) {
      queryParams.append('Size', String(size));
    }
    if (publicUrl !== undefined) {
      queryParams.append('PublicUrl', String(publicUrl));
    }
    if (allowAnonymousDownload !== undefined) {
      queryParams.append('AllowAnonymousDownload', String(allowAnonymousDownload));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (absoluteUri !== undefined) {
      queryParams.append('AbsoluteUri', String(absoluteUri));
    }
    if (parentId !== undefined) {
      queryParams.append('ParentId', String(parentId));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterRoomPhotoFile(request?: FilterRoomPhotoFileRequest | null, options?: { headers?: Record<string, string> }): Promise<RoomPhotoFile[]> {
    const path = '/app/api/Object/otg.RoomPhotoFile/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRoomPhotoFileRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => RoomPhotoFileSerializer.fromObject(item));
  }

  async recentRoomPhotoFile(request?: FilterRoomPhotoFileRequest | null, options?: { headers?: Record<string, string> }): Promise<RoomPhotoFile[]> {
    const path = '/app/api/Object/otg.RoomPhotoFile/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRoomPhotoFileRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => RoomPhotoFileSerializer.fromObject(item));
  }

  async dataViewRoomPhotoFile(request?: FilterRoomPhotoFileRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewRoomPhotoFileResponse> {
    const path = '/app/api/Object/otg.RoomPhotoFile/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRoomPhotoFileRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewRoomPhotoFileResponseSerializer.fromObject(data);
  }

  async getRoomSelectionAddLineItemForm(objectId: string, itemId?: string | null, source?: string | null, quantity?: number | null, uom?: string | null, appliesTo?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(378deb5e-9298-4c31-b6f3-81f8ea031edd)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (itemId !== undefined) {
      queryParams.append('itemId', String(itemId));
    }
    if (source !== undefined) {
      queryParams.append('source', String(source));
    }
    if (quantity !== undefined) {
      queryParams.append('quantity', String(quantity));
    }
    if (uom !== undefined) {
      queryParams.append('uom', String(uom));
    }
    if (appliesTo !== undefined) {
      queryParams.append('AppliesTo', String(appliesTo));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runRoomSelectionAddLineItemAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(378deb5e-9298-4c31-b6f3-81f8ea031edd)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startRoomSelectionAddLineItem(objectId: string, request?: StartRoomSelectionAddLineItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(378deb5e-9298-4c31-b6f3-81f8ea031edd)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartRoomSelectionAddLineItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getRoomSelectionSwitchItemForm(objectId: string, currentItemId?: string | null, itemId?: string | null, source?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(3dea1eaf-db96-4acd-a9e6-3fcfcc6b209d)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (currentItemId !== undefined) {
      queryParams.append('currentItemId', String(currentItemId));
    }
    if (itemId !== undefined) {
      queryParams.append('itemId', String(itemId));
    }
    if (source !== undefined) {
      queryParams.append('source', String(source));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runRoomSelectionSwitchItemAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(3dea1eaf-db96-4acd-a9e6-3fcfcc6b209d)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startRoomSelectionSwitchItem(objectId: string, request?: StartRoomSelectionSwitchItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(3dea1eaf-db96-4acd-a9e6-3fcfcc6b209d)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartRoomSelectionSwitchItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getRoomSelectionRemoveItemForm(objectId: string, source?: string | null, itemId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(6eb90660-350d-43f0-8a4a-f4638a223598)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (source !== undefined) {
      queryParams.append('source', String(source));
    }
    if (itemId !== undefined) {
      queryParams.append('itemId', String(itemId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runRoomSelectionRemoveItemAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(6eb90660-350d-43f0-8a4a-f4638a223598)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startRoomSelectionRemoveItem(objectId: string, request?: StartRoomSelectionRemoveItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(6eb90660-350d-43f0-8a4a-f4638a223598)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartRoomSelectionRemoveItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getRoomSelectionEditItemForm(objectId: string, source?: string | null, itemId?: string | null, margin?: number | null, wasteFactor?: number | null, quantity?: number | null, uom?: string | null, unitCost?: number | null, uomAbbreviation?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(f6ea3ec3-bbea-42b5-9125-02678dee5a88)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (source !== undefined) {
      queryParams.append('source', String(source));
    }
    if (itemId !== undefined) {
      queryParams.append('itemId', String(itemId));
    }
    if (margin !== undefined) {
      queryParams.append('margin', String(margin));
    }
    if (wasteFactor !== undefined) {
      queryParams.append('wasteFactor', String(wasteFactor));
    }
    if (quantity !== undefined) {
      queryParams.append('quantity', String(quantity));
    }
    if (uom !== undefined) {
      queryParams.append('uom', String(uom));
    }
    if (unitCost !== undefined) {
      queryParams.append('unitCost', String(unitCost));
    }
    if (uomAbbreviation !== undefined) {
      queryParams.append('uomAbbreviation', String(uomAbbreviation));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runRoomSelectionEditItemAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(f6ea3ec3-bbea-42b5-9125-02678dee5a88)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startRoomSelectionEditItem(objectId: string, request?: StartRoomSelectionEditItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(f6ea3ec3-bbea-42b5-9125-02678dee5a88)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartRoomSelectionEditItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getRoomSelectionAddFreightForm(objectId: string, itemId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(f13c1e12-ed06-426c-9a42-d7680a797afc)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (itemId !== undefined) {
      queryParams.append('itemId', String(itemId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runRoomSelectionAddFreightAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(f13c1e12-ed06-426c-9a42-d7680a797afc)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startRoomSelectionAddFreight(objectId: string, request?: StartRoomSelectionAddFreightRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/UserAction(f13c1e12-ed06-426c-9a42-d7680a797afc)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartRoomSelectionAddFreightRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForRoomSelection(formName: string, objectId: string, installationTypeId?: string | null, productType?: string | null, patternTypeId?: string | null, trimWorkId?: string | null, underlaymentId?: string | null, catalogFeedId?: string | null, itemId?: string | null, styleNumber?: string | null, bin?: string | null, projectExternalId?: string | null, roomIds?: string[] | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, wasteFactor?: number | null, binId?: string | null, sessionKey?: string | null, hash?: string | null, hasWarnings?: boolean | null, totalCost?: number | null, totalPrice?: number | null, totalTax?: number | null, flowId?: string | null, isActive?: boolean | null, objectStatusId?: string | null, areaUom?: string | null, areaUnits?: number | null, mainProductQuantityUom?: string | null, mainProductQuantityUnits?: number | null, perimeterUom?: string | null, perimeterUnits?: number | null, lineItemsCriteria?: string | null, lineItemsItemId?: string | null, lineItemsMargin?: number | null, lineItemsSku?: string | null, lineItemsSource?: string | null, lineItemsTotalCost?: number | null, lineItemsTotalPrice?: number | null, lineItemsUnitCost?: number | null, lineItemsUnitPrice?: number | null, lineItemsWasteFactor?: number | null, lineItemsActualWasteFactor?: number | null, lineItemsWarnings?: string[] | null, lineItemsTags?: string[] | null, lineItemsDescription?: string | null, lineItemsName?: string | null, lineItemsCostsLocationId?: string | null, lineItemsCostsMinimumQuantity?: number | null, lineItemsCostsPackageCondition?: string | null, lineItemsCostsPriceCriteria?: string | null, lineItemsCostsPromotion?: string | null, lineItemsCostsUom?: string | null, lineItemsCostsUnitCost?: number | null, lineItemsCostsDroppedDate?: string | null, lineItemsCostsEffectiveDate?: string | null, lineItemsCostsPendingDate?: string | null, lineItemsCostsPromotionalEnd?: string | null, lineItemsCostsPromotionalStart?: string | null, lineItemsAdjustedQuantityUom?: string | null, lineItemsAdjustedQuantityUnits?: number | null, lineItemsChildrenDescription?: string | null, lineItemsChildrenName?: string | null, lineItemsChildrenQuantityUom?: string | null, lineItemsChildrenQuantityUnits?: number | null, lineItemsCostLocationId?: string | null, lineItemsCostMinimumQuantity?: number | null, lineItemsCostPackageCondition?: string | null, lineItemsCostPriceCriteria?: string | null, lineItemsCostPromotion?: string | null, lineItemsCostUom?: string | null, lineItemsCostUnitCost?: number | null, lineItemsCostDroppedDate?: string | null, lineItemsCostEffectiveDate?: string | null, lineItemsCostPendingDate?: string | null, lineItemsCostPromotionalEnd?: string | null, lineItemsCostPromotionalStart?: string | null, lineItemsSellingUnitUom?: string | null, lineItemsSellingUnitUnits?: number | null, lineItemsQuantityUom?: string | null, lineItemsQuantityUnits?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (installationTypeId !== undefined) {
      queryParams.append('InstallationTypeId', String(installationTypeId));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (patternTypeId !== undefined) {
      queryParams.append('PatternTypeId', String(patternTypeId));
    }
    if (trimWorkId !== undefined) {
      queryParams.append('TrimWorkId', String(trimWorkId));
    }
    if (underlaymentId !== undefined) {
      queryParams.append('UnderlaymentId', String(underlaymentId));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (itemId !== undefined) {
      queryParams.append('ItemId', String(itemId));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (bin !== undefined) {
      queryParams.append('Bin', String(bin));
    }
    if (projectExternalId !== undefined) {
      queryParams.append('ProjectExternalId', String(projectExternalId));
    }
    if (roomIds !== undefined) {
      queryParams.append('RoomIds', String(roomIds));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (wasteFactor !== undefined) {
      queryParams.append('WasteFactor', String(wasteFactor));
    }
    if (binId !== undefined) {
      queryParams.append('BinId', String(binId));
    }
    if (sessionKey !== undefined) {
      queryParams.append('SessionKey', String(sessionKey));
    }
    if (hash !== undefined) {
      queryParams.append('Hash', String(hash));
    }
    if (hasWarnings !== undefined) {
      queryParams.append('HasWarnings', String(hasWarnings));
    }
    if (totalCost !== undefined) {
      queryParams.append('TotalCost', String(totalCost));
    }
    if (totalPrice !== undefined) {
      queryParams.append('TotalPrice', String(totalPrice));
    }
    if (totalTax !== undefined) {
      queryParams.append('TotalTax', String(totalTax));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (areaUom !== undefined) {
      queryParams.append('Area|UOM', String(areaUom));
    }
    if (areaUnits !== undefined) {
      queryParams.append('Area|Units', String(areaUnits));
    }
    if (mainProductQuantityUom !== undefined) {
      queryParams.append('MainProductQuantity|UOM', String(mainProductQuantityUom));
    }
    if (mainProductQuantityUnits !== undefined) {
      queryParams.append('MainProductQuantity|Units', String(mainProductQuantityUnits));
    }
    if (perimeterUom !== undefined) {
      queryParams.append('Perimeter|UOM', String(perimeterUom));
    }
    if (perimeterUnits !== undefined) {
      queryParams.append('Perimeter|Units', String(perimeterUnits));
    }
    if (lineItemsCriteria !== undefined) {
      queryParams.append('LineItems|Criteria', String(lineItemsCriteria));
    }
    if (lineItemsItemId !== undefined) {
      queryParams.append('LineItems|ItemId', String(lineItemsItemId));
    }
    if (lineItemsMargin !== undefined) {
      queryParams.append('LineItems|Margin', String(lineItemsMargin));
    }
    if (lineItemsSku !== undefined) {
      queryParams.append('LineItems|SKU', String(lineItemsSku));
    }
    if (lineItemsSource !== undefined) {
      queryParams.append('LineItems|Source', String(lineItemsSource));
    }
    if (lineItemsTotalCost !== undefined) {
      queryParams.append('LineItems|TotalCost', String(lineItemsTotalCost));
    }
    if (lineItemsTotalPrice !== undefined) {
      queryParams.append('LineItems|TotalPrice', String(lineItemsTotalPrice));
    }
    if (lineItemsUnitCost !== undefined) {
      queryParams.append('LineItems|UnitCost', String(lineItemsUnitCost));
    }
    if (lineItemsUnitPrice !== undefined) {
      queryParams.append('LineItems|UnitPrice', String(lineItemsUnitPrice));
    }
    if (lineItemsWasteFactor !== undefined) {
      queryParams.append('LineItems|WasteFactor', String(lineItemsWasteFactor));
    }
    if (lineItemsActualWasteFactor !== undefined) {
      queryParams.append('LineItems|ActualWasteFactor', String(lineItemsActualWasteFactor));
    }
    if (lineItemsWarnings !== undefined) {
      queryParams.append('LineItems|Warnings', String(lineItemsWarnings));
    }
    if (lineItemsTags !== undefined) {
      queryParams.append('LineItems|Tags', String(lineItemsTags));
    }
    if (lineItemsDescription !== undefined) {
      queryParams.append('LineItems|Description', String(lineItemsDescription));
    }
    if (lineItemsName !== undefined) {
      queryParams.append('LineItems|Name', String(lineItemsName));
    }
    if (lineItemsCostsLocationId !== undefined) {
      queryParams.append('LineItems|Costs|LocationId', String(lineItemsCostsLocationId));
    }
    if (lineItemsCostsMinimumQuantity !== undefined) {
      queryParams.append('LineItems|Costs|MinimumQuantity', String(lineItemsCostsMinimumQuantity));
    }
    if (lineItemsCostsPackageCondition !== undefined) {
      queryParams.append('LineItems|Costs|PackageCondition', String(lineItemsCostsPackageCondition));
    }
    if (lineItemsCostsPriceCriteria !== undefined) {
      queryParams.append('LineItems|Costs|PriceCriteria', String(lineItemsCostsPriceCriteria));
    }
    if (lineItemsCostsPromotion !== undefined) {
      queryParams.append('LineItems|Costs|Promotion', String(lineItemsCostsPromotion));
    }
    if (lineItemsCostsUom !== undefined) {
      queryParams.append('LineItems|Costs|UOM', String(lineItemsCostsUom));
    }
    if (lineItemsCostsUnitCost !== undefined) {
      queryParams.append('LineItems|Costs|UnitCost', String(lineItemsCostsUnitCost));
    }
    if (lineItemsCostsDroppedDate !== undefined) {
      queryParams.append('LineItems|Costs|DroppedDate', String(lineItemsCostsDroppedDate));
    }
    if (lineItemsCostsEffectiveDate !== undefined) {
      queryParams.append('LineItems|Costs|EffectiveDate', String(lineItemsCostsEffectiveDate));
    }
    if (lineItemsCostsPendingDate !== undefined) {
      queryParams.append('LineItems|Costs|PendingDate', String(lineItemsCostsPendingDate));
    }
    if (lineItemsCostsPromotionalEnd !== undefined) {
      queryParams.append('LineItems|Costs|PromotionalEnd', String(lineItemsCostsPromotionalEnd));
    }
    if (lineItemsCostsPromotionalStart !== undefined) {
      queryParams.append('LineItems|Costs|PromotionalStart', String(lineItemsCostsPromotionalStart));
    }
    if (lineItemsAdjustedQuantityUom !== undefined) {
      queryParams.append('LineItems|AdjustedQuantity|UOM', String(lineItemsAdjustedQuantityUom));
    }
    if (lineItemsAdjustedQuantityUnits !== undefined) {
      queryParams.append('LineItems|AdjustedQuantity|Units', String(lineItemsAdjustedQuantityUnits));
    }
    if (lineItemsChildrenDescription !== undefined) {
      queryParams.append('LineItems|Children|Description', String(lineItemsChildrenDescription));
    }
    if (lineItemsChildrenName !== undefined) {
      queryParams.append('LineItems|Children|Name', String(lineItemsChildrenName));
    }
    if (lineItemsChildrenQuantityUom !== undefined) {
      queryParams.append('LineItems|Children|Quantity|UOM', String(lineItemsChildrenQuantityUom));
    }
    if (lineItemsChildrenQuantityUnits !== undefined) {
      queryParams.append('LineItems|Children|Quantity|Units', String(lineItemsChildrenQuantityUnits));
    }
    if (lineItemsCostLocationId !== undefined) {
      queryParams.append('LineItems|Cost|LocationId', String(lineItemsCostLocationId));
    }
    if (lineItemsCostMinimumQuantity !== undefined) {
      queryParams.append('LineItems|Cost|MinimumQuantity', String(lineItemsCostMinimumQuantity));
    }
    if (lineItemsCostPackageCondition !== undefined) {
      queryParams.append('LineItems|Cost|PackageCondition', String(lineItemsCostPackageCondition));
    }
    if (lineItemsCostPriceCriteria !== undefined) {
      queryParams.append('LineItems|Cost|PriceCriteria', String(lineItemsCostPriceCriteria));
    }
    if (lineItemsCostPromotion !== undefined) {
      queryParams.append('LineItems|Cost|Promotion', String(lineItemsCostPromotion));
    }
    if (lineItemsCostUom !== undefined) {
      queryParams.append('LineItems|Cost|UOM', String(lineItemsCostUom));
    }
    if (lineItemsCostUnitCost !== undefined) {
      queryParams.append('LineItems|Cost|UnitCost', String(lineItemsCostUnitCost));
    }
    if (lineItemsCostDroppedDate !== undefined) {
      queryParams.append('LineItems|Cost|DroppedDate', String(lineItemsCostDroppedDate));
    }
    if (lineItemsCostEffectiveDate !== undefined) {
      queryParams.append('LineItems|Cost|EffectiveDate', String(lineItemsCostEffectiveDate));
    }
    if (lineItemsCostPendingDate !== undefined) {
      queryParams.append('LineItems|Cost|PendingDate', String(lineItemsCostPendingDate));
    }
    if (lineItemsCostPromotionalEnd !== undefined) {
      queryParams.append('LineItems|Cost|PromotionalEnd', String(lineItemsCostPromotionalEnd));
    }
    if (lineItemsCostPromotionalStart !== undefined) {
      queryParams.append('LineItems|Cost|PromotionalStart', String(lineItemsCostPromotionalStart));
    }
    if (lineItemsSellingUnitUom !== undefined) {
      queryParams.append('LineItems|SellingUnit|UOM', String(lineItemsSellingUnitUom));
    }
    if (lineItemsSellingUnitUnits !== undefined) {
      queryParams.append('LineItems|SellingUnit|Units', String(lineItemsSellingUnitUnits));
    }
    if (lineItemsQuantityUom !== undefined) {
      queryParams.append('LineItems|Quantity|UOM', String(lineItemsQuantityUom));
    }
    if (lineItemsQuantityUnits !== undefined) {
      queryParams.append('LineItems|Quantity|Units', String(lineItemsQuantityUnits));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeRoomSelection(formName: string, installationTypeId?: string | null, productType?: string | null, patternTypeId?: string | null, trimWorkId?: string | null, underlaymentId?: string | null, catalogFeedId?: string | null, itemId?: string | null, styleNumber?: string | null, bin?: string | null, projectExternalId?: string | null, roomIds?: string[] | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, wasteFactor?: number | null, binId?: string | null, sessionKey?: string | null, hash?: string | null, hasWarnings?: boolean | null, totalCost?: number | null, totalPrice?: number | null, totalTax?: number | null, flowId?: string | null, isActive?: boolean | null, objectStatusId?: string | null, areaUom?: string | null, areaUnits?: number | null, mainProductQuantityUom?: string | null, mainProductQuantityUnits?: number | null, perimeterUom?: string | null, perimeterUnits?: number | null, lineItemsCriteria?: string | null, lineItemsItemId?: string | null, lineItemsMargin?: number | null, lineItemsSku?: string | null, lineItemsSource?: string | null, lineItemsTotalCost?: number | null, lineItemsTotalPrice?: number | null, lineItemsUnitCost?: number | null, lineItemsUnitPrice?: number | null, lineItemsWasteFactor?: number | null, lineItemsActualWasteFactor?: number | null, lineItemsWarnings?: string[] | null, lineItemsTags?: string[] | null, lineItemsDescription?: string | null, lineItemsName?: string | null, lineItemsCostsLocationId?: string | null, lineItemsCostsMinimumQuantity?: number | null, lineItemsCostsPackageCondition?: string | null, lineItemsCostsPriceCriteria?: string | null, lineItemsCostsPromotion?: string | null, lineItemsCostsUom?: string | null, lineItemsCostsUnitCost?: number | null, lineItemsCostsDroppedDate?: string | null, lineItemsCostsEffectiveDate?: string | null, lineItemsCostsPendingDate?: string | null, lineItemsCostsPromotionalEnd?: string | null, lineItemsCostsPromotionalStart?: string | null, lineItemsAdjustedQuantityUom?: string | null, lineItemsAdjustedQuantityUnits?: number | null, lineItemsChildrenDescription?: string | null, lineItemsChildrenName?: string | null, lineItemsChildrenQuantityUom?: string | null, lineItemsChildrenQuantityUnits?: number | null, lineItemsCostLocationId?: string | null, lineItemsCostMinimumQuantity?: number | null, lineItemsCostPackageCondition?: string | null, lineItemsCostPriceCriteria?: string | null, lineItemsCostPromotion?: string | null, lineItemsCostUom?: string | null, lineItemsCostUnitCost?: number | null, lineItemsCostDroppedDate?: string | null, lineItemsCostEffectiveDate?: string | null, lineItemsCostPendingDate?: string | null, lineItemsCostPromotionalEnd?: string | null, lineItemsCostPromotionalStart?: string | null, lineItemsSellingUnitUom?: string | null, lineItemsSellingUnitUnits?: number | null, lineItemsQuantityUom?: string | null, lineItemsQuantityUnits?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.RoomSelection/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (installationTypeId !== undefined) {
      queryParams.append('InstallationTypeId', String(installationTypeId));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (patternTypeId !== undefined) {
      queryParams.append('PatternTypeId', String(patternTypeId));
    }
    if (trimWorkId !== undefined) {
      queryParams.append('TrimWorkId', String(trimWorkId));
    }
    if (underlaymentId !== undefined) {
      queryParams.append('UnderlaymentId', String(underlaymentId));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (itemId !== undefined) {
      queryParams.append('ItemId', String(itemId));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (bin !== undefined) {
      queryParams.append('Bin', String(bin));
    }
    if (projectExternalId !== undefined) {
      queryParams.append('ProjectExternalId', String(projectExternalId));
    }
    if (roomIds !== undefined) {
      queryParams.append('RoomIds', String(roomIds));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (wasteFactor !== undefined) {
      queryParams.append('WasteFactor', String(wasteFactor));
    }
    if (binId !== undefined) {
      queryParams.append('BinId', String(binId));
    }
    if (sessionKey !== undefined) {
      queryParams.append('SessionKey', String(sessionKey));
    }
    if (hash !== undefined) {
      queryParams.append('Hash', String(hash));
    }
    if (hasWarnings !== undefined) {
      queryParams.append('HasWarnings', String(hasWarnings));
    }
    if (totalCost !== undefined) {
      queryParams.append('TotalCost', String(totalCost));
    }
    if (totalPrice !== undefined) {
      queryParams.append('TotalPrice', String(totalPrice));
    }
    if (totalTax !== undefined) {
      queryParams.append('TotalTax', String(totalTax));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (areaUom !== undefined) {
      queryParams.append('Area|UOM', String(areaUom));
    }
    if (areaUnits !== undefined) {
      queryParams.append('Area|Units', String(areaUnits));
    }
    if (mainProductQuantityUom !== undefined) {
      queryParams.append('MainProductQuantity|UOM', String(mainProductQuantityUom));
    }
    if (mainProductQuantityUnits !== undefined) {
      queryParams.append('MainProductQuantity|Units', String(mainProductQuantityUnits));
    }
    if (perimeterUom !== undefined) {
      queryParams.append('Perimeter|UOM', String(perimeterUom));
    }
    if (perimeterUnits !== undefined) {
      queryParams.append('Perimeter|Units', String(perimeterUnits));
    }
    if (lineItemsCriteria !== undefined) {
      queryParams.append('LineItems|Criteria', String(lineItemsCriteria));
    }
    if (lineItemsItemId !== undefined) {
      queryParams.append('LineItems|ItemId', String(lineItemsItemId));
    }
    if (lineItemsMargin !== undefined) {
      queryParams.append('LineItems|Margin', String(lineItemsMargin));
    }
    if (lineItemsSku !== undefined) {
      queryParams.append('LineItems|SKU', String(lineItemsSku));
    }
    if (lineItemsSource !== undefined) {
      queryParams.append('LineItems|Source', String(lineItemsSource));
    }
    if (lineItemsTotalCost !== undefined) {
      queryParams.append('LineItems|TotalCost', String(lineItemsTotalCost));
    }
    if (lineItemsTotalPrice !== undefined) {
      queryParams.append('LineItems|TotalPrice', String(lineItemsTotalPrice));
    }
    if (lineItemsUnitCost !== undefined) {
      queryParams.append('LineItems|UnitCost', String(lineItemsUnitCost));
    }
    if (lineItemsUnitPrice !== undefined) {
      queryParams.append('LineItems|UnitPrice', String(lineItemsUnitPrice));
    }
    if (lineItemsWasteFactor !== undefined) {
      queryParams.append('LineItems|WasteFactor', String(lineItemsWasteFactor));
    }
    if (lineItemsActualWasteFactor !== undefined) {
      queryParams.append('LineItems|ActualWasteFactor', String(lineItemsActualWasteFactor));
    }
    if (lineItemsWarnings !== undefined) {
      queryParams.append('LineItems|Warnings', String(lineItemsWarnings));
    }
    if (lineItemsTags !== undefined) {
      queryParams.append('LineItems|Tags', String(lineItemsTags));
    }
    if (lineItemsDescription !== undefined) {
      queryParams.append('LineItems|Description', String(lineItemsDescription));
    }
    if (lineItemsName !== undefined) {
      queryParams.append('LineItems|Name', String(lineItemsName));
    }
    if (lineItemsCostsLocationId !== undefined) {
      queryParams.append('LineItems|Costs|LocationId', String(lineItemsCostsLocationId));
    }
    if (lineItemsCostsMinimumQuantity !== undefined) {
      queryParams.append('LineItems|Costs|MinimumQuantity', String(lineItemsCostsMinimumQuantity));
    }
    if (lineItemsCostsPackageCondition !== undefined) {
      queryParams.append('LineItems|Costs|PackageCondition', String(lineItemsCostsPackageCondition));
    }
    if (lineItemsCostsPriceCriteria !== undefined) {
      queryParams.append('LineItems|Costs|PriceCriteria', String(lineItemsCostsPriceCriteria));
    }
    if (lineItemsCostsPromotion !== undefined) {
      queryParams.append('LineItems|Costs|Promotion', String(lineItemsCostsPromotion));
    }
    if (lineItemsCostsUom !== undefined) {
      queryParams.append('LineItems|Costs|UOM', String(lineItemsCostsUom));
    }
    if (lineItemsCostsUnitCost !== undefined) {
      queryParams.append('LineItems|Costs|UnitCost', String(lineItemsCostsUnitCost));
    }
    if (lineItemsCostsDroppedDate !== undefined) {
      queryParams.append('LineItems|Costs|DroppedDate', String(lineItemsCostsDroppedDate));
    }
    if (lineItemsCostsEffectiveDate !== undefined) {
      queryParams.append('LineItems|Costs|EffectiveDate', String(lineItemsCostsEffectiveDate));
    }
    if (lineItemsCostsPendingDate !== undefined) {
      queryParams.append('LineItems|Costs|PendingDate', String(lineItemsCostsPendingDate));
    }
    if (lineItemsCostsPromotionalEnd !== undefined) {
      queryParams.append('LineItems|Costs|PromotionalEnd', String(lineItemsCostsPromotionalEnd));
    }
    if (lineItemsCostsPromotionalStart !== undefined) {
      queryParams.append('LineItems|Costs|PromotionalStart', String(lineItemsCostsPromotionalStart));
    }
    if (lineItemsAdjustedQuantityUom !== undefined) {
      queryParams.append('LineItems|AdjustedQuantity|UOM', String(lineItemsAdjustedQuantityUom));
    }
    if (lineItemsAdjustedQuantityUnits !== undefined) {
      queryParams.append('LineItems|AdjustedQuantity|Units', String(lineItemsAdjustedQuantityUnits));
    }
    if (lineItemsChildrenDescription !== undefined) {
      queryParams.append('LineItems|Children|Description', String(lineItemsChildrenDescription));
    }
    if (lineItemsChildrenName !== undefined) {
      queryParams.append('LineItems|Children|Name', String(lineItemsChildrenName));
    }
    if (lineItemsChildrenQuantityUom !== undefined) {
      queryParams.append('LineItems|Children|Quantity|UOM', String(lineItemsChildrenQuantityUom));
    }
    if (lineItemsChildrenQuantityUnits !== undefined) {
      queryParams.append('LineItems|Children|Quantity|Units', String(lineItemsChildrenQuantityUnits));
    }
    if (lineItemsCostLocationId !== undefined) {
      queryParams.append('LineItems|Cost|LocationId', String(lineItemsCostLocationId));
    }
    if (lineItemsCostMinimumQuantity !== undefined) {
      queryParams.append('LineItems|Cost|MinimumQuantity', String(lineItemsCostMinimumQuantity));
    }
    if (lineItemsCostPackageCondition !== undefined) {
      queryParams.append('LineItems|Cost|PackageCondition', String(lineItemsCostPackageCondition));
    }
    if (lineItemsCostPriceCriteria !== undefined) {
      queryParams.append('LineItems|Cost|PriceCriteria', String(lineItemsCostPriceCriteria));
    }
    if (lineItemsCostPromotion !== undefined) {
      queryParams.append('LineItems|Cost|Promotion', String(lineItemsCostPromotion));
    }
    if (lineItemsCostUom !== undefined) {
      queryParams.append('LineItems|Cost|UOM', String(lineItemsCostUom));
    }
    if (lineItemsCostUnitCost !== undefined) {
      queryParams.append('LineItems|Cost|UnitCost', String(lineItemsCostUnitCost));
    }
    if (lineItemsCostDroppedDate !== undefined) {
      queryParams.append('LineItems|Cost|DroppedDate', String(lineItemsCostDroppedDate));
    }
    if (lineItemsCostEffectiveDate !== undefined) {
      queryParams.append('LineItems|Cost|EffectiveDate', String(lineItemsCostEffectiveDate));
    }
    if (lineItemsCostPendingDate !== undefined) {
      queryParams.append('LineItems|Cost|PendingDate', String(lineItemsCostPendingDate));
    }
    if (lineItemsCostPromotionalEnd !== undefined) {
      queryParams.append('LineItems|Cost|PromotionalEnd', String(lineItemsCostPromotionalEnd));
    }
    if (lineItemsCostPromotionalStart !== undefined) {
      queryParams.append('LineItems|Cost|PromotionalStart', String(lineItemsCostPromotionalStart));
    }
    if (lineItemsSellingUnitUom !== undefined) {
      queryParams.append('LineItems|SellingUnit|UOM', String(lineItemsSellingUnitUom));
    }
    if (lineItemsSellingUnitUnits !== undefined) {
      queryParams.append('LineItems|SellingUnit|Units', String(lineItemsSellingUnitUnits));
    }
    if (lineItemsQuantityUom !== undefined) {
      queryParams.append('LineItems|Quantity|UOM', String(lineItemsQuantityUom));
    }
    if (lineItemsQuantityUnits !== undefined) {
      queryParams.append('LineItems|Quantity|Units', String(lineItemsQuantityUnits));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterRoomSelection(request?: FilterRoomSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<RoomSelection[]> {
    const path = '/app/api/Object/otg.RoomSelection/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRoomSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => RoomSelectionSerializer.fromObject(item));
  }

  async createRoomSelection(request?: CreateRoomSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.RoomSelection';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateRoomSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateRoomSelection(objectId: string, request?: UpdateRoomSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.RoomSelection({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateRoomSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentRoomSelection(request?: FilterRoomSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<RoomSelection[]> {
    const path = '/app/api/Object/otg.RoomSelection/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRoomSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => RoomSelectionSerializer.fromObject(item));
  }

  async dataViewRoomSelection(request?: FilterRoomSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewRoomSelectionResponse> {
    const path = '/app/api/Object/otg.RoomSelection/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRoomSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewRoomSelectionResponseSerializer.fromObject(data);
  }

  async getFormForObjectTask(formName: string, objectId: string, assignedUserId?: string | null, dueDate?: string | null, priority?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, parentObjectType?: string | null, parentObjectId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Task({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (assignedUserId !== undefined) {
      queryParams.append('AssignedUserId', String(assignedUserId));
    }
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (priority !== undefined) {
      queryParams.append('Priority', String(priority));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeObjectTask(formName: string, assignedUserId?: string | null, dueDate?: string | null, priority?: string | null, name?: string | null, description?: string | null, flowId?: string | null, objectStatusId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, content?: string | null, contentType?: string | null, creatorId?: string | null, entityId?: string | null, isActive?: boolean | null, relatedObjects?: Record<string, string> | null, parentObjectType?: string | null, parentObjectId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.Task/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (assignedUserId !== undefined) {
      queryParams.append('AssignedUserId', String(assignedUserId));
    }
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (priority !== undefined) {
      queryParams.append('Priority', String(priority));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (creatorId !== undefined) {
      queryParams.append('CreatorId', String(creatorId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterObjectTask(request?: FilterObjectTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<ObjectTask[]> {
    const path = '/app/api/Object/otg.Task/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ObjectTaskSerializer.fromObject(item));
  }

  async createObjectTask(request?: CreateObjectTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/otg.Task';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateObjectTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateObjectTask(objectId: string, request?: UpdateObjectTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.Task({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateObjectTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deleteObjectTask(objectId: string, fields?: ObjectTaskFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<ObjectTask> {
    let path = '/app/api/Object/otg.Task({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return ObjectTaskSerializer.fromObject(data);
  }

  async recentObjectTask(request?: FilterObjectTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<ObjectTask[]> {
    const path = '/app/api/Object/otg.Task/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ObjectTaskSerializer.fromObject(item));
  }

  async dataViewObjectTask(request?: FilterObjectTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewObjectTaskResponse> {
    const path = '/app/api/Object/otg.Task/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewObjectTaskResponseSerializer.fromObject(data);
  }

  async getOtgUserCreateFileForm(objectId: string, fileName?: string | null, contentType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.User({objectId})/UserAction(b1579ee4-a94c-44ed-9a9a-805d43592ef2)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fileName !== undefined) {
      queryParams.append('FileName', String(fileName));
    }
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runOtgUserCreateFileAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.User({objectId})/UserAction(b1579ee4-a94c-44ed-9a9a-805d43592ef2)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startOtgUserCreateFile(objectId: string, request?: StartOtgUserCreateFileRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/otg.User({objectId})/UserAction(b1579ee4-a94c-44ed-9a9a-805d43592ef2)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartOtgUserCreateFileRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForotgUser(formName: string, objectId: string, organizationId?: string | null, name?: string | null, userRoleId?: string | null, objectStatusId?: string | null, description?: string | null, id?: string | null, t?: string | null, email?: string | null, phone?: string | null, timeZoneId?: string | null, isActive?: boolean | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.User({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (organizationId !== undefined) {
      queryParams.append('OrganizationId', String(organizationId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (userRoleId !== undefined) {
      queryParams.append('UserRoleId', String(userRoleId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (email !== undefined) {
      queryParams.append('Email', String(email));
    }
    if (phone !== undefined) {
      queryParams.append('Phone', String(phone));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeotgUser(formName: string, organizationId?: string | null, name?: string | null, userRoleId?: string | null, objectStatusId?: string | null, description?: string | null, id?: string | null, t?: string | null, email?: string | null, phone?: string | null, timeZoneId?: string | null, isActive?: boolean | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.User/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (organizationId !== undefined) {
      queryParams.append('OrganizationId', String(organizationId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (userRoleId !== undefined) {
      queryParams.append('UserRoleId', String(userRoleId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    if (email !== undefined) {
      queryParams.append('Email', String(email));
    }
    if (phone !== undefined) {
      queryParams.append('Phone', String(phone));
    }
    if (timeZoneId !== undefined) {
      queryParams.append('TimeZoneId', String(timeZoneId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterOtgUser(request?: FilterOtgUserRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgUser[]> {
    const path = '/app/api/Object/otg.User/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgUserRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgUserSerializer.fromObject(item));
  }

  async recentOtgUser(request?: FilterOtgUserRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgUser[]> {
    const path = '/app/api/Object/otg.User/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgUserRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgUserSerializer.fromObject(item));
  }

  async dataViewOtgUser(request?: FilterOtgUserRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewOtgUserResponse> {
    const path = '/app/api/Object/otg.User/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgUserRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewOtgUserResponseSerializer.fromObject(data);
  }

  async getFormForVinylCatalogItem(formName: string, objectId: string, propertiesInstallationMethod?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesThickness?: string | null, propertiesWearLayer?: string | null, propertiesWidth?: string | null, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCarpetType?: string | null, propertiesCollectionName?: string | null, propertiesColorType?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesFiber?: string | null, propertiesLaminatesType?: string | null, propertiesLinks?: string | null, propertiesPatternMatch?: string | null, propertiesPlankLength?: string | null, propertiesPriceGroup?: number | null, propertiesStainResistanceRating?: number | null, propertiesStyleName?: string | null, propertiesTexture?: string | null, propertiesVendor?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.VinylCatalogItem({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeVinylCatalogItem(formName: string, propertiesInstallationMethod?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesThickness?: string | null, propertiesWearLayer?: string | null, propertiesWidth?: string | null, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCarpetType?: string | null, propertiesCollectionName?: string | null, propertiesColorType?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesFiber?: string | null, propertiesLaminatesType?: string | null, propertiesLinks?: string | null, propertiesPatternMatch?: string | null, propertiesPlankLength?: string | null, propertiesPriceGroup?: number | null, propertiesStainResistanceRating?: number | null, propertiesStyleName?: string | null, propertiesTexture?: string | null, propertiesVendor?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.VinylCatalogItem/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterVinylCatalogItem(request?: FilterVinylCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<VinylCatalogItem[]> {
    const path = '/app/api/Object/otg.VinylCatalogItem/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterVinylCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => VinylCatalogItemSerializer.fromObject(item));
  }

  async recentVinylCatalogItem(request?: FilterVinylCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<VinylCatalogItem[]> {
    const path = '/app/api/Object/otg.VinylCatalogItem/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterVinylCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => VinylCatalogItemSerializer.fromObject(item));
  }

  async dataViewVinylCatalogItem(request?: FilterVinylCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewVinylCatalogItemResponse> {
    const path = '/app/api/Object/otg.VinylCatalogItem/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterVinylCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewVinylCatalogItemResponseSerializer.fromObject(data);
  }

  async getFormForotgVinylCatalogStyle(formName: string, objectId: string, propertiesInstallationMethod?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesThickness?: string | null, propertiesWearLayer?: string | null, propertiesWidth?: string | null, externalId?: string | null, name?: string | null, description?: string | null, materialType?: string | null, propertiesLinks?: string | null, propertiesCollectionName?: string | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesDemo?: string | null, propertiesPatternMatch?: string | null, propertiesFiber?: string | null, propertiesDurabilityRating?: number | null, propertiesStainResistanceRating?: number | null, propertiesPriceGroup?: number | null, propertiesCompetitionCrushers?: boolean | null, costRange?: string | null, tags?: string[] | null, id?: string | null, isActive?: boolean | null, catalogFeedId?: string | null, parentsManufacturer?: string | null, count?: number | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, propertiesLaminatesType?: string | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.VinylCatalogStyle({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (costRange !== undefined) {
      queryParams.append('CostRange', String(costRange));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeotgVinylCatalogStyle(formName: string, propertiesInstallationMethod?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesThickness?: string | null, propertiesWearLayer?: string | null, propertiesWidth?: string | null, externalId?: string | null, name?: string | null, description?: string | null, materialType?: string | null, propertiesLinks?: string | null, propertiesCollectionName?: string | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesDemo?: string | null, propertiesPatternMatch?: string | null, propertiesFiber?: string | null, propertiesDurabilityRating?: number | null, propertiesStainResistanceRating?: number | null, propertiesPriceGroup?: number | null, propertiesCompetitionCrushers?: boolean | null, costRange?: string | null, tags?: string[] | null, id?: string | null, isActive?: boolean | null, catalogFeedId?: string | null, parentsManufacturer?: string | null, count?: number | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, propertiesLaminatesType?: string | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.VinylCatalogStyle/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (costRange !== undefined) {
      queryParams.append('CostRange', String(costRange));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterOtgVinylCatalogStyle(request?: FilterOtgVinylCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgVinylCatalogStyle[]> {
    const path = '/app/api/Object/otg.VinylCatalogStyle/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgVinylCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgVinylCatalogStyleSerializer.fromObject(item));
  }

  async recentOtgVinylCatalogStyle(request?: FilterOtgVinylCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgVinylCatalogStyle[]> {
    const path = '/app/api/Object/otg.VinylCatalogStyle/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgVinylCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgVinylCatalogStyleSerializer.fromObject(item));
  }

  async dataViewOtgVinylCatalogStyle(request?: FilterOtgVinylCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewOtgVinylCatalogStyleResponse> {
    const path = '/app/api/Object/otg.VinylCatalogStyle/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgVinylCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewOtgVinylCatalogStyleResponseSerializer.fromObject(data);
  }

  async getFormForWoodCatalogItem(formName: string, objectId: string, propertiesWidth?: string | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCarpetType?: string | null, propertiesCollectionName?: string | null, propertiesColorType?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesFiber?: string | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesLinks?: string | null, propertiesPatternMatch?: string | null, propertiesPriceGroup?: number | null, propertiesResilientType?: string | null, propertiesStainResistanceRating?: number | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesWearLayer?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.WoodCatalogItem({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeWoodCatalogItem(formName: string, propertiesWidth?: string | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, id?: string | null, abbreviatedProductName?: string | null, backing?: string | null, buyingGroup?: string | null, catalogFeedId?: string | null, collectionName?: string | null, colorName?: string | null, colorNumber?: string | null, composition?: string | null, contract?: string | null, description?: string | null, isActive?: boolean | null, name?: string | null, entityId?: string | null, gauge?: string | null, manufacturer?: string | null, manufacturerSku?: string | null, manufacturerStyleName?: string | null, manufacturerStyleNumber?: string | null, materialSubType?: string | null, materialType?: string | null, pricingGroup?: string | null, primaryComponent?: string | null, productSpecification?: string | null, productType?: string | null, sellingCompany?: string | null, sizeCode?: string | null, sku?: string | null, styleName?: string | null, styleNumber?: string | null, uniqueColorCode?: string | null, upcCode?: string | null, parentsManufacturer?: string | null, propertiesCarpetType?: string | null, propertiesCollectionName?: string | null, propertiesColorType?: string | null, propertiesCompetitionCrushers?: boolean | null, propertiesDemo?: string | null, propertiesDurabilityRating?: number | null, propertiesFiber?: string | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesLinks?: string | null, propertiesPatternMatch?: string | null, propertiesPriceGroup?: number | null, propertiesResilientType?: string | null, propertiesStainResistanceRating?: number | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesWearLayer?: string | null, tags?: string[] | null, sellingUnitUom?: string | null, sellingUnitUnits?: number | null, standardPrice?: number | null, palletPrice?: number | null, cutPrice?: number | null, effectiveDate?: string | null, pendingDate?: string | null, droppedDate?: string | null, promotionalStart?: string | null, promotionalEnd?: string | null, margin?: number | null, rollLength?: number | null, rollWidth?: number | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, patternRepeatUom?: string | null, patternRepeatUnits?: number | null, patternDropUom?: string | null, patternDropUnits?: number | null, patternLengthUom?: string | null, patternLengthUnits?: number | null, patternWidthUom?: string | null, patternWidthUnits?: number | null, nominalLengthUom?: string | null, nominalLengthUnits?: number | null, actualLengthUom?: string | null, actualLengthUnits?: number | null, nominalWidthUom?: string | null, nominalWidthUnits?: number | null, actualWidthUom?: string | null, actualWidthUnits?: number | null, heightUom?: string | null, heightUnits?: number | null, faceWeightUom?: string | null, faceWeightUnits?: number | null, costsLocationId?: string | null, costsMinimumQuantity?: number | null, costsPackageCondition?: string | null, costsPriceCriteria?: string | null, costsPromotion?: string | null, costsUom?: string | null, costsUnitCost?: number | null, costsDroppedDate?: string | null, costsEffectiveDate?: string | null, costsPendingDate?: string | null, costsPromotionalEnd?: string | null, costsPromotionalStart?: string | null, packagingUom?: string | null, packagingMeasurementUom?: string | null, packagingMeasurementUnits?: number | null, shippingWeightUom?: string | null, shippingWeightMeasurementUom?: string | null, shippingWeightMeasurementUnits?: number | null, pricesLocationId?: string | null, pricesMinimumQuantity?: number | null, pricesPackageCondition?: string | null, pricesPriceCriteria?: string | null, pricesPromotion?: string | null, pricesUom?: string | null, pricesUnitCost?: number | null, pricesDroppedDate?: string | null, pricesEffectiveDate?: string | null, pricesPendingDate?: string | null, pricesPromotionalEnd?: string | null, pricesPromotionalStart?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.WoodCatalogItem/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (abbreviatedProductName !== undefined) {
      queryParams.append('AbbreviatedProductName', String(abbreviatedProductName));
    }
    if (backing !== undefined) {
      queryParams.append('Backing', String(backing));
    }
    if (buyingGroup !== undefined) {
      queryParams.append('BuyingGroup', String(buyingGroup));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (collectionName !== undefined) {
      queryParams.append('CollectionName', String(collectionName));
    }
    if (colorName !== undefined) {
      queryParams.append('ColorName', String(colorName));
    }
    if (colorNumber !== undefined) {
      queryParams.append('ColorNumber', String(colorNumber));
    }
    if (composition !== undefined) {
      queryParams.append('Composition', String(composition));
    }
    if (contract !== undefined) {
      queryParams.append('Contract', String(contract));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (gauge !== undefined) {
      queryParams.append('Gauge', String(gauge));
    }
    if (manufacturer !== undefined) {
      queryParams.append('Manufacturer', String(manufacturer));
    }
    if (manufacturerSku !== undefined) {
      queryParams.append('ManufacturerSKU', String(manufacturerSku));
    }
    if (manufacturerStyleName !== undefined) {
      queryParams.append('ManufacturerStyleName', String(manufacturerStyleName));
    }
    if (manufacturerStyleNumber !== undefined) {
      queryParams.append('ManufacturerStyleNumber', String(manufacturerStyleNumber));
    }
    if (materialSubType !== undefined) {
      queryParams.append('Material|SubType', String(materialSubType));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (pricingGroup !== undefined) {
      queryParams.append('PricingGroup', String(pricingGroup));
    }
    if (primaryComponent !== undefined) {
      queryParams.append('PrimaryComponent', String(primaryComponent));
    }
    if (productSpecification !== undefined) {
      queryParams.append('ProductSpecification', String(productSpecification));
    }
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (sellingCompany !== undefined) {
      queryParams.append('SellingCompany', String(sellingCompany));
    }
    if (sizeCode !== undefined) {
      queryParams.append('SizeCode', String(sizeCode));
    }
    if (sku !== undefined) {
      queryParams.append('SKU', String(sku));
    }
    if (styleName !== undefined) {
      queryParams.append('StyleName', String(styleName));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (uniqueColorCode !== undefined) {
      queryParams.append('UniqueColorCode', String(uniqueColorCode));
    }
    if (upcCode !== undefined) {
      queryParams.append('UPCCode', String(upcCode));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (sellingUnitUom !== undefined) {
      queryParams.append('SellingUnit|UOM', String(sellingUnitUom));
    }
    if (sellingUnitUnits !== undefined) {
      queryParams.append('SellingUnit|Units', String(sellingUnitUnits));
    }
    if (standardPrice !== undefined) {
      queryParams.append('StandardPrice', String(standardPrice));
    }
    if (palletPrice !== undefined) {
      queryParams.append('PalletPrice', String(palletPrice));
    }
    if (cutPrice !== undefined) {
      queryParams.append('CutPrice', String(cutPrice));
    }
    if (effectiveDate !== undefined) {
      queryParams.append('EffectiveDate', String(effectiveDate));
    }
    if (pendingDate !== undefined) {
      queryParams.append('PendingDate', String(pendingDate));
    }
    if (droppedDate !== undefined) {
      queryParams.append('DroppedDate', String(droppedDate));
    }
    if (promotionalStart !== undefined) {
      queryParams.append('PromotionalStart', String(promotionalStart));
    }
    if (promotionalEnd !== undefined) {
      queryParams.append('PromotionalEnd', String(promotionalEnd));
    }
    if (margin !== undefined) {
      queryParams.append('Margin', String(margin));
    }
    if (rollLength !== undefined) {
      queryParams.append('RollLength', String(rollLength));
    }
    if (rollWidth !== undefined) {
      queryParams.append('RollWidth', String(rollWidth));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    if (patternRepeatUom !== undefined) {
      queryParams.append('PatternRepeat|UOM', String(patternRepeatUom));
    }
    if (patternRepeatUnits !== undefined) {
      queryParams.append('PatternRepeat|Units', String(patternRepeatUnits));
    }
    if (patternDropUom !== undefined) {
      queryParams.append('PatternDrop|UOM', String(patternDropUom));
    }
    if (patternDropUnits !== undefined) {
      queryParams.append('PatternDrop|Units', String(patternDropUnits));
    }
    if (patternLengthUom !== undefined) {
      queryParams.append('PatternLength|UOM', String(patternLengthUom));
    }
    if (patternLengthUnits !== undefined) {
      queryParams.append('PatternLength|Units', String(patternLengthUnits));
    }
    if (patternWidthUom !== undefined) {
      queryParams.append('PatternWidth|UOM', String(patternWidthUom));
    }
    if (patternWidthUnits !== undefined) {
      queryParams.append('PatternWidth|Units', String(patternWidthUnits));
    }
    if (nominalLengthUom !== undefined) {
      queryParams.append('NominalLength|UOM', String(nominalLengthUom));
    }
    if (nominalLengthUnits !== undefined) {
      queryParams.append('NominalLength|Units', String(nominalLengthUnits));
    }
    if (actualLengthUom !== undefined) {
      queryParams.append('ActualLength|UOM', String(actualLengthUom));
    }
    if (actualLengthUnits !== undefined) {
      queryParams.append('ActualLength|Units', String(actualLengthUnits));
    }
    if (nominalWidthUom !== undefined) {
      queryParams.append('NominalWidth|UOM', String(nominalWidthUom));
    }
    if (nominalWidthUnits !== undefined) {
      queryParams.append('NominalWidth|Units', String(nominalWidthUnits));
    }
    if (actualWidthUom !== undefined) {
      queryParams.append('ActualWidth|UOM', String(actualWidthUom));
    }
    if (actualWidthUnits !== undefined) {
      queryParams.append('ActualWidth|Units', String(actualWidthUnits));
    }
    if (heightUom !== undefined) {
      queryParams.append('Height|UOM', String(heightUom));
    }
    if (heightUnits !== undefined) {
      queryParams.append('Height|Units', String(heightUnits));
    }
    if (faceWeightUom !== undefined) {
      queryParams.append('FaceWeight|UOM', String(faceWeightUom));
    }
    if (faceWeightUnits !== undefined) {
      queryParams.append('FaceWeight|Units', String(faceWeightUnits));
    }
    if (costsLocationId !== undefined) {
      queryParams.append('Costs|LocationId', String(costsLocationId));
    }
    if (costsMinimumQuantity !== undefined) {
      queryParams.append('Costs|MinimumQuantity', String(costsMinimumQuantity));
    }
    if (costsPackageCondition !== undefined) {
      queryParams.append('Costs|PackageCondition', String(costsPackageCondition));
    }
    if (costsPriceCriteria !== undefined) {
      queryParams.append('Costs|PriceCriteria', String(costsPriceCriteria));
    }
    if (costsPromotion !== undefined) {
      queryParams.append('Costs|Promotion', String(costsPromotion));
    }
    if (costsUom !== undefined) {
      queryParams.append('Costs|UOM', String(costsUom));
    }
    if (costsUnitCost !== undefined) {
      queryParams.append('Costs|UnitCost', String(costsUnitCost));
    }
    if (costsDroppedDate !== undefined) {
      queryParams.append('Costs|DroppedDate', String(costsDroppedDate));
    }
    if (costsEffectiveDate !== undefined) {
      queryParams.append('Costs|EffectiveDate', String(costsEffectiveDate));
    }
    if (costsPendingDate !== undefined) {
      queryParams.append('Costs|PendingDate', String(costsPendingDate));
    }
    if (costsPromotionalEnd !== undefined) {
      queryParams.append('Costs|PromotionalEnd', String(costsPromotionalEnd));
    }
    if (costsPromotionalStart !== undefined) {
      queryParams.append('Costs|PromotionalStart', String(costsPromotionalStart));
    }
    if (packagingUom !== undefined) {
      queryParams.append('Packaging|UOM', String(packagingUom));
    }
    if (packagingMeasurementUom !== undefined) {
      queryParams.append('Packaging|Measurement|UOM', String(packagingMeasurementUom));
    }
    if (packagingMeasurementUnits !== undefined) {
      queryParams.append('Packaging|Measurement|Units', String(packagingMeasurementUnits));
    }
    if (shippingWeightUom !== undefined) {
      queryParams.append('ShippingWeight|UOM', String(shippingWeightUom));
    }
    if (shippingWeightMeasurementUom !== undefined) {
      queryParams.append('ShippingWeight|Measurement|UOM', String(shippingWeightMeasurementUom));
    }
    if (shippingWeightMeasurementUnits !== undefined) {
      queryParams.append('ShippingWeight|Measurement|Units', String(shippingWeightMeasurementUnits));
    }
    if (pricesLocationId !== undefined) {
      queryParams.append('Prices|LocationId', String(pricesLocationId));
    }
    if (pricesMinimumQuantity !== undefined) {
      queryParams.append('Prices|MinimumQuantity', String(pricesMinimumQuantity));
    }
    if (pricesPackageCondition !== undefined) {
      queryParams.append('Prices|PackageCondition', String(pricesPackageCondition));
    }
    if (pricesPriceCriteria !== undefined) {
      queryParams.append('Prices|PriceCriteria', String(pricesPriceCriteria));
    }
    if (pricesPromotion !== undefined) {
      queryParams.append('Prices|Promotion', String(pricesPromotion));
    }
    if (pricesUom !== undefined) {
      queryParams.append('Prices|UOM', String(pricesUom));
    }
    if (pricesUnitCost !== undefined) {
      queryParams.append('Prices|UnitCost', String(pricesUnitCost));
    }
    if (pricesDroppedDate !== undefined) {
      queryParams.append('Prices|DroppedDate', String(pricesDroppedDate));
    }
    if (pricesEffectiveDate !== undefined) {
      queryParams.append('Prices|EffectiveDate', String(pricesEffectiveDate));
    }
    if (pricesPendingDate !== undefined) {
      queryParams.append('Prices|PendingDate', String(pricesPendingDate));
    }
    if (pricesPromotionalEnd !== undefined) {
      queryParams.append('Prices|PromotionalEnd', String(pricesPromotionalEnd));
    }
    if (pricesPromotionalStart !== undefined) {
      queryParams.append('Prices|PromotionalStart', String(pricesPromotionalStart));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterWoodCatalogItem(request?: FilterWoodCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<WoodCatalogItem[]> {
    const path = '/app/api/Object/otg.WoodCatalogItem/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterWoodCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => WoodCatalogItemSerializer.fromObject(item));
  }

  async recentWoodCatalogItem(request?: FilterWoodCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<WoodCatalogItem[]> {
    const path = '/app/api/Object/otg.WoodCatalogItem/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterWoodCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => WoodCatalogItemSerializer.fromObject(item));
  }

  async dataViewWoodCatalogItem(request?: FilterWoodCatalogItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewWoodCatalogItemResponse> {
    const path = '/app/api/Object/otg.WoodCatalogItem/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterWoodCatalogItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewWoodCatalogItemResponseSerializer.fromObject(data);
  }

  async getFormForotgWoodCatalogStyle(formName: string, objectId: string, propertiesWidth?: string | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, externalId?: string | null, name?: string | null, description?: string | null, materialType?: string | null, propertiesLinks?: string | null, propertiesCollectionName?: string | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesDemo?: string | null, propertiesPatternMatch?: string | null, propertiesFiber?: string | null, propertiesDurabilityRating?: number | null, propertiesStainResistanceRating?: number | null, propertiesPriceGroup?: number | null, propertiesCompetitionCrushers?: boolean | null, costRange?: string | null, tags?: string[] | null, id?: string | null, isActive?: boolean | null, catalogFeedId?: string | null, parentsManufacturer?: string | null, count?: number | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesWearLayer?: string | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.WoodCatalogStyle({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (costRange !== undefined) {
      queryParams.append('CostRange', String(costRange));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeotgWoodCatalogStyle(formName: string, propertiesWidth?: string | null, propertiesPlankLength?: string | null, propertiesTexture?: string | null, propertiesThickness?: string | null, propertiesWoodSpecies?: string | null, propertiesWoodType?: string | null, externalId?: string | null, name?: string | null, description?: string | null, materialType?: string | null, propertiesLinks?: string | null, propertiesCollectionName?: string | null, propertiesStyleName?: string | null, propertiesVendor?: string | null, propertiesCarpetType?: string | null, propertiesColorType?: string | null, propertiesDemo?: string | null, propertiesPatternMatch?: string | null, propertiesFiber?: string | null, propertiesDurabilityRating?: number | null, propertiesStainResistanceRating?: number | null, propertiesPriceGroup?: number | null, propertiesCompetitionCrushers?: boolean | null, costRange?: string | null, tags?: string[] | null, id?: string | null, isActive?: boolean | null, catalogFeedId?: string | null, parentsManufacturer?: string | null, count?: number | null, propertiesInstallationMethod?: string | null, propertiesLaminatesType?: string | null, propertiesLength?: string | null, propertiesResilientType?: string | null, propertiesWearLayer?: string | null, seachMetaDataScore?: number | null, seachMetaDataHighlightsPath?: string | null, seachMetaDataHighlightsTextsType?: string | null, seachMetaDataHighlightsTextsValue?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/otg.WoodCatalogStyle/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (propertiesWidth !== undefined) {
      queryParams.append('Properties|Width', String(propertiesWidth));
    }
    if (propertiesPlankLength !== undefined) {
      queryParams.append('Properties|PlankLength', String(propertiesPlankLength));
    }
    if (propertiesTexture !== undefined) {
      queryParams.append('Properties|Texture', String(propertiesTexture));
    }
    if (propertiesThickness !== undefined) {
      queryParams.append('Properties|Thickness', String(propertiesThickness));
    }
    if (propertiesWoodSpecies !== undefined) {
      queryParams.append('Properties|WoodSpecies', String(propertiesWoodSpecies));
    }
    if (propertiesWoodType !== undefined) {
      queryParams.append('Properties|WoodType', String(propertiesWoodType));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (materialType !== undefined) {
      queryParams.append('Material|Type', String(materialType));
    }
    if (propertiesLinks !== undefined) {
      queryParams.append('Properties|Links', String(propertiesLinks));
    }
    if (propertiesCollectionName !== undefined) {
      queryParams.append('Properties|CollectionName', String(propertiesCollectionName));
    }
    if (propertiesStyleName !== undefined) {
      queryParams.append('Properties|StyleName', String(propertiesStyleName));
    }
    if (propertiesVendor !== undefined) {
      queryParams.append('Properties|Vendor', String(propertiesVendor));
    }
    if (propertiesCarpetType !== undefined) {
      queryParams.append('Properties|CarpetType', String(propertiesCarpetType));
    }
    if (propertiesColorType !== undefined) {
      queryParams.append('Properties|ColorType', String(propertiesColorType));
    }
    if (propertiesDemo !== undefined) {
      queryParams.append('Properties|Demo', String(propertiesDemo));
    }
    if (propertiesPatternMatch !== undefined) {
      queryParams.append('Properties|PatternMatch', String(propertiesPatternMatch));
    }
    if (propertiesFiber !== undefined) {
      queryParams.append('Properties|Fiber', String(propertiesFiber));
    }
    if (propertiesDurabilityRating !== undefined) {
      queryParams.append('Properties|DurabilityRating', String(propertiesDurabilityRating));
    }
    if (propertiesStainResistanceRating !== undefined) {
      queryParams.append('Properties|StainResistanceRating', String(propertiesStainResistanceRating));
    }
    if (propertiesPriceGroup !== undefined) {
      queryParams.append('Properties|PriceGroup', String(propertiesPriceGroup));
    }
    if (propertiesCompetitionCrushers !== undefined) {
      queryParams.append('Properties|CompetitionCrushers', String(propertiesCompetitionCrushers));
    }
    if (costRange !== undefined) {
      queryParams.append('CostRange', String(costRange));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (parentsManufacturer !== undefined) {
      queryParams.append('Parents|Manufacturer', String(parentsManufacturer));
    }
    if (count !== undefined) {
      queryParams.append('Count', String(count));
    }
    if (propertiesInstallationMethod !== undefined) {
      queryParams.append('Properties|InstallationMethod', String(propertiesInstallationMethod));
    }
    if (propertiesLaminatesType !== undefined) {
      queryParams.append('Properties|LaminatesType', String(propertiesLaminatesType));
    }
    if (propertiesLength !== undefined) {
      queryParams.append('Properties|Length', String(propertiesLength));
    }
    if (propertiesResilientType !== undefined) {
      queryParams.append('Properties|ResilientType', String(propertiesResilientType));
    }
    if (propertiesWearLayer !== undefined) {
      queryParams.append('Properties|WearLayer', String(propertiesWearLayer));
    }
    if (seachMetaDataScore !== undefined) {
      queryParams.append('SeachMetaData|Score', String(seachMetaDataScore));
    }
    if (seachMetaDataHighlightsPath !== undefined) {
      queryParams.append('SeachMetaData|Highlights|path', String(seachMetaDataHighlightsPath));
    }
    if (seachMetaDataHighlightsTextsType !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|type', String(seachMetaDataHighlightsTextsType));
    }
    if (seachMetaDataHighlightsTextsValue !== undefined) {
      queryParams.append('SeachMetaData|Highlights|texts|value', String(seachMetaDataHighlightsTextsValue));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterOtgWoodCatalogStyle(request?: FilterOtgWoodCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgWoodCatalogStyle[]> {
    const path = '/app/api/Object/otg.WoodCatalogStyle/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgWoodCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgWoodCatalogStyleSerializer.fromObject(item));
  }

  async recentOtgWoodCatalogStyle(request?: FilterOtgWoodCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<OtgWoodCatalogStyle[]> {
    const path = '/app/api/Object/otg.WoodCatalogStyle/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgWoodCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => OtgWoodCatalogStyleSerializer.fromObject(item));
  }

  async dataViewOtgWoodCatalogStyle(request?: FilterOtgWoodCatalogStyleRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewOtgWoodCatalogStyleResponse> {
    const path = '/app/api/Object/otg.WoodCatalogStyle/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterOtgWoodCatalogStyleRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewOtgWoodCatalogStyleResponseSerializer.fromObject(data);
  }

}
